var __defProp = Object.defineProperty;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var require_main = __commonJS({
  "main.js"(exports, module) {
    var _a, _b;
    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }
      return self;
    }
    function _inheritsLoose(subClass, superClass) {
      subClass.prototype = Object.create(superClass.prototype);
      subClass.prototype.constructor = subClass;
      subClass.__proto__ = superClass;
    }
    /*!
     * GSAP 3.13.0
     * https://gsap.com
     *
     * @license Copyright 2008-2025, GreenSock. All rights reserved.
     * Subject to the terms at https://gsap.com/standard-license
     * @author: Jack Doyle, jack@greensock.com
    */
    var _config = {
      autoSleep: 120,
      force3D: "auto",
      nullTargetWarn: 1,
      units: {
        lineHeight: ""
      }
    }, _defaults$1 = {
      duration: 0.5,
      overwrite: false,
      delay: 0
    }, _suppressOverwrites$1, _reverting$1, _context$2, _bigNum$2 = 1e8, _tinyNum = 1 / _bigNum$2, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt$1 = Math.sqrt, _cos$1 = Math.cos, _sin$1 = Math.sin, _isString$1 = function _isString2(value) {
      return typeof value === "string";
    }, _isFunction$1 = function _isFunction2(value) {
      return typeof value === "function";
    }, _isNumber$2 = function _isNumber2(value) {
      return typeof value === "number";
    }, _isUndefined = function _isUndefined2(value) {
      return typeof value === "undefined";
    }, _isObject$1 = function _isObject2(value) {
      return typeof value === "object";
    }, _isNotFalse = function _isNotFalse2(value) {
      return value !== false;
    }, _windowExists$2 = function _windowExists2() {
      return typeof window !== "undefined";
    }, _isFuncOrString = function _isFuncOrString2(value) {
      return _isFunction$1(value) || _isString$1(value);
    }, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {
    }, _isArray = Array.isArray, _strictNumExp = /(?:-?\.?\d|\.)+/gi, _numExp$1 = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, _numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, _relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, _unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win$4, _coreInitted$3, _doc$4, _globals = {}, _installScope = {}, _coreReady, _install = function _install2(scope) {
      return (_installScope = _merge(scope, _globals)) && gsap$4;
    }, _missingPlugin = function _missingPlugin2(property, value) {
      return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
    }, _warn = function _warn2(message, suppress) {
      return !suppress && console.warn(message);
    }, _addGlobal = function _addGlobal2(name, obj) {
      return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
    }, _emptyFunc = function _emptyFunc2() {
      return 0;
    }, _startAtRevertConfig = {
      suppressEvents: true,
      isStart: true,
      kill: false
    }, _revertConfigNoKill = {
      suppressEvents: true,
      kill: false
    }, _revertConfig = {
      suppressEvents: true
    }, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness2(targets) {
      var target = targets[0], harnessPlugin, i2;
      _isObject$1(target) || _isFunction$1(target) || (targets = [targets]);
      if (!(harnessPlugin = (target._gsap || {}).harness)) {
        i2 = _harnessPlugins.length;
        while (i2-- && !_harnessPlugins[i2].targetTest(target)) {
        }
        harnessPlugin = _harnessPlugins[i2];
      }
      i2 = targets.length;
      while (i2--) {
        targets[i2] && (targets[i2]._gsap || (targets[i2]._gsap = new GSCache(targets[i2], harnessPlugin))) || targets.splice(i2, 1);
      }
      return targets;
    }, _getCache = function _getCache2(target) {
      return target._gsap || _harness(toArray(target))[0]._gsap;
    }, _getProperty = function _getProperty2(target, property, v2) {
      return (v2 = target[property]) && _isFunction$1(v2) ? target[property]() : _isUndefined(v2) && target.getAttribute && target.getAttribute(property) || v2;
    }, _forEachName = function _forEachName2(names, func) {
      return (names = names.split(",")).forEach(func) || names;
    }, _round$4 = function _round2(value) {
      return Math.round(value * 1e5) / 1e5 || 0;
    }, _roundPrecise = function _roundPrecise2(value) {
      return Math.round(value * 1e7) / 1e7 || 0;
    }, _parseRelative = function _parseRelative2(start, value) {
      var operator = value.charAt(0), end = parseFloat(value.substr(2));
      start = parseFloat(start);
      return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
    }, _arrayContainsAny = function _arrayContainsAny2(toSearch, toFind) {
      var l2 = toFind.length, i2 = 0;
      for (; toSearch.indexOf(toFind[i2]) < 0 && ++i2 < l2; ) {
      }
      return i2 < l2;
    }, _lazyRender = function _lazyRender2() {
      var l2 = _lazyTweens.length, a2 = _lazyTweens.slice(0), i2, tween;
      _lazyLookup = {};
      _lazyTweens.length = 0;
      for (i2 = 0; i2 < l2; i2++) {
        tween = a2[i2];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
      }
    }, _isRevertWorthy = function _isRevertWorthy2(animation) {
      return !!(animation._initted || animation._startAt || animation.add);
    }, _lazySafeRender = function _lazySafeRender2(animation, time, suppressEvents, force) {
      _lazyTweens.length && !_reverting$1 && _lazyRender();
      animation.render(time, suppressEvents, !!(_reverting$1 && time < 0 && _isRevertWorthy(animation)));
      _lazyTweens.length && !_reverting$1 && _lazyRender();
    }, _numericIfPossible = function _numericIfPossible2(value) {
      var n2 = parseFloat(value);
      return (n2 || n2 === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n2 : _isString$1(value) ? value.trim() : value;
    }, _passThrough$1 = function _passThrough2(p2) {
      return p2;
    }, _setDefaults$1 = function _setDefaults2(obj, defaults) {
      for (var p2 in defaults) {
        p2 in obj || (obj[p2] = defaults[p2]);
      }
      return obj;
    }, _setKeyframeDefaults = function _setKeyframeDefaults2(excludeDuration) {
      return function(obj, defaults) {
        for (var p2 in defaults) {
          p2 in obj || p2 === "duration" && excludeDuration || p2 === "ease" || (obj[p2] = defaults[p2]);
        }
      };
    }, _merge = function _merge2(base, toMerge) {
      for (var p2 in toMerge) {
        base[p2] = toMerge[p2];
      }
      return base;
    }, _mergeDeep = function _mergeDeep2(base, toMerge) {
      for (var p2 in toMerge) {
        p2 !== "__proto__" && p2 !== "constructor" && p2 !== "prototype" && (base[p2] = _isObject$1(toMerge[p2]) ? _mergeDeep2(base[p2] || (base[p2] = {}), toMerge[p2]) : toMerge[p2]);
      }
      return base;
    }, _copyExcluding = function _copyExcluding2(obj, excluding) {
      var copy = {}, p2;
      for (p2 in obj) {
        p2 in excluding || (copy[p2] = obj[p2]);
      }
      return copy;
    }, _inheritDefaults = function _inheritDefaults2(vars) {
      var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults$1;
      if (_isNotFalse(vars.inherit)) {
        while (parent) {
          func(vars, parent.vars.defaults);
          parent = parent.parent || parent._dp;
        }
      }
      return vars;
    }, _arraysMatch = function _arraysMatch2(a1, a2) {
      var i2 = a1.length, match = i2 === a2.length;
      while (match && i2-- && a1[i2] === a2[i2]) {
      }
      return i2 < 0;
    }, _addLinkedListItem = function _addLinkedListItem2(parent, child, firstProp, lastProp, sortBy) {
      var prev = parent[lastProp], t2;
      if (sortBy) {
        t2 = child[sortBy];
        while (prev && prev[sortBy] > t2) {
          prev = prev._prev;
        }
      }
      if (prev) {
        child._next = prev._next;
        prev._next = child;
      } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
      }
      if (child._next) {
        child._next._prev = child;
      } else {
        parent[lastProp] = child;
      }
      child._prev = prev;
      child.parent = child._dp = parent;
      return child;
    }, _removeLinkedListItem = function _removeLinkedListItem2(parent, child, firstProp, lastProp) {
      if (firstProp === void 0) {
        firstProp = "_first";
      }
      if (lastProp === void 0) {
        lastProp = "_last";
      }
      var prev = child._prev, next = child._next;
      if (prev) {
        prev._next = next;
      } else if (parent[firstProp] === child) {
        parent[firstProp] = next;
      }
      if (next) {
        next._prev = prev;
      } else if (parent[lastProp] === child) {
        parent[lastProp] = prev;
      }
      child._next = child._prev = child.parent = null;
    }, _removeFromParent = function _removeFromParent2(child, onlyIfParentHasAutoRemove) {
      child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
      child._act = 0;
    }, _uncache = function _uncache2(animation, child) {
      if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        var a2 = animation;
        while (a2) {
          a2._dirty = 1;
          a2 = a2.parent;
        }
      }
      return animation;
    }, _recacheAncestors = function _recacheAncestors2(animation) {
      var parent = animation.parent;
      while (parent && parent.parent) {
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
      }
      return animation;
    }, _rewindStartAt = function _rewindStartAt2(tween, totalTime, suppressEvents, force) {
      return tween._startAt && (_reverting$1 ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
    }, _hasNoPausedAncestors = function _hasNoPausedAncestors2(animation) {
      return !animation || animation._ts && _hasNoPausedAncestors2(animation.parent);
    }, _elapsedCycleDuration = function _elapsedCycleDuration2(animation) {
      return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
    }, _animationCycle = function _animationCycle2(tTime, cycleDuration) {
      var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
      return tTime && whole === tTime ? whole - 1 : whole;
    }, _parentToChildTotalTime = function _parentToChildTotalTime2(parentTime, child) {
      return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
    }, _setEnd = function _setEnd2(animation) {
      return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
    }, _alignPlayhead = function _alignPlayhead2(animation, totalTime) {
      var parent = animation._dp;
      if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation);
      }
      return animation;
    }, _postAddChecks = function _postAddChecks2(timeline, child) {
      var t2;
      if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        t2 = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp$1(0, child.totalDuration(), t2) - child._tTime > _tinyNum) {
          child.render(t2, true);
        }
      }
      if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        if (timeline._dur < timeline.duration()) {
          t2 = timeline;
          while (t2._dp) {
            t2.rawTime() >= 0 && t2.totalTime(t2._tTime);
            t2 = t2._dp;
          }
        }
        timeline._zTime = -_tinyNum;
      }
    }, _addToTimeline = function _addToTimeline2(timeline, child, position, skipChecks) {
      child.parent && _removeFromParent(child);
      child._start = _roundPrecise((_isNumber$2(position) ? position : position || timeline !== _globalTimeline ? _parsePosition$1(timeline, position, child) : timeline._time) + child._delay);
      child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
      _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
      _isFromOrFromStart(child) || (timeline._recent = child);
      skipChecks || _postAddChecks(timeline, child);
      timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime);
      return timeline;
    }, _scrollTrigger = function _scrollTrigger2(animation, trigger) {
      return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
    }, _attemptInitTween = function _attemptInitTween2(tween, time, force, suppressEvents, tTime) {
      _initTween(tween, time, tTime);
      if (!tween._initted) {
        return 1;
      }
      if (!force && tween._pt && !_reverting$1 && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [tTime, suppressEvents];
        return 1;
      }
    }, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart2(_ref) {
      var parent = _ref.parent;
      return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart2(parent));
    }, _isFromOrFromStart = function _isFromOrFromStart2(_ref2) {
      var data = _ref2.data;
      return data === "isFromStart" || data === "isStart";
    }, _renderZeroDurationTween = function _renderZeroDurationTween2(tween, totalTime, suppressEvents, force) {
      var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
      if (repeatDelay && tween._repeat) {
        tTime = _clamp$1(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
          prevRatio = 1 - ratio;
          tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
      }
      if (ratio !== prevRatio || _reverting$1 || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) {
          return;
        }
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0);
        suppressEvents || (suppressEvents = totalTime && !prevIteration);
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while (pt) {
          pt.r(ratio, pt.d);
          pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback$1(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback$1(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
          ratio && _removeFromParent(tween, 1);
          if (!suppressEvents && !_reverting$1) {
            _callback$1(tween, ratio ? "onComplete" : "onReverseComplete", true);
            tween._prom && tween._prom();
          }
        }
      } else if (!tween._zTime) {
        tween._zTime = totalTime;
      }
    }, _findNextPauseTween = function _findNextPauseTween2(animation, prevTime, time) {
      var child;
      if (time > prevTime) {
        child = animation._first;
        while (child && child._start <= time) {
          if (child.data === "isPause" && child._start > prevTime) {
            return child;
          }
          child = child._next;
        }
      } else {
        child = animation._last;
        while (child && child._start >= time) {
          if (child.data === "isPause" && child._start < prevTime) {
            return child;
          }
          child = child._prev;
        }
      }
    }, _setDuration = function _setDuration2(animation, duration, skipUncache, leavePlayhead) {
      var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
      totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
      animation._dur = dur;
      animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
      totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
      animation.parent && _setEnd(animation);
      skipUncache || _uncache(animation.parent, animation);
      return animation;
    }, _onUpdateTotalDuration = function _onUpdateTotalDuration2(animation) {
      return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
    }, _zeroPosition = {
      _start: 0,
      endTime: _emptyFunc,
      totalDuration: _emptyFunc
    }, _parsePosition$1 = function _parsePosition2(animation, position, percentAnimation) {
      var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum$2 ? recent.endTime(false) : animation._dur, i2, offset, isPercent;
      if (_isString$1(position) && (isNaN(position) || position in labels)) {
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i2 = position.indexOf("=");
        if (offset === "<" || offset === ">") {
          i2 >= 0 && (position = position.replace(/=/, ""));
          return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i2 < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i2 < 0) {
          position in labels || (labels[position] = clippedDuration);
          return labels[position];
        }
        offset = parseFloat(position.charAt(i2 - 1) + position.substr(i2 + 1));
        if (isPercent && percentAnimation) {
          offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        }
        return i2 > 1 ? _parsePosition2(animation, position.substr(0, i2 - 1), percentAnimation) + offset : clippedDuration + offset;
      }
      return position == null ? clippedDuration : +position;
    }, _createTweenType = function _createTweenType2(type, params, timeline) {
      var isLegacy = _isNumber$2(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
      isLegacy && (vars.duration = params[1]);
      vars.parent = timeline;
      if (type) {
        irVars = vars;
        parent = timeline;
        while (parent && !("immediateRender" in irVars)) {
          irVars = parent.vars.defaults || {};
          parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1];
      }
      return new Tween(params[0], vars, params[varsIndex + 1]);
    }, _conditionalReturn = function _conditionalReturn2(value, func) {
      return value || value === 0 ? func(value) : func;
    }, _clamp$1 = function _clamp2(min, max, value) {
      return value < min ? min : value > max ? max : value;
    }, getUnit = function getUnit2(value, v2) {
      return !_isString$1(value) || !(v2 = _unitExp.exec(value)) ? "" : v2[1];
    }, clamp$1 = function clamp2(min, max, value) {
      return _conditionalReturn(value, function(v2) {
        return _clamp$1(min, max, v2);
      });
    }, _slice = [].slice, _isArrayLike = function _isArrayLike2(value, nonEmpty) {
      return value && _isObject$1(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject$1(value[0])) && !value.nodeType && value !== _win$4;
    }, _flatten = function _flatten2(ar, leaveStrings, accumulator) {
      if (accumulator === void 0) {
        accumulator = [];
      }
      return ar.forEach(function(value) {
        var _accumulator;
        return _isString$1(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
      }) || accumulator;
    }, toArray = function toArray2(value, scope, leaveStrings) {
      return _context$2 && !scope && _context$2.selector ? _context$2.selector(value) : _isString$1(value) && !leaveStrings && (_coreInitted$3 || !_wake()) ? _slice.call((scope || _doc$4).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
    }, selector = function selector2(value) {
      value = toArray(value)[0] || _warn("Invalid scope") || {};
      return function(v2) {
        var el = value.current || value.nativeElement || value;
        return toArray(v2, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc$4.createElement("div") : value);
      };
    }, shuffle = function shuffle2(a2) {
      return a2.sort(function() {
        return 0.5 - Math.random();
      });
    }, distribute = function distribute2(v2) {
      if (_isFunction$1(v2)) {
        return v2;
      }
      var vars = _isObject$1(v2) ? v2 : {
        each: v2
      }, ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
      if (_isString$1(from)) {
        ratioX = ratioY = {
          center: 0.5,
          edges: 0.5,
          end: 1
        }[from] || 0;
      } else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
      }
      return function(i2, target, a2) {
        var l2 = (a2 || vars).length, distances = cache[l2], originX, originY, x2, y2, d2, j2, max, min, wrapAt;
        if (!distances) {
          wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum$2])[1];
          if (!wrapAt) {
            max = -_bigNum$2;
            while (max < (max = a2[wrapAt++].getBoundingClientRect().left) && wrapAt < l2) {
            }
            wrapAt < l2 && wrapAt--;
          }
          distances = cache[l2] = [];
          originX = ratios ? Math.min(wrapAt, l2) * ratioX - 0.5 : from % wrapAt;
          originY = wrapAt === _bigNum$2 ? 0 : ratios ? l2 * ratioY / wrapAt - 0.5 : from / wrapAt | 0;
          max = 0;
          min = _bigNum$2;
          for (j2 = 0; j2 < l2; j2++) {
            x2 = j2 % wrapAt - originX;
            y2 = originY - (j2 / wrapAt | 0);
            distances[j2] = d2 = !axis ? _sqrt$1(x2 * x2 + y2 * y2) : Math.abs(axis === "y" ? y2 : x2);
            d2 > max && (max = d2);
            d2 < min && (min = d2);
          }
          from === "random" && shuffle(distances);
          distances.max = max - min;
          distances.min = min;
          distances.v = l2 = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l2 ? l2 - 1 : !axis ? Math.max(wrapAt, l2 / wrapAt) : axis === "y" ? l2 / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
          distances.b = l2 < 0 ? base - l2 : base;
          distances.u = getUnit(vars.amount || vars.each) || 0;
          ease = ease && l2 < 0 ? _invertEase(ease) : ease;
        }
        l2 = (distances[i2] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l2) : l2) * distances.v) + distances.u;
      };
    }, _roundModifier = function _roundModifier2(v2) {
      var p2 = Math.pow(10, ((v2 + "").split(".")[1] || "").length);
      return function(raw) {
        var n2 = _roundPrecise(Math.round(parseFloat(raw) / v2) * v2 * p2);
        return (n2 - n2 % 1) / p2 + (_isNumber$2(raw) ? 0 : getUnit(raw));
      };
    }, snap = function snap2(snapTo, value) {
      var isArray = _isArray(snapTo), radius, is2D;
      if (!isArray && _isObject$1(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum$2;
        if (snapTo.values) {
          snapTo = toArray(snapTo.values);
          if (is2D = !_isNumber$2(snapTo[0])) {
            radius *= radius;
          }
        } else {
          snapTo = _roundModifier(snapTo.increment);
        }
      }
      return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction$1(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
      } : function(raw) {
        var x2 = parseFloat(is2D ? raw.x : raw), y2 = parseFloat(is2D ? raw.y : 0), min = _bigNum$2, closest = 0, i2 = snapTo.length, dx, dy;
        while (i2--) {
          if (is2D) {
            dx = snapTo[i2].x - x2;
            dy = snapTo[i2].y - y2;
            dx = dx * dx + dy * dy;
          } else {
            dx = Math.abs(snapTo[i2] - x2);
          }
          if (dx < min) {
            min = dx;
            closest = i2;
          }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber$2(raw) ? closest : closest + getUnit(raw);
      });
    }, random = function random2(min, max, roundingIncrement, returnFunction) {
      return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * 0.99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
      });
    }, pipe = function pipe2() {
      for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
        functions[_key] = arguments[_key];
      }
      return function(value) {
        return functions.reduce(function(v2, f2) {
          return f2(v2);
        }, value);
      };
    }, unitize = function unitize2(func, unit) {
      return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
      };
    }, normalize = function normalize2(min, max, value) {
      return mapRange(min, max, 0, 1, value);
    }, _wrapArray = function _wrapArray2(a2, wrapper, value) {
      return _conditionalReturn(value, function(index) {
        return a2[~~wrapper(index)];
      });
    }, wrap = function wrap2(min, max, value) {
      var range = max - min;
      return _isArray(min) ? _wrapArray(min, wrap2(0, min.length), max) : _conditionalReturn(value, function(value2) {
        return (range + (value2 - min) % range) % range + min;
      });
    }, wrapYoyo = function wrapYoyo2(min, max, value) {
      var range = max - min, total = range * 2;
      return _isArray(min) ? _wrapArray(min, wrapYoyo2(0, min.length - 1), max) : _conditionalReturn(value, function(value2) {
        value2 = (total + (value2 - min) % total) % total || 0;
        return min + (value2 > range ? total - value2 : value2);
      });
    }, _replaceRandom = function _replaceRandom2(value) {
      var prev = 0, s2 = "", i2, nums, end, isArray;
      while (~(i2 = value.indexOf("random(", prev))) {
        end = value.indexOf(")", i2);
        isArray = value.charAt(i2 + 7) === "[";
        nums = value.substr(i2 + 7, end - i2 - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
        s2 += value.substr(prev, i2 - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
        prev = end + 1;
      }
      return s2 + value.substr(prev, value.length - prev);
    }, mapRange = function mapRange2(inMin, inMax, outMin, outMax, value) {
      var inRange = inMax - inMin, outRange = outMax - outMin;
      return _conditionalReturn(value, function(value2) {
        return outMin + ((value2 - inMin) / inRange * outRange || 0);
      });
    }, interpolate = function interpolate2(start, end, progress, mutate) {
      var func = isNaN(start + end) ? 0 : function(p3) {
        return (1 - p3) * start + p3 * end;
      };
      if (!func) {
        var isString = _isString$1(start), master = {}, p2, i2, interpolators, l2, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
          start = {
            p: start
          };
          end = {
            p: end
          };
        } else if (_isArray(start) && !_isArray(end)) {
          interpolators = [];
          l2 = start.length;
          il = l2 - 2;
          for (i2 = 1; i2 < l2; i2++) {
            interpolators.push(interpolate2(start[i2 - 1], start[i2]));
          }
          l2--;
          func = function func2(p3) {
            p3 *= l2;
            var i3 = Math.min(il, ~~p3);
            return interpolators[i3](p3 - i3);
          };
          progress = end;
        } else if (!mutate) {
          start = _merge(_isArray(start) ? [] : {}, start);
        }
        if (!interpolators) {
          for (p2 in end) {
            _addPropTween.call(master, start, p2, "get", end[p2]);
          }
          func = function func2(p3) {
            return _renderPropTweens(p3, master) || (isString ? start.p : start);
          };
        }
      }
      return _conditionalReturn(progress, func);
    }, _getLabelInDirection = function _getLabelInDirection2(timeline, fromTime, backward) {
      var labels = timeline.labels, min = _bigNum$2, p2, distance, label;
      for (p2 in labels) {
        distance = labels[p2] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
          label = p2;
          min = distance;
        }
      }
      return label;
    }, _callback$1 = function _callback2(animation, type, executeLazyFirst) {
      var v2 = animation.vars, callback = v2[type], prevContext = _context$2, context = animation._ctx, params, scope, result;
      if (!callback) {
        return;
      }
      params = v2[type + "Params"];
      scope = v2.callbackScope || animation;
      executeLazyFirst && _lazyTweens.length && _lazyRender();
      context && (_context$2 = context);
      result = params ? callback.apply(scope, params) : callback.call(scope);
      _context$2 = prevContext;
      return result;
    }, _interrupt$1 = function _interrupt2(animation) {
      _removeFromParent(animation);
      animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting$1);
      animation.progress() < 1 && _callback$1(animation, "onInterrupt");
      return animation;
    }, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin2(config) {
      if (!config) return;
      config = !config.name && config["default"] || config;
      if (_windowExists$2() || config.headless) {
        var name = config.name, isFunc = _isFunction$1(config), Plugin = name && !isFunc && config.init ? function() {
          this._props = [];
        } : config, instanceDefaults = {
          init: _emptyFunc,
          render: _renderPropTweens,
          add: _addPropTween,
          kill: _killPropTweensOf,
          modifier: _addPluginModifier,
          rawVars: 0
        }, statics = {
          targetTest: 0,
          get: 0,
          getSetter: _getSetter,
          aliases: {},
          register: 0
        };
        _wake();
        if (config !== Plugin) {
          if (_plugins[name]) {
            return;
          }
          _setDefaults$1(Plugin, _setDefaults$1(_copyExcluding(config, instanceDefaults), statics));
          _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics)));
          _plugins[Plugin.prop = name] = Plugin;
          if (config.targetTest) {
            _harnessPlugins.push(Plugin);
            _reservedProps[name] = 1;
          }
          name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin";
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap$4, Plugin, PropTween);
      } else {
        _registerPluginQueue.push(config);
      }
    }, _255 = 255, _colorLookup = {
      aqua: [0, _255, _255],
      lime: [0, _255, 0],
      silver: [192, 192, 192],
      black: [0, 0, 0],
      maroon: [128, 0, 0],
      teal: [0, 128, 128],
      blue: [0, 0, _255],
      navy: [0, 0, 128],
      white: [_255, _255, _255],
      olive: [128, 128, 0],
      yellow: [_255, _255, 0],
      orange: [_255, 165, 0],
      gray: [128, 128, 128],
      purple: [128, 0, 128],
      green: [0, 128, 0],
      red: [_255, 0, 0],
      pink: [_255, 192, 203],
      cyan: [0, _255, _255],
      transparent: [_255, _255, _255, 0]
    }, _hue = function _hue2(h2, m1, m2) {
      h2 += h2 < 0 ? 1 : h2 > 1 ? -1 : 0;
      return (h2 * 6 < 1 ? m1 + (m2 - m1) * h2 * 6 : h2 < 0.5 ? m2 : h2 * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h2) * 6 : m1) * _255 + 0.5 | 0;
    }, splitColor = function splitColor2(v2, toHSL, forceAlpha) {
      var a2 = !v2 ? _colorLookup.black : _isNumber$2(v2) ? [v2 >> 16, v2 >> 8 & _255, v2 & _255] : 0, r2, g2, b2, h2, s2, l2, max, min, d2, wasHSL;
      if (!a2) {
        if (v2.substr(-1) === ",") {
          v2 = v2.substr(0, v2.length - 1);
        }
        if (_colorLookup[v2]) {
          a2 = _colorLookup[v2];
        } else if (v2.charAt(0) === "#") {
          if (v2.length < 6) {
            r2 = v2.charAt(1);
            g2 = v2.charAt(2);
            b2 = v2.charAt(3);
            v2 = "#" + r2 + r2 + g2 + g2 + b2 + b2 + (v2.length === 5 ? v2.charAt(4) + v2.charAt(4) : "");
          }
          if (v2.length === 9) {
            a2 = parseInt(v2.substr(1, 6), 16);
            return [a2 >> 16, a2 >> 8 & _255, a2 & _255, parseInt(v2.substr(7), 16) / 255];
          }
          v2 = parseInt(v2.substr(1), 16);
          a2 = [v2 >> 16, v2 >> 8 & _255, v2 & _255];
        } else if (v2.substr(0, 3) === "hsl") {
          a2 = wasHSL = v2.match(_strictNumExp);
          if (!toHSL) {
            h2 = +a2[0] % 360 / 360;
            s2 = +a2[1] / 100;
            l2 = +a2[2] / 100;
            g2 = l2 <= 0.5 ? l2 * (s2 + 1) : l2 + s2 - l2 * s2;
            r2 = l2 * 2 - g2;
            a2.length > 3 && (a2[3] *= 1);
            a2[0] = _hue(h2 + 1 / 3, r2, g2);
            a2[1] = _hue(h2, r2, g2);
            a2[2] = _hue(h2 - 1 / 3, r2, g2);
          } else if (~v2.indexOf("=")) {
            a2 = v2.match(_numExp$1);
            forceAlpha && a2.length < 4 && (a2[3] = 1);
            return a2;
          }
        } else {
          a2 = v2.match(_strictNumExp) || _colorLookup.transparent;
        }
        a2 = a2.map(Number);
      }
      if (toHSL && !wasHSL) {
        r2 = a2[0] / _255;
        g2 = a2[1] / _255;
        b2 = a2[2] / _255;
        max = Math.max(r2, g2, b2);
        min = Math.min(r2, g2, b2);
        l2 = (max + min) / 2;
        if (max === min) {
          h2 = s2 = 0;
        } else {
          d2 = max - min;
          s2 = l2 > 0.5 ? d2 / (2 - max - min) : d2 / (max + min);
          h2 = max === r2 ? (g2 - b2) / d2 + (g2 < b2 ? 6 : 0) : max === g2 ? (b2 - r2) / d2 + 2 : (r2 - g2) / d2 + 4;
          h2 *= 60;
        }
        a2[0] = ~~(h2 + 0.5);
        a2[1] = ~~(s2 * 100 + 0.5);
        a2[2] = ~~(l2 * 100 + 0.5);
      }
      forceAlpha && a2.length < 4 && (a2[3] = 1);
      return a2;
    }, _colorOrderData = function _colorOrderData2(v2) {
      var values = [], c2 = [], i2 = -1;
      v2.split(_colorExp).forEach(function(v3) {
        var a2 = v3.match(_numWithUnitExp) || [];
        values.push.apply(values, a2);
        c2.push(i2 += a2.length + 1);
      });
      values.c = c2;
      return values;
    }, _formatColors = function _formatColors2(s2, toHSL, orderMatchData) {
      var result = "", colors = (s2 + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i2 = 0, c2, shell, d2, l2;
      if (!colors) {
        return s2;
      }
      colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
      });
      if (orderMatchData) {
        d2 = _colorOrderData(s2);
        c2 = orderMatchData.c;
        if (c2.join(result) !== d2.c.join(result)) {
          shell = s2.replace(_colorExp, "1").split(_numWithUnitExp);
          l2 = shell.length - 1;
          for (; i2 < l2; i2++) {
            result += shell[i2] + (~c2.indexOf(i2) ? colors.shift() || type + "0,0,0,0)" : (d2.length ? d2 : colors.length ? colors : orderMatchData).shift());
          }
        }
      }
      if (!shell) {
        shell = s2.split(_colorExp);
        l2 = shell.length - 1;
        for (; i2 < l2; i2++) {
          result += shell[i2] + colors[i2];
        }
      }
      return result + shell[l2];
    }, _colorExp = function() {
      var s2 = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", p2;
      for (p2 in _colorLookup) {
        s2 += "|" + p2 + "\\b";
      }
      return new RegExp(s2 + ")", "gi");
    }(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter2(a2) {
      var combined = a2.join(" "), toHSL;
      _colorExp.lastIndex = 0;
      if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a2[1] = _formatColors(a2[1], toHSL);
        a2[0] = _formatColors(a2[0], toHSL, _colorOrderData(a2[1]));
        return true;
      }
    }, _tickerActive, _ticker = function() {
      var _getTime2 = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime2(), _lastUpdate = _startTime, _gap = 1e3 / 240, _nextTime = _gap, _listeners2 = [], _id2, _req, _raf, _self, _delta, _i2, _tick = function _tick2(v2) {
        var elapsed = _getTime2() - _lastUpdate, manual = v2 === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
          frame = ++_self.frame;
          _delta = time - _self.time * 1e3;
          _self.time = time = time / 1e3;
          _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
          dispatch = 1;
        }
        manual || (_id2 = _req(_tick2));
        if (dispatch) {
          for (_i2 = 0; _i2 < _listeners2.length; _i2++) {
            _listeners2[_i2](time, _delta, frame, v2);
          }
        }
      };
      _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
          _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
          return _delta / (1e3 / (fps || 60));
        },
        wake: function wake() {
          if (_coreReady) {
            if (!_coreInitted$3 && _windowExists$2()) {
              _win$4 = _coreInitted$3 = window;
              _doc$4 = _win$4.document || {};
              _globals.gsap = gsap$4;
              (_win$4.gsapVersions || (_win$4.gsapVersions = [])).push(gsap$4.version);
              _install(_installScope || _win$4.GreenSockGlobals || !_win$4.gsap && _win$4 || {});
              _registerPluginQueue.forEach(_createPlugin);
            }
            _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
            _id2 && _self.sleep();
            _req = _raf || function(f2) {
              return setTimeout(f2, _nextTime - _self.time * 1e3 + 1 | 0);
            };
            _tickerActive = 1;
            _tick(2);
          }
        },
        sleep: function sleep() {
          (_raf ? cancelAnimationFrame : clearTimeout)(_id2);
          _tickerActive = 0;
          _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
          _lagThreshold = threshold || Infinity;
          _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
          _gap = 1e3 / (_fps || 240);
          _nextTime = _self.time * 1e3 + _gap;
        },
        add: function add(callback, once, prioritize) {
          var func = once ? function(t2, d2, f2, v2) {
            callback(t2, d2, f2, v2);
            _self.remove(func);
          } : callback;
          _self.remove(callback);
          _listeners2[prioritize ? "unshift" : "push"](func);
          _wake();
          return func;
        },
        remove: function remove(callback, i2) {
          ~(i2 = _listeners2.indexOf(callback)) && _listeners2.splice(i2, 1) && _i2 >= i2 && _i2--;
        },
        _listeners: _listeners2
      };
      return _self;
    }(), _wake = function _wake2() {
      return !_tickerActive && _ticker.wake();
    }, _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString2(value) {
      var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i2 = 1, l2 = split.length, index, val, parsedVal;
      for (; i2 < l2; i2++) {
        val = split[i2];
        index = i2 !== l2 - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
      }
      return obj;
    }, _valueInParentheses = function _valueInParentheses2(value) {
      var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
      return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
    }, _configEaseFromString = function _configEaseFromString2(name) {
      var split = (name + "").split("("), ease = _easeMap[split[0]];
      return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
    }, _invertEase = function _invertEase2(ease) {
      return function(p2) {
        return 1 - ease(1 - p2);
      };
    }, _propagateYoyoEase = function _propagateYoyoEase2(timeline, isYoyo) {
      var child = timeline._first, ease;
      while (child) {
        if (child instanceof Timeline) {
          _propagateYoyoEase2(child, isYoyo);
        } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
          if (child.timeline) {
            _propagateYoyoEase2(child.timeline, isYoyo);
          } else {
            ease = child._ease;
            child._ease = child._yEase;
            child._yEase = ease;
            child._yoyo = isYoyo;
          }
        }
        child = child._next;
      }
    }, _parseEase = function _parseEase2(ease, defaultEase) {
      return !ease ? defaultEase : (_isFunction$1(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
    }, _insertEase = function _insertEase2(names, easeIn, easeOut, easeInOut) {
      if (easeOut === void 0) {
        easeOut = function easeOut2(p2) {
          return 1 - easeIn(1 - p2);
        };
      }
      if (easeInOut === void 0) {
        easeInOut = function easeInOut2(p2) {
          return p2 < 0.5 ? easeIn(p2 * 2) / 2 : 1 - easeIn((1 - p2) * 2) / 2;
        };
      }
      var ease = {
        easeIn,
        easeOut,
        easeInOut
      }, lowercaseName;
      _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for (var p2 in ease) {
          _easeMap[lowercaseName + (p2 === "easeIn" ? ".in" : p2 === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p2] = ease[p2];
        }
      });
      return ease;
    }, _easeInOutFromOut = function _easeInOutFromOut2(easeOut) {
      return function(p2) {
        return p2 < 0.5 ? (1 - easeOut(1 - p2 * 2)) / 2 : 0.5 + easeOut((p2 - 0.5) * 2) / 2;
      };
    }, _configElastic = function _configElastic2(type, amplitude, period) {
      var p1 = amplitude >= 1 ? amplitude : 1, p2 = (period || (type ? 0.3 : 0.45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut2(p4) {
        return p4 === 1 ? 1 : p1 * Math.pow(2, -10 * p4) * _sin$1((p4 - p3) * p2) + 1;
      }, ease = type === "out" ? easeOut : type === "in" ? function(p4) {
        return 1 - easeOut(1 - p4);
      } : _easeInOutFromOut(easeOut);
      p2 = _2PI / p2;
      ease.config = function(amplitude2, period2) {
        return _configElastic2(type, amplitude2, period2);
      };
      return ease;
    }, _configBack = function _configBack2(type, overshoot) {
      if (overshoot === void 0) {
        overshoot = 1.70158;
      }
      var easeOut = function easeOut2(p2) {
        return p2 ? --p2 * p2 * ((overshoot + 1) * p2 + overshoot) + 1 : 0;
      }, ease = type === "out" ? easeOut : type === "in" ? function(p2) {
        return 1 - easeOut(1 - p2);
      } : _easeInOutFromOut(easeOut);
      ease.config = function(overshoot2) {
        return _configBack2(type, overshoot2);
      };
      return ease;
    };
    _forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i2) {
      var power = i2 < 5 ? i2 + 1 : i2;
      _insertEase(name + ",Power" + (power - 1), i2 ? function(p2) {
        return Math.pow(p2, power);
      } : function(p2) {
        return p2;
      }, function(p2) {
        return 1 - Math.pow(1 - p2, power);
      }, function(p2) {
        return p2 < 0.5 ? Math.pow(p2 * 2, power) / 2 : 1 - Math.pow((1 - p2) * 2, power) / 2;
      });
    });
    _easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
    _insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
    (function(n2, c2) {
      var n1 = 1 / c2, n22 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut2(p2) {
        return p2 < n1 ? n2 * p2 * p2 : p2 < n22 ? n2 * Math.pow(p2 - 1.5 / c2, 2) + 0.75 : p2 < n3 ? n2 * (p2 -= 2.25 / c2) * p2 + 0.9375 : n2 * Math.pow(p2 - 2.625 / c2, 2) + 0.984375;
      };
      _insertEase("Bounce", function(p2) {
        return 1 - easeOut(1 - p2);
      }, easeOut);
    })(7.5625, 2.75);
    _insertEase("Expo", function(p2) {
      return Math.pow(2, 10 * (p2 - 1)) * p2 + p2 * p2 * p2 * p2 * p2 * p2 * (1 - p2);
    });
    _insertEase("Circ", function(p2) {
      return -(_sqrt$1(1 - p2 * p2) - 1);
    });
    _insertEase("Sine", function(p2) {
      return p2 === 1 ? 1 : -_cos$1(p2 * _HALF_PI) + 1;
    });
    _insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
    _easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
      config: function config(steps, immediateStart) {
        if (steps === void 0) {
          steps = 1;
        }
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p4) {
          return ((p2 * _clamp$1(0, max, p4) | 0) + p3) * p1;
        };
      }
    };
    _defaults$1.ease = _easeMap["quad.out"];
    _forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
      return _callbackNames += name + "," + name + "Params,";
    });
    var GSCache = function GSCache2(target, harness) {
      this.id = _gsID++;
      target._gsap = this;
      this.target = target;
      this.harness = harness;
      this.get = harness ? harness.get : _getProperty;
      this.set = harness ? harness.getSetter : _getSetter;
    };
    var Animation = /* @__PURE__ */ function() {
      function Animation2(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
          this._rDelay = vars.repeatDelay || 0;
          this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context$2) {
          this._ctx = _context$2;
          _context$2.data.push(this);
        }
        _tickerActive || _ticker.wake();
      }
      var _proto = Animation2.prototype;
      _proto.delay = function delay(value) {
        if (value || value === 0) {
          this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
          this._delay = value;
          return this;
        }
        return this._delay;
      };
      _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
      };
      _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) {
          return this._tDur;
        }
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
      };
      _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) {
          return this._tTime;
        }
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
          _alignPlayhead(this, _totalTime);
          !parent._dp || parent.parent || _postAddChecks(parent, this);
          while (parent && parent.parent) {
            if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
              parent.totalTime(parent._tTime, true);
            }
            parent = parent.parent;
          }
          if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
            _addToTimeline(this._dp, this, this._start - this._delay);
          }
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
          this._ts || (this._pTime = _totalTime);
          _lazySafeRender(this, _totalTime, suppressEvents);
        }
        return this;
      };
      _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time;
      };
      _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
      };
      _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
      };
      _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
      };
      _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) {
          return this._rts === -_tinyNum ? 0 : this._rts;
        }
        if (this._rts === value) {
          return this;
        }
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime;
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts;
        this.totalTime(_clamp$1(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this);
        return _recacheAncestors(this);
      };
      _proto.paused = function paused(value) {
        if (!arguments.length) {
          return this._ps;
        }
        if (this._ps !== value) {
          this._ps = value;
          if (value) {
            this._pTime = this._tTime || Math.max(-this._delay, this.rawTime());
            this._ts = this._act = 0;
          } else {
            _wake();
            this._ts = this._rts;
            this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum));
          }
        }
        return this;
      };
      _proto.startTime = function startTime(value) {
        if (arguments.length) {
          this._start = value;
          var parent = this.parent || this._dp;
          parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
          return this;
        }
        return this._start;
      };
      _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
      };
      _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp;
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
      };
      _proto.revert = function revert(config) {
        if (config === void 0) {
          config = _revertConfig;
        }
        var prevIsReverting = _reverting$1;
        _reverting$1 = config;
        if (_isRevertWorthy(this)) {
          this.timeline && this.timeline.revert(config);
          this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting$1 = prevIsReverting;
        return this;
      };
      _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while (animation) {
          time = animation._start + time / (Math.abs(animation._ts) || 1);
          animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time;
      };
      _proto.repeat = function repeat(value) {
        if (arguments.length) {
          this._repeat = value === Infinity ? -2 : value;
          return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
      };
      _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
          var time = this._time;
          this._rDelay = value;
          _onUpdateTotalDuration(this);
          return time ? this.time(time) : this;
        }
        return this._rDelay;
      };
      _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
          this._yoyo = value;
          return this;
        }
        return this._yoyo;
      };
      _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition$1(this, position), _isNotFalse(suppressEvents));
      };
      _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum);
        return this;
      };
      _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
      };
      _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
      };
      _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
      };
      _proto.resume = function resume() {
        return this.paused(false);
      };
      _proto.reversed = function reversed(value) {
        if (arguments.length) {
          !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0));
          return this;
        }
        return this._rts < 0;
      };
      _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
      };
      _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
      };
      _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
          if (!callback) {
            delete vars[type];
          } else {
            vars[type] = callback;
            params && (vars[type + "Params"] = params);
            type === "onUpdate" && (this._onUpdate = callback);
          }
          return this;
        }
        return vars[type];
      };
      _proto.then = function then(onFulfilled) {
        var self = this;
        return new Promise(function(resolve) {
          var f2 = _isFunction$1(onFulfilled) ? onFulfilled : _passThrough$1, _resolve = function _resolve2() {
            var _then = self.then;
            self.then = null;
            _isFunction$1(f2) && (f2 = f2(self)) && (f2.then || f2 === self) && (self.then = _then);
            resolve(f2);
            self.then = _then;
          };
          if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
            _resolve();
          } else {
            self._prom = _resolve;
          }
        });
      };
      _proto.kill = function kill() {
        _interrupt$1(this);
      };
      return Animation2;
    }();
    _setDefaults$1(Animation.prototype, {
      _time: 0,
      _start: 0,
      _end: 0,
      _tTime: 0,
      _tDur: 0,
      _dirty: 0,
      _repeat: 0,
      _yoyo: false,
      parent: null,
      _initted: false,
      _rDelay: 0,
      _ts: 1,
      _dp: 0,
      ratio: 0,
      _zTime: -_tinyNum,
      _prom: 0,
      _ps: false,
      _rts: 1
    });
    var Timeline = /* @__PURE__ */ function(_Animation) {
      _inheritsLoose(Timeline2, _Animation);
      function Timeline2(vars, position) {
        var _this;
        if (vars === void 0) {
          vars = {};
        }
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
      }
      var _proto2 = Timeline2.prototype;
      _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
      };
      _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
      };
      _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
      };
      _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition$1(this, position), 1);
        return this;
      };
      _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
      };
      _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition$1(this, position));
        return this;
      };
      _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
      };
      _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
      };
      _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
          if (prevTime !== this._time && dur) {
            tTime += this._time - prevTime;
            totalTime += this._time - prevTime;
          }
          time = tTime;
          prevStart = this._start;
          timeScale = this._ts;
          prevPaused = !timeScale;
          if (crossingStart) {
            dur || (prevTime = this._zTime);
            (totalTime || !suppressEvents) && (this._zTime = totalTime);
          }
          if (this._repeat) {
            yoyo = this._yoyo;
            cycleDuration = dur + this._rDelay;
            if (this._repeat < -1 && totalTime < 0) {
              return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
            }
            time = _roundPrecise(tTime % cycleDuration);
            if (tTime === tDur) {
              iteration = this._repeat;
              time = dur;
            } else {
              prevIteration = _roundPrecise(tTime / cycleDuration);
              iteration = ~~prevIteration;
              if (iteration && iteration === prevIteration) {
                time = dur;
                iteration--;
              }
              time > dur && (time = dur);
            }
            prevIteration = _animationCycle(this._tTime, cycleDuration);
            !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration);
            if (yoyo && iteration & 1) {
              time = dur - time;
              isYoyo = 1;
            }
            if (iteration !== prevIteration && !this._lock) {
              var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
              iteration < prevIteration && (rewinding = !rewinding);
              prevTime = rewinding ? 0 : tTime % dur ? dur : tTime;
              this._lock = 1;
              this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
              this._tTime = tTime;
              !suppressEvents && this.parent && _callback$1(this, "onRepeat");
              this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);
              if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
                return this;
              }
              dur = this._dur;
              tDur = this._tDur;
              if (doesWrap) {
                this._lock = 2;
                prevTime = rewinding ? dur : -1e-4;
                this.render(prevTime, true);
                this.vars.repeatRefresh && !isYoyo && this.invalidate();
              }
              this._lock = 0;
              if (!this._ts && !prevPaused) {
                return this;
              }
              _propagateYoyoEase(this, isYoyo);
            }
          }
          if (this._hasPause && !this._forcing && this._lock < 2) {
            pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
            if (pauseTween) {
              tTime -= time - (time = pauseTween._start);
            }
          }
          this._tTime = tTime;
          this._time = time;
          this._act = !timeScale;
          if (!this._initted) {
            this._onUpdate = this.vars.onUpdate;
            this._initted = 1;
            this._zTime = totalTime;
            prevTime = 0;
          }
          if (!prevTime && tTime && !suppressEvents && !prevIteration) {
            _callback$1(this, "onStart");
            if (this._tTime !== tTime) {
              return this;
            }
          }
          if (time >= prevTime && totalTime >= 0) {
            child = this._first;
            while (child) {
              next = child._next;
              if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                if (child.parent !== this) {
                  return this.render(totalTime, suppressEvents, force);
                }
                child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                if (time !== this._time || !this._ts && !prevPaused) {
                  pauseTween = 0;
                  next && (tTime += this._zTime = -_tinyNum);
                  break;
                }
              }
              child = next;
            }
          } else {
            child = this._last;
            var adjustedTime = totalTime < 0 ? totalTime : time;
            while (child) {
              next = child._prev;
              if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                if (child.parent !== this) {
                  return this.render(totalTime, suppressEvents, force);
                }
                child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting$1 && _isRevertWorthy(child));
                if (time !== this._time || !this._ts && !prevPaused) {
                  pauseTween = 0;
                  next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum);
                  break;
                }
              }
              child = next;
            }
          }
          if (pauseTween && !suppressEvents) {
            this.pause();
            pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
            if (this._ts) {
              this._start = prevStart;
              _setEnd(this);
              return this.render(totalTime, suppressEvents, force);
            }
          }
          this._onUpdate && !suppressEvents && _callback$1(this, "onUpdate", true);
          if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
            if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
              if (!this._lock) {
                (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);
                if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                  _callback$1(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                  this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
              }
            }
          }
        }
        return this;
      };
      _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber$2(position) || (position = _parsePosition$1(this, position, child));
        if (!(child instanceof Animation)) {
          if (_isArray(child)) {
            child.forEach(function(obj) {
              return _this2.add(obj, position);
            });
            return this;
          }
          if (_isString$1(child)) {
            return this.addLabel(child, position);
          }
          if (_isFunction$1(child)) {
            child = Tween.delayedCall(0, child);
          } else {
            return this;
          }
        }
        return this !== child ? _addToTimeline(this, child, position) : this;
      };
      _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) {
          nested = true;
        }
        if (tweens === void 0) {
          tweens = true;
        }
        if (timelines === void 0) {
          timelines = true;
        }
        if (ignoreBeforeTime === void 0) {
          ignoreBeforeTime = -_bigNum$2;
        }
        var a2 = [], child = this._first;
        while (child) {
          if (child._start >= ignoreBeforeTime) {
            if (child instanceof Tween) {
              tweens && a2.push(child);
            } else {
              timelines && a2.push(child);
              nested && a2.push.apply(a2, child.getChildren(true, tweens, timelines));
            }
          }
          child = child._next;
        }
        return a2;
      };
      _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i2 = animations.length;
        while (i2--) {
          if (animations[i2].vars.id === id) {
            return animations[i2];
          }
        }
      };
      _proto2.remove = function remove(child) {
        if (_isString$1(child)) {
          return this.removeLabel(child);
        }
        if (_isFunction$1(child)) {
          return this.killTweensOf(child);
        }
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) {
          this._recent = this._last;
        }
        return _uncache(this);
      };
      _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) {
          return this._tTime;
        }
        this._forcing = 1;
        if (!this._dp && this._ts) {
          this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        }
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
      };
      _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition$1(this, position);
        return this;
      };
      _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
      };
      _proto2.addPause = function addPause(position, callback, params) {
        var t2 = Tween.delayedCall(0, callback || _emptyFunc, params);
        t2.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t2, _parsePosition$1(this, position));
      };
      _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition$1(this, position);
        while (child) {
          if (child._start === position && child.data === "isPause") {
            _removeFromParent(child);
          }
          child = child._next;
        }
      };
      _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i2 = tweens.length;
        while (i2--) {
          _overwritingTween !== tweens[i2] && tweens[i2].kill(targets, props);
        }
        return this;
      };
      _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a2 = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber$2(onlyActive), children;
        while (child) {
          if (child instanceof Tween) {
            if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
              a2.push(child);
            }
          } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
            a2.push.apply(a2, children);
          }
          child = child._next;
        }
        return a2;
      };
      _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition$1(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults$1({
          ease: vars.ease || "none",
          lazy: false,
          immediateRender: false,
          time: endTime,
          overwrite: "auto",
          duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
          onStart: function onStart() {
            tl.pause();
            if (!initted) {
              var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
              tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
              initted = 1;
            }
            _onStart && _onStart.apply(tween, onStartParams || []);
          }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
      };
      _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults$1({
          startAt: {
            time: _parsePosition$1(this, fromPosition)
          }
        }, vars));
      };
      _proto2.recent = function recent() {
        return this._recent;
      };
      _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) {
          afterTime = this._time;
        }
        return _getLabelInDirection(this, _parsePosition$1(this, afterTime));
      };
      _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) {
          beforeTime = this._time;
        }
        return _getLabelInDirection(this, _parsePosition$1(this, beforeTime), 1);
      };
      _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
      };
      _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) {
          ignoreBeforeTime = 0;
        }
        var child = this._first, labels = this.labels, p2;
        while (child) {
          if (child._start >= ignoreBeforeTime) {
            child._start += amount;
            child._end += amount;
          }
          child = child._next;
        }
        if (adjustLabels) {
          for (p2 in labels) {
            if (labels[p2] >= ignoreBeforeTime) {
              labels[p2] += amount;
            }
          }
        }
        return _uncache(this);
      };
      _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while (child) {
          child.invalidate(soft);
          child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
      };
      _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) {
          includeLabels = true;
        }
        var child = this._first, next;
        while (child) {
          next = child._next;
          this.remove(child);
          child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
      };
      _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum$2, prev, start, parent;
        if (arguments.length) {
          return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        }
        if (self._dirty) {
          parent = self.parent;
          while (child) {
            prev = child._prev;
            child._dirty && child.totalDuration();
            start = child._start;
            if (start > prevStart && self._sort && child._ts && !self._lock) {
              self._lock = 1;
              _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
            } else {
              prevStart = start;
            }
            if (start < 0 && child._ts) {
              max -= start;
              if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                self._start += start / self._ts;
                self._time -= start;
                self._tTime -= start;
              }
              self.shiftChildren(-start, false, -Infinity);
              prevStart = 0;
            }
            child._end > max && child._ts && (max = child._end);
            child = prev;
          }
          _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
          self._dirty = 0;
        }
        return self._tDur;
      };
      Timeline2.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
          _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
          _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
          _nextGCFrame += _config.autoSleep || 120;
          var child = _globalTimeline._first;
          if (!child || !child._ts) {
            if (_config.autoSleep && _ticker._listeners.length < 2) {
              while (child && !child._ts) {
                child = child._next;
              }
              child || _ticker.sleep();
            }
          }
        }
      };
      return Timeline2;
    }(Animation);
    _setDefaults$1(Timeline.prototype, {
      _lock: 0,
      _hasPause: 0,
      _forcing: 0
    });
    var _addComplexStringPropTween = function _addComplexStringPropTween2(target, prop, start, end, setter, stringFilter, funcParam) {
      var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a2;
      pt.b = start;
      pt.e = end;
      start += "";
      end += "";
      if (hasRandom = ~end.indexOf("random(")) {
        end = _replaceRandom(end);
      }
      if (stringFilter) {
        a2 = [start, end];
        stringFilter(a2, target, prop);
        start = a2[0];
        end = a2[1];
      }
      startNums = start.match(_complexStringNumExp) || [];
      while (result = _complexStringNumExp.exec(end)) {
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) {
          color = (color + 1) % 5;
        } else if (chunk.substr(-5) === "rgba(") {
          color = 1;
        }
        if (endNum !== startNums[matchIndex++]) {
          startNum = parseFloat(startNums[matchIndex - 1]) || 0;
          pt._pt = {
            _next: pt._pt,
            p: chunk || matchIndex === 1 ? chunk : ",",
            //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
            s: startNum,
            c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
            m: color && color < 4 ? Math.round : 0
          };
          index = _complexStringNumExp.lastIndex;
        }
      }
      pt.c = index < end.length ? end.substring(index, end.length) : "";
      pt.fp = funcParam;
      if (_relExp.test(end) || hasRandom) {
        pt.e = 0;
      }
      this._pt = pt;
      return pt;
    }, _addPropTween = function _addPropTween2(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
      _isFunction$1(end) && (end = end(index || 0, target, targets));
      var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction$1(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction$1(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction$1(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
      if (_isString$1(end)) {
        if (~end.indexOf("random(")) {
          end = _replaceRandom(end);
        }
        if (end.charAt(1) === "=") {
          pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
          if (pt || pt === 0) {
            end = pt;
          }
        }
      }
      if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
          pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
          funcParam && (pt.fp = funcParam);
          modifier && pt.modifier(modifier, this, target);
          return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
      }
    }, _processVars = function _processVars2(vars, index, target, targets, tween) {
      _isFunction$1(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
      if (!_isObject$1(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
        return _isString$1(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
      }
      var copy = {}, p2;
      for (p2 in vars) {
        copy[p2] = _parseFuncOrString(vars[p2], tween, index, target, targets);
      }
      return copy;
    }, _checkPlugin = function _checkPlugin2(property, vars, tween, index, target, targets) {
      var plugin, pt, ptLookup, i2;
      if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
          ptLookup = tween._ptLookup[tween._targets.indexOf(target)];
          i2 = plugin._props.length;
          while (i2--) {
            ptLookup[plugin._props[i2]] = pt;
          }
        }
      }
      return plugin;
    }, _overwritingTween, _forceAllPropTweens, _initTween = function _initTween2(tween, time, tTime) {
      var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites$1, tl = tween.timeline, cleanVars, i2, p2, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
      tl && (!keyframes || !ease) && (ease = "none");
      tween._ease = _parseEase(ease, _defaults$1.ease);
      tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults$1.ease)) : 0;
      if (yoyoEase && tween._yoyo && !tween._repeat) {
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
      }
      tween._from = !tl && !!vars.runBackwards;
      if (!tl || keyframes && !vars.stagger) {
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop];
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
          prevStartAt._zTime < 0 && prevStartAt.progress(1);
          time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig);
          prevStartAt._lazy = 0;
        }
        if (startAt) {
          _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults$1({
            data: "isStart",
            overwrite: false,
            parent,
            immediateRender: true,
            lazy: !prevStartAt && _isNotFalse(lazy),
            startAt: null,
            delay: 0,
            onUpdate: onUpdate && function() {
              return _callback$1(tween, "onUpdate");
            },
            stagger: 0
          }, startAt)));
          tween._startAt._dp = 0;
          tween._startAt._sat = tween;
          time < 0 && (_reverting$1 || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill);
          if (immediateRender) {
            if (dur && time <= 0 && tTime <= 0) {
              time && (tween._zTime = time);
              return;
            }
          }
        } else if (runBackwards && dur) {
          if (!prevStartAt) {
            time && (immediateRender = false);
            p2 = _setDefaults$1({
              overwrite: false,
              data: "isFromStart",
              //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
              lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
              immediateRender,
              //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
              stagger: 0,
              parent
              //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
            }, cleanVars);
            harnessVars && (p2[harness.prop] = harnessVars);
            _removeFromParent(tween._startAt = Tween.set(targets, p2));
            tween._startAt._dp = 0;
            tween._startAt._sat = tween;
            time < 0 && (_reverting$1 ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
            tween._zTime = time;
            if (!immediateRender) {
              _initTween2(tween._startAt, _tinyNum, _tinyNum);
            } else if (!time) {
              return;
            }
          }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for (i2 = 0; i2 < targets.length; i2++) {
          target = targets[i2];
          gsData = target._gsap || _harness(targets)[i2]._gsap;
          tween._ptLookup[i2] = ptLookup = {};
          _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender();
          index = fullTargets === targets ? i2 : fullTargets.indexOf(target);
          if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
            tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
            plugin._props.forEach(function(name) {
              ptLookup[name] = pt;
            });
            plugin.priority && (hasPriority = 1);
          }
          if (!harness || harnessVars) {
            for (p2 in cleanVars) {
              if (_plugins[p2] && (plugin = _checkPlugin(p2, cleanVars, tween, index, target, fullTargets))) {
                plugin.priority && (hasPriority = 1);
              } else {
                ptLookup[p2] = pt = _addPropTween.call(tween, target, p2, "get", cleanVars[p2], index, fullTargets, 0, vars.stringFilter);
              }
            }
          }
          tween._op && tween._op[i2] && tween.kill(target, tween._op[i2]);
          if (autoOverwrite && tween._pt) {
            _overwritingTween = tween;
            _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time));
            overwritten = !tween.parent;
            _overwritingTween = 0;
          }
          tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween);
      }
      tween._onUpdate = onUpdate;
      tween._initted = (!tween._op || tween._pt) && !overwritten;
      keyframes && time <= 0 && tl.render(_bigNum$2, true, true);
    }, _updatePropTweens = function _updatePropTweens2(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
      var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i2;
      if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i2 = tween._targets.length;
        while (i2--) {
          pt = lookup[i2][property];
          if (pt && pt.d && pt.d._pt) {
            pt = pt.d._pt;
            while (pt && pt.p !== property && pt.fp !== property) {
              pt = pt._next;
            }
          }
          if (!pt) {
            _forceAllPropTweens = 1;
            tween.vars[property] = "+=0";
            _initTween(tween, time);
            _forceAllPropTweens = 0;
            return skipRecursion ? _warn(property + " not eligible for reset") : 1;
          }
          ptCache.push(pt);
        }
      }
      i2 = ptCache.length;
      while (i2--) {
        rootPT = ptCache[i2];
        pt = rootPT._pt || rootPT;
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round$4(value) + getUnit(rootPT.e));
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b));
      }
    }, _addAliasesToVars = function _addAliasesToVars2(targets, vars) {
      var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p2, i2, aliases;
      if (!propertyAliases) {
        return vars;
      }
      copy = _merge({}, vars);
      for (p2 in propertyAliases) {
        if (p2 in copy) {
          aliases = propertyAliases[p2].split(",");
          i2 = aliases.length;
          while (i2--) {
            copy[aliases[i2]] = copy[p2];
          }
        }
      }
      return copy;
    }, _parseKeyframe = function _parseKeyframe2(prop, obj, allProps, easeEach) {
      var ease = obj.ease || easeEach || "power1.inOut", p2, a2;
      if (_isArray(obj)) {
        a2 = allProps[prop] || (allProps[prop] = []);
        obj.forEach(function(value, i2) {
          return a2.push({
            t: i2 / (obj.length - 1) * 100,
            v: value,
            e: ease
          });
        });
      } else {
        for (p2 in obj) {
          a2 = allProps[p2] || (allProps[p2] = []);
          p2 === "ease" || a2.push({
            t: parseFloat(prop),
            v: obj[p2],
            e: ease
          });
        }
      }
    }, _parseFuncOrString = function _parseFuncOrString2(value, tween, i2, target, targets) {
      return _isFunction$1(value) ? value.call(tween, i2, target, targets) : _isString$1(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
    }, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
    _forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
      return _staggerPropsToSkip[name] = 1;
    });
    var Tween = /* @__PURE__ */ function(_Animation2) {
      _inheritsLoose(Tween2, _Animation2);
      function Tween2(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
          position.duration = vars;
          vars = position;
          position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber$2(targets[0]) : "length" in vars) ? [targets] : toArray(targets), tl, i2, copy, l2, p2, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = [];
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
          vars = _this3.vars;
          tl = _this3.timeline = new Timeline({
            data: "nested",
            defaults: defaults || {},
            targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
          });
          tl.kill();
          tl.parent = tl._dp = _assertThisInitialized(_this3);
          tl._start = 0;
          if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            l2 = parsedTargets.length;
            staggerFunc = stagger && distribute(stagger);
            if (_isObject$1(stagger)) {
              for (p2 in stagger) {
                if (~_staggerTweenProps.indexOf(p2)) {
                  staggerVarsToMerge || (staggerVarsToMerge = {});
                  staggerVarsToMerge[p2] = stagger[p2];
                }
              }
            }
            for (i2 = 0; i2 < l2; i2++) {
              copy = _copyExcluding(vars, _staggerPropsToSkip);
              copy.stagger = 0;
              yoyoEase && (copy.yoyoEase = yoyoEase);
              staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
              curTarget = parsedTargets[i2];
              copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i2, curTarget, parsedTargets);
              copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i2, curTarget, parsedTargets) || 0) - _this3._delay;
              if (!stagger && l2 === 1 && copy.delay) {
                _this3._delay = delay = copy.delay;
                _this3._start += delay;
                copy.delay = 0;
              }
              tl.to(curTarget, copy, staggerFunc ? staggerFunc(i2, curTarget, parsedTargets) : 0);
              tl._ease = _easeMap.none;
            }
            tl.duration() ? duration = delay = 0 : _this3.timeline = 0;
          } else if (keyframes) {
            _inheritDefaults(_setDefaults$1(tl.vars.defaults, {
              ease: "none"
            }));
            tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
            var time = 0, a2, kf, v2;
            if (_isArray(keyframes)) {
              keyframes.forEach(function(frame) {
                return tl.to(parsedTargets, frame, ">");
              });
              tl.duration();
            } else {
              copy = {};
              for (p2 in keyframes) {
                p2 === "ease" || p2 === "easeEach" || _parseKeyframe(p2, keyframes[p2], copy, keyframes.easeEach);
              }
              for (p2 in copy) {
                a2 = copy[p2].sort(function(a3, b2) {
                  return a3.t - b2.t;
                });
                time = 0;
                for (i2 = 0; i2 < a2.length; i2++) {
                  kf = a2[i2];
                  v2 = {
                    ease: kf.e,
                    duration: (kf.t - (i2 ? a2[i2 - 1].t : 0)) / 100 * duration
                  };
                  v2[p2] = kf.v;
                  tl.to(parsedTargets, v2, time);
                  time += v2.duration;
                }
              }
              tl.duration() < duration && tl.to({}, {
                duration: duration - tl.duration()
              });
            }
          }
          duration || _this3.duration(duration = tl.duration());
        } else {
          _this3.timeline = 0;
        }
        if (overwrite === true && !_suppressOverwrites$1) {
          _overwritingTween = _assertThisInitialized(_this3);
          _globalTimeline.killTweensOf(parsedTargets);
          _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
          _this3._tTime = -_tinyNum;
          _this3.render(Math.max(0, -delay) || 0);
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
      }
      var _proto3 = Tween2.prototype;
      _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) {
          _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
          time = tTime;
          timeline = this.timeline;
          if (this._repeat) {
            cycleDuration = dur + this._rDelay;
            if (this._repeat < -1 && isNegative) {
              return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
            }
            time = _roundPrecise(tTime % cycleDuration);
            if (tTime === tDur) {
              iteration = this._repeat;
              time = dur;
            } else {
              prevIteration = _roundPrecise(tTime / cycleDuration);
              iteration = ~~prevIteration;
              if (iteration && iteration === prevIteration) {
                time = dur;
                iteration--;
              } else if (time > dur) {
                time = dur;
              }
            }
            isYoyo = this._yoyo && iteration & 1;
            if (isYoyo) {
              yoyoEase = this._yEase;
              time = dur - time;
            }
            prevIteration = _animationCycle(this._tTime, cycleDuration);
            if (time === prevTime && !force && this._initted && iteration === prevIteration) {
              this._tTime = tTime;
              return this;
            }
            if (iteration !== prevIteration) {
              timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo);
              if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                this._lock = force = 1;
                this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
              }
            }
          }
          if (!this._initted) {
            if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
              this._tTime = 0;
              return this;
            }
            if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) {
              return this;
            }
            if (dur !== this._dur) {
              return this.render(totalTime, suppressEvents, force);
            }
          }
          this._tTime = tTime;
          this._time = time;
          if (!this._act && this._ts) {
            this._act = 1;
            this._lazy = 0;
          }
          this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
          if (this._from) {
            this.ratio = ratio = 1 - ratio;
          }
          if (!prevTime && tTime && !suppressEvents && !prevIteration) {
            _callback$1(this, "onStart");
            if (this._tTime !== tTime) {
              return this;
            }
          }
          pt = this._pt;
          while (pt) {
            pt.r(ratio, pt.d);
            pt = pt._next;
          }
          timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
          if (this._onUpdate && !suppressEvents) {
            isNegative && _rewindStartAt(this, totalTime, suppressEvents, force);
            _callback$1(this, "onUpdate");
          }
          this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback$1(this, "onRepeat");
          if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
            isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
            (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);
            if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
              _callback$1(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
              this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
            }
          }
        }
        return this;
      };
      _proto3.targets = function targets() {
        return this._targets;
      };
      _proto3.invalidate = function invalidate(soft) {
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
      };
      _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur);
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) {
          return this.resetTo(property, value, start, startIsRelative, 1);
        }
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
      };
      _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) {
          vars = "all";
        }
        if (!targets && (!vars || vars === "all")) {
          this._lazy = this._pt = 0;
          this.parent ? _interrupt$1(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting$1);
          return this;
        }
        if (this.timeline) {
          var tDur = this.timeline.totalDuration();
          this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt$1(this);
          this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1);
          return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p2, pt, i2;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
          vars === "all" && (this._pt = 0);
          return _interrupt$1(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
          if (_isString$1(vars)) {
            p2 = {};
            _forEachName(vars, function(name) {
              return p2[name] = 1;
            });
            vars = p2;
          }
          vars = _addAliasesToVars(parsedTargets, vars);
        }
        i2 = parsedTargets.length;
        while (i2--) {
          if (~killingTargets.indexOf(parsedTargets[i2])) {
            curLookup = propTweenLookup[i2];
            if (vars === "all") {
              overwrittenProps[i2] = vars;
              props = curLookup;
              curOverwriteProps = {};
            } else {
              curOverwriteProps = overwrittenProps[i2] = overwrittenProps[i2] || {};
              props = vars;
            }
            for (p2 in props) {
              pt = curLookup && curLookup[p2];
              if (pt) {
                if (!("kill" in pt.d) || pt.d.kill(p2) === true) {
                  _removeLinkedListItem(this, pt, "_pt");
                }
                delete curLookup[p2];
              }
              if (curOverwriteProps !== "all") {
                curOverwriteProps[p2] = 1;
              }
            }
          }
        }
        this._initted && !this._pt && firstPT && _interrupt$1(this);
        return this;
      };
      Tween2.to = function to(targets, vars) {
        return new Tween2(targets, vars, arguments[2]);
      };
      Tween2.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
      };
      Tween2.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween2(callback, 0, {
          immediateRender: false,
          lazy: false,
          overwrite: false,
          delay,
          onComplete: callback,
          onReverseComplete: callback,
          onCompleteParams: params,
          onReverseCompleteParams: params,
          callbackScope: scope
        });
      };
      Tween2.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
      };
      Tween2.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween2(targets, vars);
      };
      Tween2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
      };
      return Tween2;
    }(Animation);
    _setDefaults$1(Tween.prototype, {
      _targets: [],
      _lazy: 0,
      _startAt: 0,
      _op: 0,
      _onInit: 0
    });
    _forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
      Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
      };
    });
    var _setterPlain = function _setterPlain2(target, property, value) {
      return target[property] = value;
    }, _setterFunc = function _setterFunc2(target, property, value) {
      return target[property](value);
    }, _setterFuncWithParam = function _setterFuncWithParam2(target, property, value, data) {
      return target[property](data.fp, value);
    }, _setterAttribute = function _setterAttribute2(target, property, value) {
      return target.setAttribute(property, value);
    }, _getSetter = function _getSetter2(target, property) {
      return _isFunction$1(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
    }, _renderPlain = function _renderPlain2(ratio, data) {
      return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1e6) / 1e6, data);
    }, _renderBoolean = function _renderBoolean2(ratio, data) {
      return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
    }, _renderComplexString = function _renderComplexString2(ratio, data) {
      var pt = data._pt, s2 = "";
      if (!ratio && data.b) {
        s2 = data.b;
      } else if (ratio === 1 && data.e) {
        s2 = data.e;
      } else {
        while (pt) {
          s2 = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 1e4) / 1e4) + s2;
          pt = pt._next;
        }
        s2 += data.c;
      }
      data.set(data.t, data.p, s2, data);
    }, _renderPropTweens = function _renderPropTweens2(ratio, data) {
      var pt = data._pt;
      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }
    }, _addPluginModifier = function _addPluginModifier2(modifier, tween, target, property) {
      var pt = this._pt, next;
      while (pt) {
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
      }
    }, _killPropTweensOf = function _killPropTweensOf2(property) {
      var pt = this._pt, hasNonDependentRemaining, next;
      while (pt) {
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) {
          _removeLinkedListItem(this, pt, "_pt");
        } else if (!pt.dep) {
          hasNonDependentRemaining = 1;
        }
        pt = next;
      }
      return !hasNonDependentRemaining;
    }, _setterWithModifier = function _setterWithModifier2(target, property, value, data) {
      data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
    }, _sortPropTweensByPriority = function _sortPropTweensByPriority2(parent) {
      var pt = parent._pt, next, pt2, first, last;
      while (pt) {
        next = pt._next;
        pt2 = first;
        while (pt2 && pt2.pr > pt.pr) {
          pt2 = pt2._next;
        }
        if (pt._prev = pt2 ? pt2._prev : last) {
          pt._prev._next = pt;
        } else {
          first = pt;
        }
        if (pt._next = pt2) {
          pt2._prev = pt;
        } else {
          last = pt;
        }
        pt = next;
      }
      parent._pt = first;
    };
    var PropTween = /* @__PURE__ */ function() {
      function PropTween2(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) {
          next._prev = this;
        }
      }
      var _proto4 = PropTween2.prototype;
      _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set;
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target;
        this.tween = tween;
      };
      return PropTween2;
    }();
    _forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
      return _reservedProps[name] = 1;
    });
    _globals.TweenMax = _globals.TweenLite = Tween;
    _globals.TimelineLite = _globals.TimelineMax = Timeline;
    _globalTimeline = new Timeline({
      sortChildren: false,
      defaults: _defaults$1,
      autoRemoveChildren: true,
      id: "root",
      smoothChildTiming: true
    });
    _config.stringFilter = _colorStringFilter;
    var _media = [], _listeners$1 = {}, _emptyArray$1 = [], _lastMediaTime = 0, _contextID = 0, _dispatch$1 = function _dispatch2(type) {
      return (_listeners$1[type] || _emptyArray$1).map(function(f2) {
        return f2();
      });
    }, _onMediaChange = function _onMediaChange2() {
      var time = Date.now(), matches = [];
      if (time - _lastMediaTime > 2) {
        _dispatch$1("matchMediaInit");
        _media.forEach(function(c2) {
          var queries = c2.queries, conditions = c2.conditions, match, p2, anyMatch, toggled;
          for (p2 in queries) {
            match = _win$4.matchMedia(queries[p2]).matches;
            match && (anyMatch = 1);
            if (match !== conditions[p2]) {
              conditions[p2] = match;
              toggled = 1;
            }
          }
          if (toggled) {
            c2.revert();
            anyMatch && matches.push(c2);
          }
        });
        _dispatch$1("matchMediaRevert");
        matches.forEach(function(c2) {
          return c2.onMatch(c2, function(func) {
            return c2.add(null, func);
          });
        });
        _lastMediaTime = time;
        _dispatch$1("matchMedia");
      }
    };
    var Context = /* @__PURE__ */ function() {
      function Context2(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = [];
        this.isReverted = false;
        this.id = _contextID++;
        func && this.add(func);
      }
      var _proto5 = Context2.prototype;
      _proto5.add = function add(name, func, scope) {
        if (_isFunction$1(name)) {
          scope = func;
          func = name;
          name = _isFunction$1;
        }
        var self = this, f2 = function f3() {
          var prev = _context$2, prevSelector = self.selector, result;
          prev && prev !== self && prev.data.push(self);
          scope && (self.selector = selector(scope));
          _context$2 = self;
          result = func.apply(self, arguments);
          _isFunction$1(result) && self._r.push(result);
          _context$2 = prev;
          self.selector = prevSelector;
          self.isReverted = false;
          return result;
        };
        self.last = f2;
        return name === _isFunction$1 ? f2(self, function(func2) {
          return self.add(null, func2);
        }) : name ? self[name] = f2 : f2;
      };
      _proto5.ignore = function ignore(func) {
        var prev = _context$2;
        _context$2 = null;
        func(this);
        _context$2 = prev;
      };
      _proto5.getTweens = function getTweens() {
        var a2 = [];
        this.data.forEach(function(e2) {
          return e2 instanceof Context2 ? a2.push.apply(a2, e2.getTweens()) : e2 instanceof Tween && !(e2.parent && e2.parent.data === "nested") && a2.push(e2);
        });
        return a2;
      };
      _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
      };
      _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) {
          (function() {
            var tweens = _this4.getTweens(), i3 = _this4.data.length, t2;
            while (i3--) {
              t2 = _this4.data[i3];
              if (t2.data === "isFlip") {
                t2.revert();
                t2.getChildren(true, true, false).forEach(function(tween) {
                  return tweens.splice(tweens.indexOf(tween), 1);
                });
              }
            }
            tweens.map(function(t3) {
              return {
                g: t3._dur || t3._delay || t3._sat && !t3._sat.vars.immediateRender ? t3.globalTime(0) : -Infinity,
                t: t3
              };
            }).sort(function(a2, b2) {
              return b2.g - a2.g || -Infinity;
            }).forEach(function(o2) {
              return o2.t.revert(revert);
            });
            i3 = _this4.data.length;
            while (i3--) {
              t2 = _this4.data[i3];
              if (t2 instanceof Timeline) {
                if (t2.data !== "nested") {
                  t2.scrollTrigger && t2.scrollTrigger.revert();
                  t2.kill();
                }
              } else {
                !(t2 instanceof Tween) && t2.revert && t2.revert(revert);
              }
            }
            _this4._r.forEach(function(f2) {
              return f2(revert, _this4);
            });
            _this4.isReverted = true;
          })();
        } else {
          this.data.forEach(function(e2) {
            return e2.kill && e2.kill();
          });
        }
        this.clear();
        if (matchMedia) {
          var i2 = _media.length;
          while (i2--) {
            _media[i2].id === this.id && _media.splice(i2, 1);
          }
        }
      };
      _proto5.revert = function revert(config) {
        this.kill(config || {});
      };
      return Context2;
    }();
    var MatchMedia = /* @__PURE__ */ function() {
      function MatchMedia2(scope) {
        this.contexts = [];
        this.scope = scope;
        _context$2 && _context$2.data.push(this);
      }
      var _proto6 = MatchMedia2.prototype;
      _proto6.add = function add(conditions, func, scope) {
        _isObject$1(conditions) || (conditions = {
          matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p2, active;
        _context$2 && !context.selector && (context.selector = _context$2.selector);
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for (p2 in conditions) {
          if (p2 === "all") {
            active = 1;
          } else {
            mq = _win$4.matchMedia(conditions[p2]);
            if (mq) {
              _media.indexOf(context) < 0 && _media.push(context);
              (cond[p2] = mq.matches) && (active = 1);
              mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
          }
        }
        active && func(context, function(f2) {
          return context.add(null, f2);
        });
        return this;
      };
      _proto6.revert = function revert(config) {
        this.kill(config || {});
      };
      _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c2) {
          return c2.kill(revert, true);
        });
      };
      return MatchMedia2;
    }();
    var _gsap = {
      registerPlugin: function registerPlugin() {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        args.forEach(function(config) {
          return _createPlugin(config);
        });
      },
      timeline: function timeline(vars) {
        return new Timeline(vars);
      },
      getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
      },
      getProperty: function getProperty(target, property, unit, uncache) {
        _isString$1(target) && (target = toArray(target)[0]);
        var getter = _getCache(target || {}).get, format = unit ? _passThrough$1 : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property2, unit2, uncache2) {
          return format((_plugins[property2] && _plugins[property2].get || getter)(target, property2, unit2, uncache2));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
      },
      quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
          var setters = target.map(function(t2) {
            return gsap$4.quickSetter(t2, property, unit);
          }), l2 = setters.length;
          return function(value) {
            var i2 = l2;
            while (i2--) {
              setters[i2](value);
            }
          };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p2 = cache.harness && (cache.harness.aliases || {})[property] || property, setter = Plugin ? function(value) {
          var p3 = new Plugin();
          _quickTween._pt = 0;
          p3.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
          p3.render(1, p3);
          _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p2);
        return Plugin ? setter : function(value) {
          return setter(target, p2, unit ? value + unit : value, cache, 1);
        };
      },
      quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap$4.to(target, _setDefaults$1((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func2(value, start, startIsRelative) {
          return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
      },
      isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
      },
      defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults$1.ease));
        return _mergeDeep(_defaults$1, value || {});
      },
      config: function config(value) {
        return _mergeDeep(_config, value || {});
      },
      registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
          return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
          return effect(toArray(targets), _setDefaults$1(vars || {}, defaults), tl);
        };
        if (extendTimeline) {
          Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject$1(vars) ? vars : (position = vars) && {}, this), position);
          };
        }
      },
      registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
      },
      parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
      },
      getById: function getById(id) {
        return _globalTimeline.getById(id);
      },
      exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) {
          vars = {};
        }
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0;
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while (child) {
          next = child._next;
          if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
            _addToTimeline(tl, child, child._start - child._delay);
          }
          child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
      },
      context: function context(func, scope) {
        return func ? new Context(func, scope) : _context$2;
      },
      matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
      },
      matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c2) {
          var cond = c2.conditions, found, p2;
          for (p2 in cond) {
            if (cond[p2]) {
              cond[p2] = false;
              found = 1;
            }
          }
          found && c2.revert();
        }) || _onMediaChange();
      },
      addEventListener: function addEventListener(type, callback) {
        var a2 = _listeners$1[type] || (_listeners$1[type] = []);
        ~a2.indexOf(callback) || a2.push(callback);
      },
      removeEventListener: function removeEventListener(type, callback) {
        var a2 = _listeners$1[type], i2 = a2 && a2.indexOf(callback);
        i2 >= 0 && a2.splice(i2, 1);
      },
      utils: {
        wrap,
        wrapYoyo,
        distribute,
        random,
        snap,
        normalize,
        getUnit,
        clamp: clamp$1,
        splitColor,
        toArray,
        selector,
        mapRange,
        pipe,
        unitize,
        interpolate,
        shuffle
      },
      install: _install,
      effects: _effects,
      ticker: _ticker,
      updateRoot: Timeline.updateRoot,
      plugins: _plugins,
      globalTimeline: _globalTimeline,
      core: {
        PropTween,
        globals: _addGlobal,
        Tween,
        Timeline,
        Animation,
        getCache: _getCache,
        _removeLinkedListItem,
        reverting: function reverting() {
          return _reverting$1;
        },
        context: function context(toAdd) {
          if (toAdd && _context$2) {
            _context$2.data.push(toAdd);
            toAdd._ctx = _context$2;
          }
          return _context$2;
        },
        suppressOverwrites: function suppressOverwrites(value) {
          return _suppressOverwrites$1 = value;
        }
      }
    };
    _forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
      return _gsap[name] = Tween[name];
    });
    _ticker.add(Timeline.updateRoot);
    _quickTween = _gsap.to({}, {
      duration: 0
    });
    var _getPluginPropTween = function _getPluginPropTween2(plugin, prop) {
      var pt = plugin._pt;
      while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
        pt = pt._next;
      }
      return pt;
    }, _addModifiers = function _addModifiers2(tween, modifiers) {
      var targets = tween._targets, p2, i2, pt;
      for (p2 in modifiers) {
        i2 = targets.length;
        while (i2--) {
          pt = tween._ptLookup[i2][p2];
          if (pt && (pt = pt.d)) {
            if (pt._pt) {
              pt = _getPluginPropTween(pt, p2);
            }
            pt && pt.modifier && pt.modifier(modifiers[p2], tween, targets[i2], p2);
          }
        }
      }
    }, _buildModifierPlugin = function _buildModifierPlugin2(name, modifier) {
      return {
        name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
          tween._onInit = function(tween2) {
            var temp, p2;
            if (_isString$1(vars)) {
              temp = {};
              _forEachName(vars, function(name2) {
                return temp[name2] = 1;
              });
              vars = temp;
            }
            if (modifier) {
              temp = {};
              for (p2 in vars) {
                temp[p2] = modifier(vars[p2]);
              }
              vars = temp;
            }
            _addModifiers(tween2, vars);
          };
        }
      };
    };
    var gsap$4 = _gsap.registerPlugin({
      name: "attr",
      init: function init(target, vars, tween, index, targets) {
        var p2, pt, v2;
        this.tween = tween;
        for (p2 in vars) {
          v2 = target.getAttribute(p2) || "";
          pt = this.add(target, "setAttribute", (v2 || 0) + "", vars[p2], index, targets, 0, 0, p2);
          pt.op = p2;
          pt.b = v2;
          this._props.push(p2);
        }
      },
      render: function render(ratio, data) {
        var pt = data._pt;
        while (pt) {
          _reverting$1 ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d);
          pt = pt._next;
        }
      }
    }, {
      name: "endArray",
      headless: 1,
      init: function init(target, value) {
        var i2 = value.length;
        while (i2--) {
          this.add(target, i2, target[i2] || 0, value[i2], 0, 0, 0, 0, 0, 1);
        }
      }
    }, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap;
    Tween.version = Timeline.version = gsap$4.version = "3.13.0";
    _coreReady = 1;
    _windowExists$2() && _wake();
    _easeMap.Power0;
    _easeMap.Power1;
    _easeMap.Power2;
    _easeMap.Power3;
    _easeMap.Power4;
    _easeMap.Linear;
    _easeMap.Quad;
    _easeMap.Cubic;
    _easeMap.Quart;
    _easeMap.Quint;
    _easeMap.Strong;
    _easeMap.Elastic;
    _easeMap.Back;
    _easeMap.SteppedEase;
    _easeMap.Bounce;
    _easeMap.Sine;
    _easeMap.Expo;
    _easeMap.Circ;
    /*!
     * CSSPlugin 3.13.0
     * https://gsap.com
     *
     * Copyright 2008-2025, GreenSock. All rights reserved.
     * Subject to the terms at https://gsap.com/standard-license
     * @author: Jack Doyle, jack@greensock.com
    */
    var _win$3, _doc$3, _docElement$1, _pluginInitted, _tempDiv, _recentSetterPlugin, _reverting, _windowExists$1 = function _windowExists2() {
      return typeof window !== "undefined";
    }, _transformProps = {}, _RAD2DEG$1 = 180 / Math.PI, _DEG2RAD$2 = Math.PI / 180, _atan2 = Math.atan2, _bigNum$1 = 1e8, _capsExp$1 = /([A-Z])/g, _horizontalExp = /(left|right|width|margin|padding|x)/i, _complexExp = /[\s,\(]\S/, _propertyAliases = {
      autoAlpha: "opacity,visibility",
      scale: "scaleX,scaleY",
      alpha: "opacity"
    }, _renderCSSProp = function _renderCSSProp2(ratio, data) {
      return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u, data);
    }, _renderPropWithEnd = function _renderPropWithEnd2(ratio, data) {
      return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u, data);
    }, _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning2(ratio, data) {
      return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 1e4) / 1e4 + data.u : data.b, data);
    }, _renderRoundedCSSProp = function _renderRoundedCSSProp2(ratio, data) {
      var value = data.s + data.c * ratio;
      data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : 0.5)) + data.u, data);
    }, _renderNonTweeningValue = function _renderNonTweeningValue2(ratio, data) {
      return data.set(data.t, data.p, ratio ? data.e : data.b, data);
    }, _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd2(ratio, data) {
      return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
    }, _setterCSSStyle = function _setterCSSStyle2(target, property, value) {
      return target.style[property] = value;
    }, _setterCSSProp = function _setterCSSProp2(target, property, value) {
      return target.style.setProperty(property, value);
    }, _setterTransform = function _setterTransform2(target, property, value) {
      return target._gsap[property] = value;
    }, _setterScale = function _setterScale2(target, property, value) {
      return target._gsap.scaleX = target._gsap.scaleY = value;
    }, _setterScaleWithRender = function _setterScaleWithRender2(target, property, value, data, ratio) {
      var cache = target._gsap;
      cache.scaleX = cache.scaleY = value;
      cache.renderTransform(ratio, cache);
    }, _setterTransformWithRender = function _setterTransformWithRender2(target, property, value, data, ratio) {
      var cache = target._gsap;
      cache[property] = value;
      cache.renderTransform(ratio, cache);
    }, _transformProp$2 = "transform", _transformOriginProp$1 = _transformProp$2 + "Origin", _saveStyle = function _saveStyle2(property, isNotCSS) {
      var _this = this;
      var target = this.target, style = target.style, cache = target._gsap;
      if (property in _transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
          property = _propertyAliases[property] || property;
          ~property.indexOf(",") ? property.split(",").forEach(function(a2) {
            return _this.tfm[a2] = _get(target, a2);
          }) : this.tfm[property] = cache.x ? cache[property] : _get(target, property);
          property === _transformOriginProp$1 && (this.tfm.zOrigin = cache.zOrigin);
        } else {
          return _propertyAliases.transform.split(",").forEach(function(p2) {
            return _saveStyle2.call(_this, p2, isNotCSS);
          });
        }
        if (this.props.indexOf(_transformProp$2) >= 0) {
          return;
        }
        if (cache.svg) {
          this.svgo = target.getAttribute("data-svg-origin");
          this.props.push(_transformOriginProp$1, isNotCSS, "");
        }
        property = _transformProp$2;
      }
      (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
    }, _removeIndependentTransforms = function _removeIndependentTransforms2(style) {
      if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
      }
    }, _revertStyle = function _revertStyle2() {
      var props = this.props, target = this.target, style = target.style, cache = target._gsap, i2, p2;
      for (i2 = 0; i2 < props.length; i2 += 3) {
        if (!props[i2 + 1]) {
          props[i2 + 2] ? style[props[i2]] = props[i2 + 2] : style.removeProperty(props[i2].substr(0, 2) === "--" ? props[i2] : props[i2].replace(_capsExp$1, "-$1").toLowerCase());
        } else if (props[i2 + 1] === 2) {
          target[props[i2]](props[i2 + 2]);
        } else {
          target[props[i2]] = props[i2 + 2];
        }
      }
      if (this.tfm) {
        for (p2 in this.tfm) {
          cache[p2] = this.tfm[p2];
        }
        if (cache.svg) {
          cache.renderTransform();
          target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i2 = _reverting();
        if ((!i2 || !i2.isStart) && !style[_transformProp$2]) {
          _removeIndependentTransforms(style);
          if (cache.zOrigin && style[_transformOriginProp$1]) {
            style[_transformOriginProp$1] += " " + cache.zOrigin + "px";
            cache.zOrigin = 0;
            cache.renderTransform();
          }
          cache.uncache = 1;
        }
      }
    }, _getStyleSaver$1 = function _getStyleSaver2(target, properties) {
      var saver = {
        target,
        props: [],
        revert: _revertStyle,
        save: _saveStyle
      };
      target._gsap || gsap$4.core.getCache(target);
      properties && target.style && target.nodeType && properties.split(",").forEach(function(p2) {
        return saver.save(p2);
      });
      return saver;
    }, _supports3D, _createElement = function _createElement2(type, ns) {
      var e2 = _doc$3.createElementNS ? _doc$3.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc$3.createElement(type);
      return e2 && e2.style ? e2 : _doc$3.createElement(type);
    }, _getComputedProperty = function _getComputedProperty2(target, property, skipPrefixFallback) {
      var cs = getComputedStyle(target);
      return cs[property] || cs.getPropertyValue(property.replace(_capsExp$1, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty2(target, _checkPropPrefix(property) || property, 1) || "";
    }, _prefixes = "O,Moz,ms,Ms,Webkit".split(","), _checkPropPrefix = function _checkPropPrefix2(property, element, preferPrefix) {
      var e2 = element || _tempDiv, s2 = e2.style, i2 = 5;
      if (property in s2 && !preferPrefix) {
        return property;
      }
      property = property.charAt(0).toUpperCase() + property.substr(1);
      while (i2-- && !(_prefixes[i2] + property in s2)) {
      }
      return i2 < 0 ? null : (i2 === 3 ? "ms" : i2 >= 0 ? _prefixes[i2] : "") + property;
    }, _initCore$2 = function _initCore2() {
      if (_windowExists$1() && window.document) {
        _win$3 = window;
        _doc$3 = _win$3.document;
        _docElement$1 = _doc$3.documentElement;
        _tempDiv = _createElement("div") || {
          style: {}
        };
        _createElement("div");
        _transformProp$2 = _checkPropPrefix(_transformProp$2);
        _transformOriginProp$1 = _transformProp$2 + "Origin";
        _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0";
        _supports3D = !!_checkPropPrefix("perspective");
        _reverting = gsap$4.core.reverting;
        _pluginInitted = 1;
      }
    }, _getReparentedCloneBBox = function _getReparentedCloneBBox2(target) {
      var owner = target.ownerSVGElement, svg = _createElement("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
      clone.style.display = "block";
      svg.appendChild(clone);
      _docElement$1.appendChild(svg);
      try {
        bbox = clone.getBBox();
      } catch (e2) {
      }
      svg.removeChild(clone);
      _docElement$1.removeChild(svg);
      return bbox;
    }, _getAttributeFallbacks = function _getAttributeFallbacks2(target, attributesArray) {
      var i2 = attributesArray.length;
      while (i2--) {
        if (target.hasAttribute(attributesArray[i2])) {
          return target.getAttribute(attributesArray[i2]);
        }
      }
    }, _getBBox = function _getBBox2(target) {
      var bounds, cloned;
      try {
        bounds = target.getBBox();
      } catch (error) {
        bounds = _getReparentedCloneBBox(target);
        cloned = 1;
      }
      bounds && (bounds.width || bounds.height) || cloned || (bounds = _getReparentedCloneBBox(target));
      return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
        y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
        width: 0,
        height: 0
      } : bounds;
    }, _isSVG = function _isSVG2(e2) {
      return !!(e2.getCTM && (!e2.parentNode || e2.ownerSVGElement) && _getBBox(e2));
    }, _removeProperty = function _removeProperty2(target, property) {
      if (property) {
        var style = target.style, first2Chars;
        if (property in _transformProps && property !== _transformOriginProp$1) {
          property = _transformProp$2;
        }
        if (style.removeProperty) {
          first2Chars = property.substr(0, 2);
          if (first2Chars === "ms" || property.substr(0, 6) === "webkit") {
            property = "-" + property;
          }
          style.removeProperty(first2Chars === "--" ? property : property.replace(_capsExp$1, "-$1").toLowerCase());
        } else {
          style.removeAttribute(property);
        }
      }
    }, _addNonTweeningPT = function _addNonTweeningPT2(plugin, target, property, beginning, end, onlySetAtEnd) {
      var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
      plugin._pt = pt;
      pt.b = beginning;
      pt.e = end;
      plugin._props.push(property);
      return pt;
    }, _nonConvertibleUnits = {
      deg: 1,
      rad: 1,
      turn: 1
    }, _nonStandardLayouts = {
      grid: 1,
      flex: 1
    }, _convertToUnit = function _convertToUnit2(target, property, value, unit) {
      var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", style = _tempDiv.style, horizontal = _horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
      if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
        return curValue;
      }
      curUnit !== "px" && !toPixels && (curValue = _convertToUnit2(target, property, value, "px"));
      isSVG = target.getCTM && _isSVG(target);
      if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return _round$4(toPercent ? curValue / px * amount : curValue / 100 * px);
      }
      style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
      parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
      if (isSVG) {
        parent = (target.ownerSVGElement || {}).parentNode;
      }
      if (!parent || parent === _doc$3 || !parent.appendChild) {
        parent = _doc$3.body;
      }
      cache = parent._gsap;
      if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time && !cache.uncache) {
        return _round$4(curValue / cache.width * amount);
      } else {
        if (toPercent && (property === "height" || property === "width")) {
          var v2 = target.style[property];
          target.style[property] = amount + unit;
          px = target[measureProperty];
          v2 ? target.style[property] = v2 : _removeProperty(target, property);
        } else {
          (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
          parent === target && (style.position = "static");
          parent.appendChild(_tempDiv);
          px = _tempDiv[measureProperty];
          parent.removeChild(_tempDiv);
          style.position = "absolute";
        }
        if (horizontal && toPercent) {
          cache = _getCache(parent);
          cache.time = _ticker.time;
          cache.width = parent[measureProperty];
        }
      }
      return _round$4(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
    }, _get = function _get2(target, property, unit, uncache) {
      var value;
      _pluginInitted || _initCore$2();
      if (property in _propertyAliases && property !== "transform") {
        property = _propertyAliases[property];
        if (~property.indexOf(",")) {
          property = property.split(",")[0];
        }
      }
      if (_transformProps[property] && property !== "transform") {
        value = _parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp$1)) + " " + value.zOrigin + "px";
      } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
          value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0);
        }
      }
      return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
    }, _tweenComplexCSSString = function _tweenComplexCSSString2(target, prop, start, end) {
      if (!start || start === "none") {
        var p2 = _checkPropPrefix(prop, target, 1), s2 = p2 && _getComputedProperty(target, p2, 1);
        if (s2 && s2 !== start) {
          prop = p2;
          start = s2;
        } else if (prop === "borderColor") {
          start = _getComputedProperty(target, "borderTopColor");
        }
      }
      var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString), index = 0, matchIndex = 0, a2, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
      pt.b = start;
      pt.e = end;
      start += "";
      end += "";
      if (end.substring(0, 6) === "var(--") {
        end = _getComputedProperty(target, end.substring(4, end.indexOf(")")));
      }
      if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = _getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : _removeProperty(target, prop);
      }
      a2 = [start, end];
      _colorStringFilter(a2);
      start = a2[0];
      end = a2[1];
      startValues = start.match(_numWithUnitExp) || [];
      endValues = end.match(_numWithUnitExp) || [];
      if (endValues.length) {
        while (result = _numWithUnitExp.exec(end)) {
          endValue = result[0];
          chunk = end.substring(index, result.index);
          if (color) {
            color = (color + 1) % 5;
          } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
            color = 1;
          }
          if (endValue !== (startValue = startValues[matchIndex++] || "")) {
            startNum = parseFloat(startValue) || 0;
            startUnit = startValue.substr((startNum + "").length);
            endValue.charAt(1) === "=" && (endValue = _parseRelative(startNum, endValue) + startUnit);
            endNum = parseFloat(endValue);
            endUnit = endValue.substr((endNum + "").length);
            index = _numWithUnitExp.lastIndex - endUnit.length;
            if (!endUnit) {
              endUnit = endUnit || _config.units[prop] || startUnit;
              if (index === end.length) {
                end += endUnit;
                pt.e += endUnit;
              }
            }
            if (startUnit !== endUnit) {
              startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
            }
            pt._pt = {
              _next: pt._pt,
              p: chunk || matchIndex === 1 ? chunk : ",",
              //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
              s: startNum,
              c: endNum - startNum,
              m: color && color < 4 || prop === "zIndex" ? Math.round : 0
            };
          }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : "";
      } else {
        pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
      }
      _relExp.test(end) && (pt.e = 0);
      this._pt = pt;
      return pt;
    }, _keywordToPercent = {
      top: "0%",
      bottom: "100%",
      left: "0%",
      right: "100%",
      center: "50%"
    }, _convertKeywordsToPercentages = function _convertKeywordsToPercentages2(value) {
      var split = value.split(" "), x2 = split[0], y2 = split[1] || "50%";
      if (x2 === "top" || x2 === "bottom" || y2 === "left" || y2 === "right") {
        value = x2;
        x2 = y2;
        y2 = value;
      }
      split[0] = _keywordToPercent[x2] || x2;
      split[1] = _keywordToPercent[y2] || y2;
      return split.join(" ");
    }, _renderClearProps = function _renderClearProps2(ratio, data) {
      if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i2;
        if (props === "all" || props === true) {
          style.cssText = "";
          clearTransforms = 1;
        } else {
          props = props.split(",");
          i2 = props.length;
          while (--i2 > -1) {
            prop = props[i2];
            if (_transformProps[prop]) {
              clearTransforms = 1;
              prop = prop === "transformOrigin" ? _transformOriginProp$1 : _transformProp$2;
            }
            _removeProperty(target, prop);
          }
        }
        if (clearTransforms) {
          _removeProperty(target, _transformProp$2);
          if (cache) {
            cache.svg && target.removeAttribute("transform");
            style.scale = style.rotate = style.translate = "none";
            _parseTransform(target, 1);
            cache.uncache = 1;
            _removeIndependentTransforms(style);
          }
        }
      }
    }, _specialProps = {
      clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
          var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
          pt.u = endValue;
          pt.pr = -10;
          pt.tween = tween;
          plugin._props.push(property);
          return 1;
        }
      }
      /* className feature (about 0.4kb gzipped).
      , className(plugin, target, property, endValue, tween) {
      	let _renderClassName = (ratio, data) => {
      			data.css.render(ratio, data.css);
      			if (!ratio || ratio === 1) {
      				let inline = data.rmv,
      					target = data.t,
      					p;
      				target.setAttribute("class", ratio ? data.e : data.b);
      				for (p in inline) {
      					_removeProperty(target, p);
      				}
      			}
      		},
      		_getAllStyles = (target) => {
      			let styles = {},
      				computed = getComputedStyle(target),
      				p;
      			for (p in computed) {
      				if (isNaN(p) && p !== "cssText" && p !== "length") {
      					styles[p] = computed[p];
      				}
      			}
      			_setDefaults(styles, _parseTransform(target, 1));
      			return styles;
      		},
      		startClassList = target.getAttribute("class"),
      		style = target.style,
      		cssText = style.cssText,
      		cache = target._gsap,
      		classPT = cache.classPT,
      		inlineToRemoveAtEnd = {},
      		data = {t:target, plugin:plugin, rmv:inlineToRemoveAtEnd, b:startClassList, e:(endValue.charAt(1) !== "=") ? endValue : startClassList.replace(new RegExp("(?:\\s|^)" + endValue.substr(2) + "(?![\\w-])"), "") + ((endValue.charAt(0) === "+") ? " " + endValue.substr(2) : "")},
      		changingVars = {},
      		startVars = _getAllStyles(target),
      		transformRelated = /(transform|perspective)/i,
      		endVars, p;
      	if (classPT) {
      		classPT.r(1, classPT.d);
      		_removeLinkedListItem(classPT.d.plugin, classPT, "_pt");
      	}
      	target.setAttribute("class", data.e);
      	endVars = _getAllStyles(target, true);
      	target.setAttribute("class", startClassList);
      	for (p in endVars) {
      		if (endVars[p] !== startVars[p] && !transformRelated.test(p)) {
      			changingVars[p] = endVars[p];
      			if (!style[p] && style[p] !== "0") {
      				inlineToRemoveAtEnd[p] = 1;
      			}
      		}
      	}
      	cache.classPT = plugin._pt = new PropTween(plugin._pt, target, "className", 0, 0, _renderClassName, data, 0, -11);
      	if (style.cssText !== cssText) { //only apply if things change. Otherwise, in cases like a background-image that's pulled dynamically, it could cause a refresh. See https://gsap.com/forums/topic/20368-possible-gsap-bug-switching-classnames-in-chrome/.
      		style.cssText = cssText; //we recorded cssText before we swapped classes and ran _getAllStyles() because in cases when a className tween is overwritten, we remove all the related tweening properties from that class change (otherwise class-specific stuff can't override properties we've directly set on the target's style object due to specificity).
      	}
      	_parseTransform(target, true); //to clear the caching of transforms
      	data.css = new gsap.plugins.css();
      	data.css.init(target, changingVars, tween);
      	plugin._props.push(...data.css._props);
      	return 1;
      }
      */
    }, _identity2DMatrix = [1, 0, 0, 1, 0, 0], _rotationalProperties = {}, _isNullTransform = function _isNullTransform2(value) {
      return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
    }, _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray2(target) {
      var matrixString = _getComputedProperty(target, _transformProp$2);
      return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp$1).map(_round$4);
    }, _getMatrix = function _getMatrix2(target, force2D) {
      var cache = target._gsap || _getCache(target), style = target.style, matrix = _getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
      if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix;
        matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
        return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
      } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement$1 && !cache.svg) {
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
          addedToDOM = 1;
          nextSibling = target.nextElementSibling;
          _docElement$1.appendChild(target);
        }
        matrix = _getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : _removeProperty(target, "display");
        if (addedToDOM) {
          nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement$1.removeChild(target);
        }
      }
      return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
    }, _applySVGOrigin = function _applySVGOrigin2(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
      var cache = target._gsap, matrix = matrixArray || _getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a2 = matrix[0], b2 = matrix[1], c2 = matrix[2], d2 = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x2, y2;
      if (!originIsAbsolute) {
        bounds = _getBBox(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
      } else if (matrix !== _identity2DMatrix && (determinant = a2 * d2 - b2 * c2)) {
        x2 = xOrigin * (d2 / determinant) + yOrigin * (-c2 / determinant) + (c2 * ty - d2 * tx) / determinant;
        y2 = xOrigin * (-b2 / determinant) + yOrigin * (a2 / determinant) - (a2 * ty - b2 * tx) / determinant;
        xOrigin = x2;
        yOrigin = y2;
      }
      if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a2 + ty * c2) - tx;
        cache.yOffset = yOffsetOld + (tx * b2 + ty * d2) - ty;
      } else {
        cache.xOffset = cache.yOffset = 0;
      }
      cache.xOrigin = xOrigin;
      cache.yOrigin = yOrigin;
      cache.smooth = !!smooth;
      cache.origin = origin;
      cache.originIsAbsolute = !!originIsAbsolute;
      target.style[_transformOriginProp$1] = "0px 0px";
      if (pluginToAddPropTweensTo) {
        _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
      }
      target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
    }, _parseTransform = function _parseTransform2(target, uncache) {
      var cache = target._gsap || new GSCache(target);
      if ("x" in cache && !uncache && !cache.uncache) {
        return cache;
      }
      var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = _getComputedProperty(target, _transformOriginProp$1) || "0", x2, y2, z2, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a2, b2, c2, d2, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
      x2 = y2 = z2 = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
      scaleX = scaleY = 1;
      cache.svg = !!(target.getCTM && _isSVG(target));
      if (cs.translate) {
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") {
          style[_transformProp$2] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp$2] !== "none" ? cs[_transformProp$2] : "");
        }
        style.scale = style.rotate = style.translate = "none";
      }
      matrix = _getMatrix(target, cache.svg);
      if (cache.svg) {
        if (cache.uncache) {
          t2 = target.getBBox();
          origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
          t1 = "";
        } else {
          t1 = !uncache && target.getAttribute("data-svg-origin");
        }
        _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
      }
      xOrigin = cache.xOrigin || 0;
      yOrigin = cache.yOrigin || 0;
      if (matrix !== _identity2DMatrix) {
        a2 = matrix[0];
        b2 = matrix[1];
        c2 = matrix[2];
        d2 = matrix[3];
        x2 = a12 = matrix[4];
        y2 = a22 = matrix[5];
        if (matrix.length === 6) {
          scaleX = Math.sqrt(a2 * a2 + b2 * b2);
          scaleY = Math.sqrt(d2 * d2 + c2 * c2);
          rotation = a2 || b2 ? _atan2(b2, a2) * _RAD2DEG$1 : 0;
          skewX = c2 || d2 ? _atan2(c2, d2) * _RAD2DEG$1 + rotation : 0;
          skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD$2)));
          if (cache.svg) {
            x2 -= xOrigin - (xOrigin * a2 + yOrigin * c2);
            y2 -= yOrigin - (xOrigin * b2 + yOrigin * d2);
          }
        } else {
          a32 = matrix[6];
          a42 = matrix[7];
          a13 = matrix[8];
          a23 = matrix[9];
          a33 = matrix[10];
          a43 = matrix[11];
          x2 = matrix[12];
          y2 = matrix[13];
          z2 = matrix[14];
          angle = _atan2(a32, a33);
          rotationX = angle * _RAD2DEG$1;
          if (angle) {
            cos = Math.cos(-angle);
            sin = Math.sin(-angle);
            t1 = a12 * cos + a13 * sin;
            t2 = a22 * cos + a23 * sin;
            t3 = a32 * cos + a33 * sin;
            a13 = a12 * -sin + a13 * cos;
            a23 = a22 * -sin + a23 * cos;
            a33 = a32 * -sin + a33 * cos;
            a43 = a42 * -sin + a43 * cos;
            a12 = t1;
            a22 = t2;
            a32 = t3;
          }
          angle = _atan2(-c2, a33);
          rotationY = angle * _RAD2DEG$1;
          if (angle) {
            cos = Math.cos(-angle);
            sin = Math.sin(-angle);
            t1 = a2 * cos - a13 * sin;
            t2 = b2 * cos - a23 * sin;
            t3 = c2 * cos - a33 * sin;
            a43 = d2 * sin + a43 * cos;
            a2 = t1;
            b2 = t2;
            c2 = t3;
          }
          angle = _atan2(b2, a2);
          rotation = angle * _RAD2DEG$1;
          if (angle) {
            cos = Math.cos(angle);
            sin = Math.sin(angle);
            t1 = a2 * cos + b2 * sin;
            t2 = a12 * cos + a22 * sin;
            b2 = b2 * cos - a2 * sin;
            a22 = a22 * cos - a12 * sin;
            a2 = t1;
            a12 = t2;
          }
          if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
            rotationX = rotation = 0;
            rotationY = 180 - rotationY;
          }
          scaleX = _round$4(Math.sqrt(a2 * a2 + b2 * b2 + c2 * c2));
          scaleY = _round$4(Math.sqrt(a22 * a22 + a32 * a32));
          angle = _atan2(a12, a22);
          skewX = Math.abs(angle) > 2e-4 ? angle * _RAD2DEG$1 : 0;
          perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
          t1 = target.getAttribute("transform");
          cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp$2));
          t1 && target.setAttribute("transform", t1);
        }
      }
      if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
          scaleX *= -1;
          skewX += rotation <= 0 ? 180 : -180;
          rotation += rotation <= 0 ? 180 : -180;
        } else {
          scaleY *= -1;
          skewX += skewX <= 0 ? 180 : -180;
        }
      }
      uncache = uncache || cache.uncache;
      cache.x = x2 - ((cache.xPercent = x2 && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x2) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
      cache.y = y2 - ((cache.yPercent = y2 && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y2) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
      cache.z = z2 + px;
      cache.scaleX = _round$4(scaleX);
      cache.scaleY = _round$4(scaleY);
      cache.rotation = _round$4(rotation) + deg;
      cache.rotationX = _round$4(rotationX) + deg;
      cache.rotationY = _round$4(rotationY) + deg;
      cache.skewX = skewX + deg;
      cache.skewY = skewY + deg;
      cache.transformPerspective = perspective + px;
      if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) {
        style[_transformOriginProp$1] = _firstTwoOnly(origin);
      }
      cache.xOffset = cache.yOffset = 0;
      cache.force3D = _config.force3D;
      cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
      cache.uncache = 0;
      return cache;
    }, _firstTwoOnly = function _firstTwoOnly2(value) {
      return (value = value.split(" "))[0] + " " + value[1];
    }, _addPxTranslate = function _addPxTranslate2(target, start, value) {
      var unit = getUnit(start);
      return _round$4(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
    }, _renderNon3DTransforms = function _renderNon3DTransforms2(ratio, cache) {
      cache.z = "0px";
      cache.rotationY = cache.rotationX = "0deg";
      cache.force3D = 0;
      _renderCSSTransforms(ratio, cache);
    }, _zeroDeg = "0deg", _zeroPx = "0px", _endParenthesis = ") ", _renderCSSTransforms = function _renderCSSTransforms2(ratio, cache) {
      var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x2 = _ref.x, y2 = _ref.y, z2 = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true;
      if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
        var angle = parseFloat(rotationY) * _DEG2RAD$2, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * _DEG2RAD$2;
        cos = Math.cos(angle);
        x2 = _addPxTranslate(target, x2, a13 * cos * -zOrigin);
        y2 = _addPxTranslate(target, y2, -Math.sin(angle) * -zOrigin);
        z2 = _addPxTranslate(target, z2, a33 * cos * -zOrigin + zOrigin);
      }
      if (transformPerspective !== _zeroPx) {
        transforms += "perspective(" + transformPerspective + _endParenthesis;
      }
      if (xPercent || yPercent) {
        transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
      }
      if (use3D || x2 !== _zeroPx || y2 !== _zeroPx || z2 !== _zeroPx) {
        transforms += z2 !== _zeroPx || use3D ? "translate3d(" + x2 + ", " + y2 + ", " + z2 + ") " : "translate(" + x2 + ", " + y2 + _endParenthesis;
      }
      if (rotation !== _zeroDeg) {
        transforms += "rotate(" + rotation + _endParenthesis;
      }
      if (rotationY !== _zeroDeg) {
        transforms += "rotateY(" + rotationY + _endParenthesis;
      }
      if (rotationX !== _zeroDeg) {
        transforms += "rotateX(" + rotationX + _endParenthesis;
      }
      if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
        transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
      }
      if (scaleX !== 1 || scaleY !== 1) {
        transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
      }
      target.style[_transformProp$2] = transforms || "translate(0, 0)";
    }, _renderSVGTransforms = function _renderSVGTransforms2(ratio, cache) {
      var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x2 = _ref2.x, y2 = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x2), ty = parseFloat(y2), a11, a21, a12, a22, temp;
      rotation = parseFloat(rotation);
      skewX = parseFloat(skewX);
      skewY = parseFloat(skewY);
      if (skewY) {
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
      }
      if (rotation || skewX) {
        rotation *= _DEG2RAD$2;
        skewX *= _DEG2RAD$2;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
          skewY *= _DEG2RAD$2;
          temp = Math.tan(skewX - skewY);
          temp = Math.sqrt(1 + temp * temp);
          a12 *= temp;
          a22 *= temp;
          if (skewY) {
            temp = Math.tan(skewY);
            temp = Math.sqrt(1 + temp * temp);
            a11 *= temp;
            a21 *= temp;
          }
        }
        a11 = _round$4(a11);
        a21 = _round$4(a21);
        a12 = _round$4(a12);
        a22 = _round$4(a22);
      } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
      }
      if (tx && !~(x2 + "").indexOf("px") || ty && !~(y2 + "").indexOf("px")) {
        tx = _convertToUnit(target, "x", x2, "px");
        ty = _convertToUnit(target, "y", y2, "px");
      }
      if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = _round$4(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = _round$4(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
      }
      if (xPercent || yPercent) {
        temp = target.getBBox();
        tx = _round$4(tx + xPercent / 100 * temp.width);
        ty = _round$4(ty + yPercent / 100 * temp.height);
      }
      temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
      target.setAttribute("transform", temp);
      forceCSS && (target.style[_transformProp$2] = temp);
    }, _addRotationalPropTween = function _addRotationalPropTween2(plugin, target, property, startNum, endValue) {
      var cap = 360, isString = _isString$1(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG$1 : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
      if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
          change %= cap;
          if (change !== change % (cap / 2)) {
            change += change < 0 ? cap : -cap;
          }
        }
        if (direction === "cw" && change < 0) {
          change = (change + cap * _bigNum$1) % cap - ~~(change / cap) * cap;
        } else if (direction === "ccw" && change > 0) {
          change = (change - cap * _bigNum$1) % cap - ~~(change / cap) * cap;
        }
      }
      plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
      pt.e = finalValue;
      pt.u = "deg";
      plugin._props.push(property);
      return pt;
    }, _assign = function _assign2(target, source) {
      for (var p2 in source) {
        target[p2] = source[p2];
      }
      return target;
    }, _addRawTransformPTs = function _addRawTransformPTs2(plugin, transforms, target) {
      var startCache = _assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p2, startValue, endValue, startNum, endNum, startUnit, endUnit;
      if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[_transformProp$2] = transforms;
        endCache = _parseTransform(target, 1);
        _removeProperty(target, _transformProp$2);
        target.setAttribute("transform", startValue);
      } else {
        startValue = getComputedStyle(target)[_transformProp$2];
        style[_transformProp$2] = transforms;
        endCache = _parseTransform(target, 1);
        style[_transformProp$2] = startValue;
      }
      for (p2 in _transformProps) {
        startValue = startCache[p2];
        endValue = endCache[p2];
        if (startValue !== endValue && exclude.indexOf(p2) < 0) {
          startUnit = getUnit(startValue);
          endUnit = getUnit(endValue);
          startNum = startUnit !== endUnit ? _convertToUnit(target, p2, startValue, endUnit) : parseFloat(startValue);
          endNum = parseFloat(endValue);
          plugin._pt = new PropTween(plugin._pt, endCache, p2, startNum, endNum - startNum, _renderCSSProp);
          plugin._pt.u = endUnit || 0;
          plugin._props.push(p2);
        }
      }
      _assign(endCache, startCache);
    };
    _forEachName("padding,margin,Width,Radius", function(name, index) {
      var t2 = "Top", r2 = "Right", b2 = "Bottom", l2 = "Left", props = (index < 3 ? [t2, r2, b2, l2] : [t2 + l2, t2 + r2, b2 + r2, b2 + l2]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
      });
      _specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a2, vars;
        if (arguments.length < 4) {
          a2 = props.map(function(prop) {
            return _get(plugin, prop, property);
          });
          vars = a2.join(" ");
          return vars.split(a2[0]).length === 5 ? a2[0] : vars;
        }
        a2 = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i2) {
          return vars[prop] = a2[i2] = a2[i2] || a2[(i2 - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
      };
    });
    var CSSPlugin = {
      name: "css",
      register: _initCore$2,
      targetTest: function targetTest(target) {
        return target.style && target.nodeType;
      },
      init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p2, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps;
        _pluginInitted || _initCore$2();
        this.styles = this.styles || _getStyleSaver$1(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for (p2 in vars) {
          if (p2 === "autoRound") {
            continue;
          }
          endValue = vars[p2];
          if (_plugins[p2] && _checkPlugin(p2, vars, tween, index, target, targets)) {
            continue;
          }
          type = typeof endValue;
          specialProp = _specialProps[p2];
          if (type === "function") {
            endValue = endValue.call(tween, index, target, targets);
            type = typeof endValue;
          }
          if (type === "string" && ~endValue.indexOf("random(")) {
            endValue = _replaceRandom(endValue);
          }
          if (specialProp) {
            specialProp(this, target, p2, endValue, tween) && (hasPriority = 1);
          } else if (p2.substr(0, 2) === "--") {
            startValue = (getComputedStyle(target).getPropertyValue(p2) + "").trim();
            endValue += "";
            _colorExp.lastIndex = 0;
            if (!_colorExp.test(startValue)) {
              startUnit = getUnit(startValue);
              endUnit = getUnit(endValue);
            }
            endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p2, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
            this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p2);
            props.push(p2);
            inlineProps.push(p2, 0, style[p2]);
          } else if (type !== "undefined") {
            if (startAt && p2 in startAt) {
              startValue = typeof startAt[p2] === "function" ? startAt[p2].call(tween, index, target, targets) : startAt[p2];
              _isString$1(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
              getUnit(startValue + "") || startValue === "auto" || (startValue += _config.units[p2] || getUnit(_get(target, p2)) || "");
              (startValue + "").charAt(1) === "=" && (startValue = _get(target, p2));
            } else {
              startValue = _get(target, p2);
            }
            startNum = parseFloat(startValue);
            relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
            relative && (endValue = endValue.substr(2));
            endNum = parseFloat(endValue);
            if (p2 in _propertyAliases) {
              if (p2 === "autoAlpha") {
                if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
                  startNum = 0;
                }
                inlineProps.push("visibility", 0, style.visibility);
                _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
              }
              if (p2 !== "scale" && p2 !== "transform") {
                p2 = _propertyAliases[p2];
                ~p2.indexOf(",") && (p2 = p2.split(",")[0]);
              }
            }
            isTransformRelated = p2 in _transformProps;
            if (isTransformRelated) {
              this.styles.save(p2);
              if (type === "string" && endValue.substring(0, 6) === "var(--") {
                endValue = _getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                endNum = parseFloat(endValue);
              }
              if (!transformPropTween) {
                cache = target._gsap;
                cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform);
                smooth = vars.smoothOrigin !== false && cache.smooth;
                transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp$2, 0, 1, cache.renderTransform, cache, 0, -1);
                transformPropTween.dep = 1;
              }
              if (p2 === "scale") {
                this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? _parseRelative(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
                this._pt.u = 0;
                props.push("scaleY", p2);
                p2 += "X";
              } else if (p2 === "transformOrigin") {
                inlineProps.push(_transformOriginProp$1, 0, style[_transformOriginProp$1]);
                endValue = _convertKeywordsToPercentages(endValue);
                if (cache.svg) {
                  _applySVGOrigin(target, endValue, 0, smooth, 0, this);
                } else {
                  endUnit = parseFloat(endValue.split(" ")[2]) || 0;
                  endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                  _addNonTweeningPT(this, style, p2, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
                }
                continue;
              } else if (p2 === "svgOrigin") {
                _applySVGOrigin(target, endValue, 1, smooth, 0, this);
                continue;
              } else if (p2 in _rotationalProperties) {
                _addRotationalPropTween(this, cache, p2, startNum, relative ? _parseRelative(startNum, relative + endValue) : endValue);
                continue;
              } else if (p2 === "smoothOrigin") {
                _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                continue;
              } else if (p2 === "force3D") {
                cache[p2] = endValue;
                continue;
              } else if (p2 === "transform") {
                _addRawTransformPTs(this, endValue, target);
                continue;
              }
            } else if (!(p2 in style)) {
              p2 = _checkPropPrefix(p2) || p2;
            }
            if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p2 in style) {
              startUnit = (startValue + "").substr((startNum + "").length);
              endNum || (endNum = 0);
              endUnit = getUnit(endValue) || (p2 in _config.units ? _config.units[p2] : startUnit);
              startUnit !== endUnit && (startNum = _convertToUnit(target, p2, startValue, endUnit));
              this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p2, startNum, (relative ? _parseRelative(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p2 === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
              this._pt.u = endUnit || 0;
              if (startUnit !== endUnit && endUnit !== "%") {
                this._pt.b = startValue;
                this._pt.r = _renderCSSPropWithBeginning;
              }
            } else if (!(p2 in style)) {
              if (p2 in target) {
                this.add(target, p2, startValue || target[p2], relative ? relative + endValue : endValue, index, targets);
              } else if (p2 !== "parseTransform") {
                _missingPlugin(p2, endValue);
                continue;
              }
            } else {
              _tweenComplexCSSString.call(this, target, p2, startValue, relative ? relative + endValue : endValue);
            }
            isTransformRelated || (p2 in style ? inlineProps.push(p2, 0, style[p2]) : typeof target[p2] === "function" ? inlineProps.push(p2, 2, target[p2]()) : inlineProps.push(p2, 1, startValue || target[p2]));
            props.push(p2);
          }
        }
        hasPriority && _sortPropTweensByPriority(this);
      },
      render: function render(ratio, data) {
        if (data.tween._time || !_reverting()) {
          var pt = data._pt;
          while (pt) {
            pt.r(ratio, pt.d);
            pt = pt._next;
          }
        } else {
          data.styles.revert();
        }
      },
      get: _get,
      aliases: _propertyAliases,
      getSetter: function getSetter(target, property, plugin) {
        var p2 = _propertyAliases[property];
        p2 && p2.indexOf(",") < 0 && (property = p2);
        return property in _transformProps && property !== _transformOriginProp$1 && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
      },
      core: {
        _removeProperty,
        _getMatrix
      }
    };
    gsap$4.utils.checkPrefix = _checkPropPrefix;
    gsap$4.core.getStyleSaver = _getStyleSaver$1;
    (function(positionAndScale, rotation, others, aliases) {
      var all = _forEachName(positionAndScale + "," + rotation + "," + others, function(name) {
        _transformProps[name] = 1;
      });
      _forEachName(rotation, function(name) {
        _config.units[name] = "deg";
        _rotationalProperties[name] = 1;
      });
      _propertyAliases[all[13]] = positionAndScale + "," + rotation;
      _forEachName(aliases, function(name) {
        var split = name.split(":");
        _propertyAliases[split[1]] = all[split[0]];
      });
    })("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
    _forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
      _config.units[name] = "px";
    });
    gsap$4.registerPlugin(CSSPlugin);
    var gsapWithCSS = gsap$4.registerPlugin(CSSPlugin) || gsap$4;
    gsapWithCSS.core.Tween;
    function _defineProperties(target, props) {
      for (var i2 = 0; i2 < props.length; i2++) {
        var descriptor = props[i2];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      return Constructor;
    }
    /*!
     * Observer 3.13.0
     * https://gsap.com
     *
     * @license Copyright 2008-2025, GreenSock. All rights reserved.
     * Subject to the terms at https://gsap.com/standard-license
     * @author: Jack Doyle, jack@greensock.com
    */
    var gsap$3, _coreInitted$2, _win$2, _doc$2, _docEl$1, _body$3, _isTouch, _pointerType, ScrollTrigger$1, _root$1, _normalizer$1, _eventTypes, _context$1, _getGSAP$2 = function _getGSAP2() {
      return gsap$3 || typeof window !== "undefined" && (gsap$3 = window.gsap) && gsap$3.registerPlugin && gsap$3;
    }, _startup$1 = 1, _observers = [], _scrollers = [], _proxies = [], _getTime$1 = Date.now, _bridge = function _bridge2(name, value) {
      return value;
    }, _integrate = function _integrate2() {
      var core = ScrollTrigger$1.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
      scrollers.push.apply(scrollers, _scrollers);
      proxies.push.apply(proxies, _proxies);
      _scrollers = scrollers;
      _proxies = proxies;
      _bridge = function _bridge2(name, value) {
        return data[name](value);
      };
    }, _getProxyProp = function _getProxyProp2(element, property) {
      return ~_proxies.indexOf(element) && _proxies[_proxies.indexOf(element) + 1][property];
    }, _isViewport$1 = function _isViewport2(el) {
      return !!~_root$1.indexOf(el);
    }, _addListener$1 = function _addListener2(element, type, func, passive, capture) {
      return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
      });
    }, _removeListener$1 = function _removeListener2(element, type, func, capture) {
      return element.removeEventListener(type, func, !!capture);
    }, _scrollLeft = "scrollLeft", _scrollTop = "scrollTop", _onScroll$1 = function _onScroll2() {
      return _normalizer$1 && _normalizer$1.isPressed || _scrollers.cache++;
    }, _scrollCacheFunc = function _scrollCacheFunc2(f2, doNotCache) {
      var cachingFunc = function cachingFunc2(value) {
        if (value || value === 0) {
          _startup$1 && (_win$2.history.scrollRestoration = "manual");
          var isNormalizing = _normalizer$1 && _normalizer$1.isPressed;
          value = cachingFunc2.v = Math.round(value) || (_normalizer$1 && _normalizer$1.iOS ? 1 : 0);
          f2(value);
          cachingFunc2.cacheID = _scrollers.cache;
          isNormalizing && _bridge("ss", value);
        } else if (doNotCache || _scrollers.cache !== cachingFunc2.cacheID || _bridge("ref")) {
          cachingFunc2.cacheID = _scrollers.cache;
          cachingFunc2.v = f2();
        }
        return cachingFunc2.v + cachingFunc2.offset;
      };
      cachingFunc.offset = 0;
      return f2 && cachingFunc;
    }, _horizontal = {
      s: _scrollLeft,
      p: "left",
      p2: "Left",
      os: "right",
      os2: "Right",
      d: "width",
      d2: "Width",
      a: "x",
      sc: _scrollCacheFunc(function(value) {
        return arguments.length ? _win$2.scrollTo(value, _vertical.sc()) : _win$2.pageXOffset || _doc$2[_scrollLeft] || _docEl$1[_scrollLeft] || _body$3[_scrollLeft] || 0;
      })
    }, _vertical = {
      s: _scrollTop,
      p: "top",
      p2: "Top",
      os: "bottom",
      os2: "Bottom",
      d: "height",
      d2: "Height",
      a: "y",
      op: _horizontal,
      sc: _scrollCacheFunc(function(value) {
        return arguments.length ? _win$2.scrollTo(_horizontal.sc(), value) : _win$2.pageYOffset || _doc$2[_scrollTop] || _docEl$1[_scrollTop] || _body$3[_scrollTop] || 0;
      })
    }, _getTarget = function _getTarget2(t2, self) {
      return (self && self._ctx && self._ctx.selector || gsap$3.utils.toArray)(t2)[0] || (typeof t2 === "string" && gsap$3.config().nullTargetWarn !== false ? console.warn("Element not found:", t2) : null);
    }, _isWithin = function _isWithin2(element, list) {
      var i2 = list.length;
      while (i2--) {
        if (list[i2] === element || list[i2].contains(element)) {
          return true;
        }
      }
      return false;
    }, _getScrollFunc = function _getScrollFunc2(element, _ref) {
      var s2 = _ref.s, sc = _ref.sc;
      _isViewport$1(element) && (element = _doc$2.scrollingElement || _docEl$1);
      var i2 = _scrollers.indexOf(element), offset = sc === _vertical.sc ? 1 : 2;
      !~i2 && (i2 = _scrollers.push(element) - 1);
      _scrollers[i2 + offset] || _addListener$1(element, "scroll", _onScroll$1);
      var prev = _scrollers[i2 + offset], func = prev || (_scrollers[i2 + offset] = _scrollCacheFunc(_getProxyProp(element, s2), true) || (_isViewport$1(element) ? sc : _scrollCacheFunc(function(value) {
        return arguments.length ? element[s2] = value : element[s2];
      })));
      func.target = element;
      prev || (func.smooth = gsap$3.getProperty(element, "scrollBehavior") === "smooth");
      return func;
    }, _getVelocityProp = function _getVelocityProp2(value, minTimeRefresh, useDelta) {
      var v1 = value, v2 = value, t1 = _getTime$1(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update2(value2, force) {
        var t3 = _getTime$1();
        if (force || t3 - t1 > min) {
          v2 = v1;
          v1 = value2;
          t2 = t1;
          t1 = t3;
        } else if (useDelta) {
          v1 += value2;
        } else {
          v1 = v2 + (value2 - v2) / (t3 - t2) * (t1 - t2);
        }
      }, reset = function reset2() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
      }, getVelocity = function getVelocity2(latestValue) {
        var tOld = t2, vOld = v2, t3 = _getTime$1();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t3 - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t3 : t1) - tOld) * 1e3;
      };
      return {
        update,
        reset,
        getVelocity
      };
    }, _getEvent = function _getEvent2(e2, preventDefault) {
      preventDefault && !e2._gsapAllow && e2.preventDefault();
      return e2.changedTouches ? e2.changedTouches[0] : e2;
    }, _getAbsoluteMax = function _getAbsoluteMax2(a2) {
      var max = Math.max.apply(Math, a2), min = Math.min.apply(Math, a2);
      return Math.abs(max) >= Math.abs(min) ? max : min;
    }, _setScrollTrigger = function _setScrollTrigger2() {
      ScrollTrigger$1 = gsap$3.core.globals().ScrollTrigger;
      ScrollTrigger$1 && ScrollTrigger$1.core && _integrate();
    }, _initCore$1 = function _initCore2(core) {
      gsap$3 = core || _getGSAP$2();
      if (!_coreInitted$2 && gsap$3 && typeof document !== "undefined" && document.body) {
        _win$2 = window;
        _doc$2 = document;
        _docEl$1 = _doc$2.documentElement;
        _body$3 = _doc$2.body;
        _root$1 = [_win$2, _doc$2, _docEl$1, _body$3];
        gsap$3.utils.clamp;
        _context$1 = gsap$3.core.context || function() {
        };
        _pointerType = "onpointerenter" in _body$3 ? "pointer" : "mouse";
        _isTouch = Observer.isTouch = _win$2.matchMedia && _win$2.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in _win$2 || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        _eventTypes = Observer.eventTypes = ("ontouchstart" in _docEl$1 ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in _docEl$1) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
          return _startup$1 = 0;
        }, 500);
        _setScrollTrigger();
        _coreInitted$2 = 1;
      }
      return _coreInitted$2;
    };
    _horizontal.op = _vertical;
    _scrollers.cache = 0;
    var Observer = /* @__PURE__ */ function() {
      function Observer2(vars) {
        this.init(vars);
      }
      var _proto = Observer2.prototype;
      _proto.init = function init(vars) {
        _coreInitted$2 || _initCore$1(gsap$3) || console.warn("Please gsap.registerPlugin(Observer)");
        ScrollTrigger$1 || _setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce2 = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = _getTarget(target) || _docEl$1;
        this.vars = vars;
        ignore && (ignore = gsap$3.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce2 = debounce2 !== false;
        lineHeight || (lineHeight = parseFloat(_win$2.getComputedStyle(_body$3).lineHeight) || 22);
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault && vars.passive !== false, scrollFuncX = _getScrollFunc(target, _horizontal), scrollFuncY = _getScrollFunc(target, _vertical), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && _eventTypes[0] === "pointerdown", isViewport = _isViewport$1(target), ownerDoc = target.ownerDocument || _doc$2, deltaX = [0, 0, 0], deltaY = [0, 0, 0], onClickTime = 0, clickCapture = function clickCapture2() {
          return onClickTime = _getTime$1();
        }, _ignoreCheck = function _ignoreCheck2(e2, isPointerOrTouch) {
          return (self.event = e2) && ignore && _isWithin(e2.target, ignore) || isPointerOrTouch && limitToTouch && e2.pointerType !== "touch" || ignoreCheck && ignoreCheck(e2, isPointerOrTouch);
        }, onStopFunc = function onStopFunc2() {
          self._vx.reset();
          self._vy.reset();
          onStopDelayedCall.pause();
          onStop && onStop(self);
        }, update = function update2() {
          var dx = self.deltaX = _getAbsoluteMax(deltaX), dy = self.deltaY = _getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
          onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY);
          if (changedX) {
            onRight && self.deltaX > 0 && onRight(self);
            onLeft && self.deltaX < 0 && onLeft(self);
            onChangeX && onChangeX(self);
            onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
            prevDeltaX = self.deltaX;
            deltaX[0] = deltaX[1] = deltaX[2] = 0;
          }
          if (changedY) {
            onDown && self.deltaY > 0 && onDown(self);
            onUp && self.deltaY < 0 && onUp(self);
            onChangeY && onChangeY(self);
            onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
            prevDeltaY = self.deltaY;
            deltaY[0] = deltaY[1] = deltaY[2] = 0;
          }
          if (moved || dragged) {
            onMove && onMove(self);
            if (dragged) {
              onDragStart && dragged === 1 && onDragStart(self);
              onDrag && onDrag(self);
              dragged = 0;
            }
            moved = false;
          }
          locked && !(locked = false) && onLockAxis && onLockAxis(self);
          if (wheeled) {
            onWheel(self);
            wheeled = false;
          }
          id = 0;
        }, onDelta = function onDelta2(x2, y2, index) {
          deltaX[index] += x2;
          deltaY[index] += y2;
          self._vx.update(x2);
          self._vy.update(y2);
          debounce2 ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta2(x2, y2) {
          if (lockAxis && !axis) {
            self.axis = axis = Math.abs(x2) > Math.abs(y2) ? "x" : "y";
            locked = true;
          }
          if (axis !== "y") {
            deltaX[2] += x2;
            self._vx.update(x2, true);
          }
          if (axis !== "x") {
            deltaY[2] += y2;
            self._vy.update(y2, true);
          }
          debounce2 ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag2(e2) {
          if (_ignoreCheck(e2, 1)) {
            return;
          }
          e2 = _getEvent(e2, preventDefault);
          var x2 = e2.clientX, y2 = e2.clientY, dx = x2 - self.x, dy = y2 - self.y, isDragging = self.isDragging;
          self.x = x2;
          self.y = y2;
          if (isDragging || (dx || dy) && (Math.abs(self.startX - x2) >= dragMinimum || Math.abs(self.startY - y2) >= dragMinimum)) {
            dragged = isDragging ? 2 : 1;
            isDragging || (self.isDragging = true);
            onTouchOrPointerDelta(dx, dy);
          }
        }, _onPress = self.onPress = function(e2) {
          if (_ignoreCheck(e2, 1) || e2 && e2.button) {
            return;
          }
          self.axis = axis = null;
          onStopDelayedCall.pause();
          self.isPressed = true;
          e2 = _getEvent(e2);
          prevDeltaX = prevDeltaY = 0;
          self.startX = self.x = e2.clientX;
          self.startY = self.y = e2.clientY;
          self._vx.reset();
          self._vy.reset();
          _addListener$1(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, passive, true);
          self.deltaX = self.deltaY = 0;
          onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e2) {
          if (_ignoreCheck(e2, 1)) {
            return;
          }
          _removeListener$1(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, true);
          var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), eventData = _getEvent(e2);
          if (!isDragNotClick && isTrackingDrag) {
            self._vx.reset();
            self._vy.reset();
            if (preventDefault && allowClicks) {
              gsap$3.delayedCall(0.08, function() {
                if (_getTime$1() - onClickTime > 300 && !e2.defaultPrevented) {
                  if (e2.target.click) {
                    e2.target.click();
                  } else if (ownerDoc.createEvent) {
                    var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                    syntheticEvent.initMouseEvent("click", true, true, _win$2, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                    e2.target.dispatchEvent(syntheticEvent);
                  }
                }
              });
            }
          }
          self.isDragging = self.isGesturing = self.isPressed = false;
          onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
          dragged && update();
          onDragEnd && wasDragging && onDragEnd(self);
          onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart2(e2) {
          return e2.touches && e2.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e2, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd2() {
          return (self.isGesturing = false) || onGestureEnd(self);
        }, onScroll = function onScroll2(e2) {
          if (_ignoreCheck(e2)) {
            return;
          }
          var x2 = scrollFuncX(), y2 = scrollFuncY();
          onDelta((x2 - scrollX) * scrollSpeed, (y2 - scrollY) * scrollSpeed, 1);
          scrollX = x2;
          scrollY = y2;
          onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel2(e2) {
          if (_ignoreCheck(e2)) {
            return;
          }
          e2 = _getEvent(e2, preventDefault);
          onWheel && (wheeled = true);
          var multiplier = (e2.deltaMode === 1 ? lineHeight : e2.deltaMode === 2 ? _win$2.innerHeight : 1) * wheelSpeed;
          onDelta(e2.deltaX * multiplier, e2.deltaY * multiplier, 0);
          onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove2(e2) {
          if (_ignoreCheck(e2)) {
            return;
          }
          var x2 = e2.clientX, y2 = e2.clientY, dx = x2 - self.x, dy = y2 - self.y;
          self.x = x2;
          self.y = y2;
          moved = true;
          onStop && onStopDelayedCall.restart(true);
          (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover2(e2) {
          self.event = e2;
          onHover(self);
        }, _onHoverEnd = function _onHoverEnd2(e2) {
          self.event = e2;
          onHoverEnd(self);
        }, _onClick = function _onClick2(e2) {
          return _ignoreCheck(e2) || _getEvent(e2, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = gsap$3.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = _getVelocityProp(0, 50, true);
        self._vy = _getVelocityProp(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        _context$1(this);
        self.enable = function(e2) {
          if (!self.isEnabled) {
            _addListener$1(isViewport ? ownerDoc : target, "scroll", _onScroll$1);
            type.indexOf("scroll") >= 0 && _addListener$1(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
            type.indexOf("wheel") >= 0 && _addListener$1(target, "wheel", _onWheel, passive, capture);
            if (type.indexOf("touch") >= 0 && _isTouch || type.indexOf("pointer") >= 0) {
              _addListener$1(target, _eventTypes[0], _onPress, passive, capture);
              _addListener$1(ownerDoc, _eventTypes[2], _onRelease);
              _addListener$1(ownerDoc, _eventTypes[3], _onRelease);
              allowClicks && _addListener$1(target, "click", clickCapture, true, true);
              onClick && _addListener$1(target, "click", _onClick);
              onGestureStart && _addListener$1(ownerDoc, "gesturestart", _onGestureStart);
              onGestureEnd && _addListener$1(ownerDoc, "gestureend", _onGestureEnd);
              onHover && _addListener$1(target, _pointerType + "enter", _onHover);
              onHoverEnd && _addListener$1(target, _pointerType + "leave", _onHoverEnd);
              onMove && _addListener$1(target, _pointerType + "move", _onMove);
            }
            self.isEnabled = true;
            self.isDragging = self.isGesturing = self.isPressed = moved = dragged = false;
            self._vx.reset();
            self._vy.reset();
            scrollX = scrollFuncX();
            scrollY = scrollFuncY();
            e2 && e2.type && _onPress(e2);
            onEnable && onEnable(self);
          }
          return self;
        };
        self.disable = function() {
          if (self.isEnabled) {
            _observers.filter(function(o2) {
              return o2 !== self && _isViewport$1(o2.target);
            }).length || _removeListener$1(isViewport ? ownerDoc : target, "scroll", _onScroll$1);
            if (self.isPressed) {
              self._vx.reset();
              self._vy.reset();
              _removeListener$1(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, true);
            }
            _removeListener$1(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
            _removeListener$1(target, "wheel", _onWheel, capture);
            _removeListener$1(target, _eventTypes[0], _onPress, capture);
            _removeListener$1(ownerDoc, _eventTypes[2], _onRelease);
            _removeListener$1(ownerDoc, _eventTypes[3], _onRelease);
            _removeListener$1(target, "click", clickCapture, true);
            _removeListener$1(target, "click", _onClick);
            _removeListener$1(ownerDoc, "gesturestart", _onGestureStart);
            _removeListener$1(ownerDoc, "gestureend", _onGestureEnd);
            _removeListener$1(target, _pointerType + "enter", _onHover);
            _removeListener$1(target, _pointerType + "leave", _onHoverEnd);
            _removeListener$1(target, _pointerType + "move", _onMove);
            self.isEnabled = self.isPressed = self.isDragging = false;
            onDisable && onDisable(self);
          }
        };
        self.kill = self.revert = function() {
          self.disable();
          var i2 = _observers.indexOf(self);
          i2 >= 0 && _observers.splice(i2, 1);
          _normalizer$1 === self && (_normalizer$1 = 0);
        };
        _observers.push(self);
        isNormalizer && _isViewport$1(target) && (_normalizer$1 = self);
        self.enable(event);
      };
      _createClass(Observer2, [{
        key: "velocityX",
        get: function get() {
          return this._vx.getVelocity();
        }
      }, {
        key: "velocityY",
        get: function get() {
          return this._vy.getVelocity();
        }
      }]);
      return Observer2;
    }();
    Observer.version = "3.13.0";
    Observer.create = function(vars) {
      return new Observer(vars);
    };
    Observer.register = _initCore$1;
    Observer.getAll = function() {
      return _observers.slice();
    };
    Observer.getById = function(id) {
      return _observers.filter(function(o2) {
        return o2.vars.id === id;
      })[0];
    };
    _getGSAP$2() && gsap$3.registerPlugin(Observer);
    /*!
     * ScrollTrigger 3.13.0
     * https://gsap.com
     *
     * @license Copyright 2008-2025, GreenSock. All rights reserved.
     * Subject to the terms at https://gsap.com/standard-license
     * @author: Jack Doyle, jack@greensock.com
    */
    var gsap$2, _coreInitted$1, _win$1, _doc$1, _docEl, _body$2, _root, _resizeDelay, _toArray$1, _clamp, _time2, _syncInterval, _refreshing, _pointerIsDown, _transformProp$1, _i, _prevWidth, _prevHeight, _autoRefresh, _sort, _suppressOverwrites, _ignoreResize, _normalizer, _ignoreMobileResize, _baseScreenHeight, _baseScreenWidth, _fixIOSBug, _context, _scrollRestoration, _div100vh, _100vh, _isReverted, _clampingMax, _limitCallbacks, _startup = 1, _getTime = Date.now, _time1 = _getTime(), _lastScrollTime = 0, _enabled = 0, _parseClamp = function _parseClamp2(value, type, self) {
      var clamp2 = _isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
      self["_" + type + "Clamp"] = clamp2;
      return clamp2 ? value.substr(6, value.length - 7) : value;
    }, _keepClamp = function _keepClamp2(value, clamp2) {
      return clamp2 && (!_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
    }, _rafBugFix = function _rafBugFix2() {
      return _enabled && requestAnimationFrame(_rafBugFix2);
    }, _pointerDownHandler = function _pointerDownHandler2() {
      return _pointerIsDown = 1;
    }, _pointerUpHandler = function _pointerUpHandler2() {
      return _pointerIsDown = 0;
    }, _passThrough = function _passThrough2(v2) {
      return v2;
    }, _round$3 = function _round2(value) {
      return Math.round(value * 1e5) / 1e5 || 0;
    }, _windowExists = function _windowExists2() {
      return typeof window !== "undefined";
    }, _getGSAP$1 = function _getGSAP2() {
      return gsap$2 || _windowExists() && (gsap$2 = window.gsap) && gsap$2.registerPlugin && gsap$2;
    }, _isViewport = function _isViewport2(e2) {
      return !!~_root.indexOf(e2);
    }, _getViewportDimension = function _getViewportDimension2(dimensionProperty) {
      return (dimensionProperty === "Height" ? _100vh : _win$1["inner" + dimensionProperty]) || _docEl["client" + dimensionProperty] || _body$2["client" + dimensionProperty];
    }, _getBoundsFunc = function _getBoundsFunc2(element) {
      return _getProxyProp(element, "getBoundingClientRect") || (_isViewport(element) ? function() {
        _winOffsets.width = _win$1.innerWidth;
        _winOffsets.height = _100vh;
        return _winOffsets;
      } : function() {
        return _getBounds(element);
      });
    }, _getSizeFunc = function _getSizeFunc2(scroller, isViewport, _ref) {
      var d2 = _ref.d, d22 = _ref.d2, a2 = _ref.a;
      return (a2 = _getProxyProp(scroller, "getBoundingClientRect")) ? function() {
        return a2()[d2];
      } : function() {
        return (isViewport ? _getViewportDimension(d22) : scroller["client" + d22]) || 0;
      };
    }, _getOffsetsFunc = function _getOffsetsFunc2(element, isViewport) {
      return !isViewport || ~_proxies.indexOf(element) ? _getBoundsFunc(element) : function() {
        return _winOffsets;
      };
    }, _maxScroll = function _maxScroll2(element, _ref2) {
      var s2 = _ref2.s, d2 = _ref2.d2, d3 = _ref2.d, a2 = _ref2.a;
      return Math.max(0, (s2 = "scroll" + d2) && (a2 = _getProxyProp(element, s2)) ? a2() - _getBoundsFunc(element)()[d3] : _isViewport(element) ? (_docEl[s2] || _body$2[s2]) - _getViewportDimension(d2) : element[s2] - element["offset" + d2]);
    }, _iterateAutoRefresh = function _iterateAutoRefresh2(func, events) {
      for (var i2 = 0; i2 < _autoRefresh.length; i2 += 3) {
        (!events || ~events.indexOf(_autoRefresh[i2 + 1])) && func(_autoRefresh[i2], _autoRefresh[i2 + 1], _autoRefresh[i2 + 2]);
      }
    }, _isString = function _isString2(value) {
      return typeof value === "string";
    }, _isFunction = function _isFunction2(value) {
      return typeof value === "function";
    }, _isNumber$1 = function _isNumber2(value) {
      return typeof value === "number";
    }, _isObject = function _isObject2(value) {
      return typeof value === "object";
    }, _endAnimation = function _endAnimation2(animation, reversed, pause) {
      return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
    }, _callback = function _callback2(self, func) {
      if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
          return func(self);
        }) : func(self);
        result && result.totalTime && (self.callbackAnimation = result);
      }
    }, _abs$1 = Math.abs, _left = "left", _top = "top", _right = "right", _bottom = "bottom", _width = "width", _height = "height", _Right = "Right", _Left = "Left", _Top = "Top", _Bottom = "Bottom", _padding = "padding", _margin = "margin", _Width = "Width", _Height = "Height", _px = "px", _getComputedStyle = function _getComputedStyle2(element) {
      return _win$1.getComputedStyle(element);
    }, _makePositionable = function _makePositionable2(element) {
      var position = _getComputedStyle(element).position;
      element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
    }, _setDefaults = function _setDefaults2(obj, defaults) {
      for (var p2 in defaults) {
        p2 in obj || (obj[p2] = defaults[p2]);
      }
      return obj;
    }, _getBounds = function _getBounds2(element, withoutTransforms) {
      var tween = withoutTransforms && _getComputedStyle(element)[_transformProp$1] !== "matrix(1, 0, 0, 1, 0, 0)" && gsap$2.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
      }).progress(1), bounds = element.getBoundingClientRect();
      tween && tween.progress(0).kill();
      return bounds;
    }, _getSize = function _getSize2(element, _ref3) {
      var d2 = _ref3.d2;
      return element["offset" + d2] || element["client" + d2] || 0;
    }, _getLabelRatioArray = function _getLabelRatioArray2(timeline) {
      var a2 = [], labels = timeline.labels, duration = timeline.duration(), p2;
      for (p2 in labels) {
        a2.push(labels[p2] / duration);
      }
      return a2;
    }, _getClosestLabel = function _getClosestLabel2(animation) {
      return function(value) {
        return gsap$2.utils.snap(_getLabelRatioArray(animation), value);
      };
    }, _snapDirectional = function _snapDirectional2(snapIncrementOrArray) {
      var snap2 = gsap$2.utils.snap(snapIncrementOrArray), a2 = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a3, b2) {
        return a3 - b2;
      });
      return a2 ? function(value, direction, threshold) {
        if (threshold === void 0) {
          threshold = 1e-3;
        }
        var i2;
        if (!direction) {
          return snap2(value);
        }
        if (direction > 0) {
          value -= threshold;
          for (i2 = 0; i2 < a2.length; i2++) {
            if (a2[i2] >= value) {
              return a2[i2];
            }
          }
          return a2[i2 - 1];
        } else {
          i2 = a2.length;
          value += threshold;
          while (i2--) {
            if (a2[i2] <= value) {
              return a2[i2];
            }
          }
        }
        return a2[0];
      } : function(value, direction, threshold) {
        if (threshold === void 0) {
          threshold = 1e-3;
        }
        var snapped = snap2(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap2(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
      };
    }, _getLabelAtDirection = function _getLabelAtDirection2(timeline) {
      return function(value, st) {
        return _snapDirectional(_getLabelRatioArray(timeline))(value, st.direction);
      };
    }, _multiListener = function _multiListener2(func, element, types, callback) {
      return types.split(",").forEach(function(type) {
        return func(element, type, callback);
      });
    }, _addListener = function _addListener2(element, type, func, nonPassive, capture) {
      return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
      });
    }, _removeListener = function _removeListener2(element, type, func, capture) {
      return element.removeEventListener(type, func, !!capture);
    }, _wheelListener = function _wheelListener2(func, el, scrollFunc) {
      scrollFunc = scrollFunc && scrollFunc.wheelHandler;
      if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
      }
    }, _markerDefaults = {
      startColor: "green",
      endColor: "red",
      indent: 0,
      fontSize: "16px",
      fontWeight: "normal"
    }, _defaults = {
      toggleActions: "play",
      anticipatePin: 0
    }, _keywords = {
      top: 0,
      left: 0,
      center: 0.5,
      bottom: 1,
      right: 1
    }, _offsetToPx = function _offsetToPx2(value, size) {
      if (_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
          value.indexOf("%") > eqIndex && (relative *= size / 100);
          value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in _keywords ? _keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
      }
      return value;
    }, _createMarker = function _createMarker2(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
      var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
      var e2 = _doc$1.createElement("div"), useFixedPosition = _isViewport(container) || _getProxyProp(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? _body$2 : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
      css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
      (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === _vertical ? _right : _bottom) + ":" + (offset + parseFloat(indent)) + "px;");
      matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
      e2._isStart = isStart;
      e2.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
      e2.style.cssText = css;
      e2.innerText = name || name === 0 ? type + "-" + name : type;
      parent.children[0] ? parent.insertBefore(e2, parent.children[0]) : parent.appendChild(e2);
      e2._offset = e2["offset" + direction.op.d2];
      _positionMarker(e2, 0, direction, isStart);
      return e2;
    }, _positionMarker = function _positionMarker2(marker, start, direction, flipped) {
      var vars = {
        display: "block"
      }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
      marker._isFlipped = flipped;
      vars[direction.a + "Percent"] = flipped ? -100 : 0;
      vars[direction.a] = flipped ? "1px" : 0;
      vars["border" + side + _Width] = 1;
      vars["border" + oppositeSide + _Width] = 0;
      vars[direction.p] = start + "px";
      gsap$2.set(marker, vars);
    }, _triggers = [], _ids = {}, _rafID, _sync = function _sync2() {
      return _getTime() - _lastScrollTime > 34 && (_rafID || (_rafID = requestAnimationFrame(_updateAll)));
    }, _onScroll = function _onScroll2() {
      if (!_normalizer || !_normalizer.isPressed || _normalizer.startX > _body$2.clientWidth) {
        _scrollers.cache++;
        if (_normalizer) {
          _rafID || (_rafID = requestAnimationFrame(_updateAll));
        } else {
          _updateAll();
        }
        _lastScrollTime || _dispatch("scrollStart");
        _lastScrollTime = _getTime();
      }
    }, _setBaseDimensions = function _setBaseDimensions2() {
      _baseScreenWidth = _win$1.innerWidth;
      _baseScreenHeight = _win$1.innerHeight;
    }, _onResize = function _onResize2(force) {
      _scrollers.cache++;
      (force === true || !_refreshing && !_ignoreResize && !_doc$1.fullscreenElement && !_doc$1.webkitFullscreenElement && (!_ignoreMobileResize || _baseScreenWidth !== _win$1.innerWidth || Math.abs(_win$1.innerHeight - _baseScreenHeight) > _win$1.innerHeight * 0.25)) && _resizeDelay.restart(true);
    }, _listeners = {}, _emptyArray = [], _softRefresh = function _softRefresh2() {
      return _removeListener(ScrollTrigger, "scrollEnd", _softRefresh2) || _refreshAll(true);
    }, _dispatch = function _dispatch2(type) {
      return _listeners[type] && _listeners[type].map(function(f2) {
        return f2();
      }) || _emptyArray;
    }, _savedStyles = [], _revertRecorded = function _revertRecorded2(media) {
      for (var i2 = 0; i2 < _savedStyles.length; i2 += 5) {
        if (!media || _savedStyles[i2 + 4] && _savedStyles[i2 + 4].query === media) {
          _savedStyles[i2].style.cssText = _savedStyles[i2 + 1];
          _savedStyles[i2].getBBox && _savedStyles[i2].setAttribute("transform", _savedStyles[i2 + 2] || "");
          _savedStyles[i2 + 3].uncache = 1;
        }
      }
    }, _revertAll = function _revertAll2(kill, media) {
      var trigger;
      for (_i = 0; _i < _triggers.length; _i++) {
        trigger = _triggers[_i];
        if (trigger && (!media || trigger._ctx === media)) {
          if (kill) {
            trigger.kill(1);
          } else {
            trigger.revert(true, true);
          }
        }
      }
      _isReverted = true;
      media && _revertRecorded(media);
      media || _dispatch("revert");
    }, _clearScrollMemory = function _clearScrollMemory2(scrollRestoration, force) {
      _scrollers.cache++;
      (force || !_refreshingAll) && _scrollers.forEach(function(obj) {
        return _isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
      });
      _isString(scrollRestoration) && (_win$1.history.scrollRestoration = _scrollRestoration = scrollRestoration);
    }, _refreshingAll, _refreshID = 0, _queueRefreshID, _queueRefreshAll = function _queueRefreshAll2() {
      if (_queueRefreshID !== _refreshID) {
        var id = _queueRefreshID = _refreshID;
        requestAnimationFrame(function() {
          return id === _refreshID && _refreshAll(true);
        });
      }
    }, _refresh100vh = function _refresh100vh2() {
      _body$2.appendChild(_div100vh);
      _100vh = !_normalizer && _div100vh.offsetHeight || _win$1.innerHeight;
      _body$2.removeChild(_div100vh);
    }, _hideAllMarkers = function _hideAllMarkers2(hide) {
      return _toArray$1(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
      });
    }, _refreshAll = function _refreshAll2(force, skipRevert) {
      _docEl = _doc$1.documentElement;
      _body$2 = _doc$1.body;
      _root = [_win$1, _doc$1, _docEl, _body$2];
      if (_lastScrollTime && !force && !_isReverted) {
        _addListener(ScrollTrigger, "scrollEnd", _softRefresh);
        return;
      }
      _refresh100vh();
      _refreshingAll = ScrollTrigger.isRefreshing = true;
      _scrollers.forEach(function(obj) {
        return _isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
      });
      var refreshInits = _dispatch("refreshInit");
      _sort && ScrollTrigger.sort();
      skipRevert || _revertAll();
      _scrollers.forEach(function(obj) {
        if (_isFunction(obj)) {
          obj.smooth && (obj.target.style.scrollBehavior = "auto");
          obj(0);
        }
      });
      _triggers.slice(0).forEach(function(t2) {
        return t2.refresh();
      });
      _isReverted = false;
      _triggers.forEach(function(t2) {
        if (t2._subPinOffset && t2.pin) {
          var prop = t2.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t2.pin[prop];
          t2.revert(true, 1);
          t2.adjustPinSpacing(t2.pin[prop] - original);
          t2.refresh();
        }
      });
      _clampingMax = 1;
      _hideAllMarkers(true);
      _triggers.forEach(function(t2) {
        var max = _maxScroll(t2.scroller, t2._dir), endClamp = t2.vars.end === "max" || t2._endClamp && t2.end > max, startClamp = t2._startClamp && t2.start >= max;
        (endClamp || startClamp) && t2.setPositions(startClamp ? max - 1 : t2.start, endClamp ? Math.max(startClamp ? max : t2.start + 1, max) : t2.end, true);
      });
      _hideAllMarkers(false);
      _clampingMax = 0;
      refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
      });
      _scrollers.forEach(function(obj) {
        if (_isFunction(obj)) {
          obj.smooth && requestAnimationFrame(function() {
            return obj.target.style.scrollBehavior = "smooth";
          });
          obj.rec && obj(obj.rec);
        }
      });
      _clearScrollMemory(_scrollRestoration, 1);
      _resizeDelay.pause();
      _refreshID++;
      _refreshingAll = 2;
      _updateAll(2);
      _triggers.forEach(function(t2) {
        return _isFunction(t2.vars.onRefresh) && t2.vars.onRefresh(t2);
      });
      _refreshingAll = ScrollTrigger.isRefreshing = false;
      _dispatch("refresh");
    }, _lastScroll = 0, _direction = 1, _primary, _updateAll = function _updateAll2(force) {
      if (force === 2 || !_refreshingAll && !_isReverted) {
        ScrollTrigger.isUpdating = true;
        _primary && _primary.update(0);
        var l2 = _triggers.length, time = _getTime(), recordVelocity = time - _time1 >= 50, scroll = l2 && _triggers[0].scroll();
        _direction = _lastScroll > scroll ? -1 : 1;
        _refreshingAll || (_lastScroll = scroll);
        if (recordVelocity) {
          if (_lastScrollTime && !_pointerIsDown && time - _lastScrollTime > 200) {
            _lastScrollTime = 0;
            _dispatch("scrollEnd");
          }
          _time2 = _time1;
          _time1 = time;
        }
        if (_direction < 0) {
          _i = l2;
          while (_i-- > 0) {
            _triggers[_i] && _triggers[_i].update(0, recordVelocity);
          }
          _direction = 1;
        } else {
          for (_i = 0; _i < l2; _i++) {
            _triggers[_i] && _triggers[_i].update(0, recordVelocity);
          }
        }
        ScrollTrigger.isUpdating = false;
      }
      _rafID = 0;
    }, _propNamesToCopy = [_left, _top, _bottom, _right, _margin + _Bottom, _margin + _Right, _margin + _Top, _margin + _Left, "display", "flexShrink", "float", "zIndex", "gridColumnStart", "gridColumnEnd", "gridRowStart", "gridRowEnd", "gridArea", "justifySelf", "alignSelf", "placeSelf", "order"], _stateProps = _propNamesToCopy.concat([_width, _height, "boxSizing", "max" + _Width, "max" + _Height, "position", _margin, _padding, _padding + _Top, _padding + _Right, _padding + _Bottom, _padding + _Left]), _swapPinOut = function _swapPinOut2(pin, spacer, state) {
      _setState(state);
      var cache = pin._gsap;
      if (cache.spacerIsNative) {
        _setState(cache.spacerState);
      } else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
          parent.insertBefore(pin, spacer);
          parent.removeChild(spacer);
        }
      }
      pin._gsap.swappedIn = false;
    }, _swapPinIn = function _swapPinIn2(pin, spacer, cs, spacerState) {
      if (!pin._gsap.swappedIn) {
        var i2 = _propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p2;
        while (i2--) {
          p2 = _propNamesToCopy[i2];
          spacerStyle[p2] = cs[p2];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[_bottom] = pinStyle[_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[_width] = _getSize(pin, _horizontal) + _px;
        spacerStyle[_height] = _getSize(pin, _vertical) + _px;
        spacerStyle[_padding] = pinStyle[_margin] = pinStyle[_top] = pinStyle[_left] = "0";
        _setState(spacerState);
        pinStyle[_width] = pinStyle["max" + _Width] = cs[_width];
        pinStyle[_height] = pinStyle["max" + _Height] = cs[_height];
        pinStyle[_padding] = cs[_padding];
        if (pin.parentNode !== spacer) {
          pin.parentNode.insertBefore(spacer, pin);
          spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
      }
    }, _capsExp = /([A-Z])/g, _setState = function _setState2(state) {
      if (state) {
        var style = state.t.style, l2 = state.length, i2 = 0, p2, value;
        (state.t._gsap || gsap$2.core.getCache(state.t)).uncache = 1;
        for (; i2 < l2; i2 += 2) {
          value = state[i2 + 1];
          p2 = state[i2];
          if (value) {
            style[p2] = value;
          } else if (style[p2]) {
            style.removeProperty(p2.replace(_capsExp, "-$1").toLowerCase());
          }
        }
      }
    }, _getState = function _getState2(element) {
      var l2 = _stateProps.length, style = element.style, state = [], i2 = 0;
      for (; i2 < l2; i2++) {
        state.push(_stateProps[i2], style[_stateProps[i2]]);
      }
      state.t = element;
      return state;
    }, _copyState = function _copyState2(state, override, omitOffsets) {
      var result = [], l2 = state.length, i2 = omitOffsets ? 8 : 0, p2;
      for (; i2 < l2; i2 += 2) {
        p2 = state[i2];
        result.push(p2, p2 in override ? override[p2] : state[i2 + 1]);
      }
      result.t = state.t;
      return result;
    }, _winOffsets = {
      left: 0,
      top: 0
    }, _parsePosition = function _parsePosition2(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
      _isFunction(value) && (value = value(self));
      if (_isString(value) && value.substr(0, 3) === "max") {
        value = scrollerMax + (value.charAt(4) === "=" ? _offsetToPx("0" + value.substr(3), scrollerSize) : 0);
      }
      var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
      containerAnimation && containerAnimation.seek(0);
      isNaN(value) || (value = +value);
      if (!_isNumber$1(value)) {
        _isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = _getTarget(trigger, self) || _body$2;
        bounds = _getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && _getComputedStyle(element).display === "none") {
          display = element.style.display;
          element.style.display = "block";
          bounds = _getBounds(element);
          display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = _offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = _offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && _positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset;
      } else {
        containerAnimation && (value = gsap$2.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && _positionMarker(markerScroller, scrollerSize, direction, true);
      }
      if (clampZeroProp) {
        self[clampZeroProp] = value || -1e-3;
        value < 0 && (value = 0);
      }
      if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        _positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max(_body$2[p1], _docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
          scrollerBounds = _getBounds(markerScroller);
          useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + _px);
        }
      }
      if (containerAnimation && element) {
        p1 = _getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = _getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
      }
      containerAnimation && containerAnimation.seek(time);
      return containerAnimation ? value : Math.round(value);
    }, _prefixExp = /(webkit|moz|length|cssText|inset)/i, _reparent = function _reparent2(element, parent, top, left) {
      if (element.parentNode !== parent) {
        var style = element.style, p2, cs;
        if (parent === _body$2) {
          element._stOrig = style.cssText;
          cs = _getComputedStyle(element);
          for (p2 in cs) {
            if (!+p2 && !_prefixExp.test(p2) && cs[p2] && typeof style[p2] === "string" && p2 !== "0") {
              style[p2] = cs[p2];
            }
          }
          style.top = top;
          style.left = left;
        } else {
          style.cssText = element._stOrig;
        }
        gsap$2.core.getCache(element).uncache = 1;
        parent.appendChild(element);
      }
    }, _interruptionTracker = function _interruptionTracker2(getValueFunc, initialValue, onInterrupt) {
      var last1 = initialValue, last2 = last1;
      return function(value) {
        var current = Math.round(getValueFunc());
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
          value = current;
          onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = Math.round(value);
        return last1;
      };
    }, _shiftMarker = function _shiftMarker2(marker, direction, value) {
      var vars = {};
      vars[direction.p] = "+=" + value;
      gsap$2.set(marker, vars);
    }, _getTweenCreator = function _getTweenCreator2(scroller, direction) {
      var getScroll = _getScrollFunc(scroller, direction), prop = "_scroll" + direction.p2, getTween = function getTween2(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween2.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = _interruptionTracker(getScroll, initialValue, function() {
          tween.kill();
          getTween2.tween = 0;
        });
        change2 = change1 && change2 || 0;
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
          return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
          _scrollers.cache++;
          getTween2.tween && _updateAll();
        };
        vars.onComplete = function() {
          getTween2.tween = 0;
          onComplete && onComplete.call(tween);
        };
        tween = getTween2.tween = gsap$2.to(scroller, vars);
        return tween;
      };
      scroller[prop] = getScroll;
      getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
      };
      _addListener(scroller, "wheel", getScroll.wheelHandler);
      ScrollTrigger.isTouch && _addListener(scroller, "touchmove", getScroll.wheelHandler);
      return getTween;
    };
    var ScrollTrigger = /* @__PURE__ */ function() {
      function ScrollTrigger2(vars, animation) {
        _coreInitted$1 || ScrollTrigger2.register(gsap$2) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        _context(this);
        this.init(vars, animation);
      }
      var _proto = ScrollTrigger2.prototype;
      _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true);
        if (!_enabled) {
          this.update = this.refresh = this.kill = _passThrough;
          return;
        }
        vars = _setDefaults(_isString(vars) || _isNumber$1(vars) || vars.nodeType ? {
          trigger: vars
        } : vars, _defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap2 = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? _horizontal : _vertical, isToggle = !scrub && scrub !== 0, scroller = _getTarget(vars.scroller || _win$1), scrollerCache = gsap$2.core.getCache(scroller), isViewport = _isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : _getProxyProp(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [vars.onEnter, vars.onLeave, vars.onEnterBack, vars.onLeaveBack], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : _defaults.markers, borderWidth = isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
          return vars.onRefreshInit(self);
        }, getScrollerSize = _getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = _getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = _getScrollFunc(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap22, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn;
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
          _sort = 1;
          vars.refreshPriority === -9999 && (_primary = self);
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
          top: _getTweenCreator(scroller, _vertical),
          left: _getTweenCreator(scroller, _horizontal)
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
          scrubSmooth = _isNumber$1(value) && value;
          if (!scrubSmooth) {
            scrubTween && scrubTween.progress(1).kill();
            scrubTween = 0;
          } else {
            scrubTween ? scrubTween.duration(value) : scrubTween = gsap$2.to(animation, {
              ease: "expo",
              totalProgress: "+=0",
              inherit: false,
              duration: scrubSmooth,
              paused: true,
              onComplete: function onComplete() {
                return onScrubComplete && onScrubComplete(self);
              }
            });
          }
        };
        if (animation) {
          animation.vars.lazy = false;
          animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true);
          self.animation = animation.pause();
          animation.scrollTrigger = self;
          self.scrubDuration(scrub);
          snap1 = 0;
          id || (id = animation.vars.id);
        }
        if (snap2) {
          if (!_isObject(snap2) || snap2.push) {
            snap2 = {
              snapTo: snap2
            };
          }
          "scrollBehavior" in _body$2.style && gsap$2.set(isViewport ? [_body$2, _docEl] : scroller, {
            scrollBehavior: "auto"
          });
          _scrollers.forEach(function(o2) {
            return _isFunction(o2) && o2.target === (isViewport ? _doc$1.scrollingElement || _docEl : scroller) && (o2.smooth = false);
          });
          snapFunc = _isFunction(snap2.snapTo) ? snap2.snapTo : snap2.snapTo === "labels" ? _getClosestLabel(animation) : snap2.snapTo === "labelsDirectional" ? _getLabelAtDirection(animation) : snap2.directional !== false ? function(value, st) {
            return _snapDirectional(snap2.snapTo)(value, _getTime() - lastRefresh < 500 ? 0 : st.direction);
          } : gsap$2.utils.snap(snap2.snapTo);
          snapDurClamp = snap2.duration || {
            min: 0.1,
            max: 2
          };
          snapDurClamp = _isObject(snapDurClamp) ? _clamp(snapDurClamp.min, snapDurClamp.max) : _clamp(snapDurClamp, snapDurClamp);
          snapDelayedCall = gsap$2.delayedCall(snap2.delay || scrubSmooth / 2 || 0.1, function() {
            var scroll = scrollFunc(), refreshedRecently = _getTime() - lastRefresh < 500, tween = tweenTo.tween;
            if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !_pointerIsDown && lastSnap !== scroll) {
              var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap22) / (_getTime() - _time2) * 1e3 || 0, change1 = gsap$2.utils.clamp(-progress, 1 - progress, _abs$1(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap2.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap2, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
              endValue = snapFunc(naturalEnd, self);
              _isNumber$1(endValue) || (endValue = naturalEnd);
              endScroll = Math.max(0, Math.round(start + endValue * change));
              if (scroll <= end && scroll >= start && endScroll !== scroll) {
                if (tween && !tween._initted && tween.data <= _abs$1(endScroll - scroll)) {
                  return;
                }
                if (snap2.inertia === false) {
                  change1 = endValue - progress;
                }
                tweenTo(endScroll, {
                  duration: snapDurClamp(_abs$1(Math.max(_abs$1(naturalEnd - totalProgress), _abs$1(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                  ease: snap2.ease || "power3",
                  data: _abs$1(endScroll - scroll),
                  // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                  onInterrupt: function onInterrupt() {
                    return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                  },
                  onComplete: function onComplete() {
                    self.update();
                    lastSnap = scrollFunc();
                    if (animation && !isToggle) {
                      scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                    }
                    snap1 = snap22 = animation && !isToggle ? animation.totalProgress() : self.progress;
                    onSnapComplete && onSnapComplete(self);
                    _onComplete && _onComplete(self);
                  }
                }, scroll, change1 * change, endScroll - scroll - change1 * change);
                onStart && onStart(self, tweenTo.tween);
              }
            } else if (self.isActive && lastSnap !== scroll) {
              snapDelayedCall.restart(true);
            }
          }).pause();
        }
        id && (_ids[id] = self);
        trigger = self.trigger = _getTarget(trigger || pin !== true && pin);
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : _getTarget(pin);
        _isString(toggleClass) && (toggleClass = {
          targets: trigger,
          className: toggleClass
        });
        if (pin) {
          pinSpacing === false || pinSpacing === _margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && _getComputedStyle(pin.parentNode).display === "flex" ? false : _padding);
          self.pin = pin;
          pinCache = gsap$2.core.getCache(pin);
          if (!pinCache.spacer) {
            if (pinSpacer) {
              pinSpacer = _getTarget(pinSpacer);
              pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement);
              pinCache.spacerIsNative = !!pinSpacer;
              pinSpacer && (pinCache.spacerState = _getState(pinSpacer));
            }
            pinCache.spacer = spacer = pinSpacer || _doc$1.createElement("div");
            spacer.classList.add("pin-spacer");
            id && spacer.classList.add("pin-spacer-" + id);
            pinCache.pinState = pinOriginalState = _getState(pin);
          } else {
            pinOriginalState = pinCache.pinState;
          }
          vars.force3D !== false && gsap$2.set(pin, {
            force3D: true
          });
          self.spacer = spacer = pinCache.spacer;
          cs = _getComputedStyle(pin);
          spacingStart = cs[pinSpacing + direction.os2];
          pinGetter = gsap$2.getProperty(pin);
          pinSetter = gsap$2.quickSetter(pin, direction.a, _px);
          _swapPinIn(pin, spacer, cs);
          pinState = _getState(pin);
        }
        if (markers) {
          markerVars = _isObject(markers) ? _setDefaults(markers, _markerDefaults) : _markerDefaults;
          markerStartTrigger = _createMarker("scroller-start", id, scroller, direction, markerVars, 0);
          markerEndTrigger = _createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
          offset = markerStartTrigger["offset" + direction.op.d2];
          var content = _getTarget(_getProxyProp(scroller, "content") || scroller);
          markerStart = this.markerStart = _createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
          markerEnd = this.markerEnd = _createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
          containerAnimation && (caMarkerSetter = gsap$2.quickSetter([markerStart, markerEnd], direction.a, _px));
          if (!useFixedPosition && !(_proxies.length && _getProxyProp(scroller, "fixedMarkers") === true)) {
            _makePositionable(isViewport ? _body$2 : scroller);
            gsap$2.set([markerStartTrigger, markerEndTrigger], {
              force3D: true
            });
            markerStartSetter = gsap$2.quickSetter(markerStartTrigger, direction.a, _px);
            markerEndSetter = gsap$2.quickSetter(markerEndTrigger, direction.a, _px);
          }
        }
        if (containerAnimation) {
          var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
          containerAnimation.eventCallback("onUpdate", function() {
            self.update(0, 0, 1);
            oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
          });
        }
        self.previous = function() {
          return _triggers[_triggers.indexOf(self) - 1];
        };
        self.next = function() {
          return _triggers[_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
          if (!temp) {
            return self.kill(true);
          }
          var r2 = revert !== false || !self.enabled, prevRefreshing = _refreshing;
          if (r2 !== self.isReverted) {
            if (r2) {
              prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0);
              prevProgress = self.progress;
              prevAnimProgress = animation && animation.progress();
            }
            markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function(m2) {
              return m2.style.display = r2 ? "none" : "block";
            });
            if (r2) {
              _refreshing = self;
              self.update(r2);
            }
            if (pin && (!pinReparent || !self.isActive)) {
              if (r2) {
                _swapPinOut(pin, spacer, pinOriginalState);
              } else {
                _swapPinIn(pin, spacer, _getComputedStyle(pin), spacerState);
              }
            }
            r2 || self.update(r2);
            _refreshing = prevRefreshing;
            self.isReverted = r2;
          }
        };
        self.refresh = function(soft, force, position, pinOffset) {
          if ((_refreshing || !self.enabled) && !force) {
            return;
          }
          if (pin && soft && _lastScrollTime) {
            _addListener(ScrollTrigger2, "scrollEnd", _softRefresh);
            return;
          }
          !_refreshingAll && onRefreshInit && onRefreshInit(self);
          _refreshing = self;
          if (tweenTo.tween && !position) {
            tweenTo.tween.kill();
            tweenTo.tween = 0;
          }
          scrubTween && scrubTween.pause();
          if (invalidateOnRefresh && animation) {
            animation.revert({
              kill: false
            }).invalidate();
            animation.getChildren && animation.getChildren(true, true, false).forEach(function(t2) {
              return t2.vars.immediateRender && t2.render(0, true, true);
            });
          }
          self.isReverted || self.revert(true, true);
          self._subPinOffset = false;
          var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : _maxScroll(scroller, direction), isFirstRefresh = change <= 0.01 || !change, offset2 = 0, otherPinOffset = pinOffset || 0, parsedEnd = _isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = _isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && _getTarget(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, _triggers.indexOf(self)) || 0, i2 = triggerIndex, cs2, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
          if (markers && _isObject(position)) {
            markerStartOffset = gsap$2.getProperty(markerStartTrigger, direction.p);
            markerEndOffset = gsap$2.getProperty(markerEndTrigger, direction.p);
          }
          while (i2-- > 0) {
            curTrigger = _triggers[i2];
            curTrigger.end || curTrigger.refresh(0, 1) || (_refreshing = self);
            curPin = curTrigger.pin;
            if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
              revertedPins || (revertedPins = []);
              revertedPins.unshift(curTrigger);
              curTrigger.revert(true, true);
            }
            if (curTrigger !== _triggers[i2]) {
              triggerIndex--;
              i2--;
            }
          }
          _isFunction(parsedStart) && (parsedStart = parsedStart(self));
          parsedStart = _parseClamp(parsedStart, "start", self);
          start = _parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -1e-3 : 0);
          _isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
          if (_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
            if (~parsedEnd.indexOf(" ")) {
              parsedEnd = (_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
            } else {
              offset2 = _offsetToPx(parsedEnd.substr(2), size);
              parsedEnd = _isString(parsedStart) ? parsedStart : (containerAnimation ? gsap$2.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset2;
              parsedEndTrigger = trigger;
            }
          }
          parsedEnd = _parseClamp(parsedEnd, "end", self);
          end = Math.max(start, _parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset2, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -1e-3;
          offset2 = 0;
          i2 = triggerIndex;
          while (i2--) {
            curTrigger = _triggers[i2];
            curPin = curTrigger.pin;
            if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
              cs2 = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
              if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) {
                offset2 += cs2 * (1 - curTrigger.progress);
              }
              curPin === pin && (otherPinOffset += cs2);
            }
          }
          start += offset2;
          end += offset2;
          self._startClamp && (self._startClamp += offset2);
          if (self._endClamp && !_refreshingAll) {
            self._endClamp = end || -1e-3;
            end = Math.min(end, _maxScroll(scroller, direction));
          }
          change = end - start || (start -= 0.01) && 1e-3;
          if (isFirstRefresh) {
            prevProgress = gsap$2.utils.clamp(0, 1, gsap$2.utils.normalize(start, end, prevScroll));
          }
          self._pinPush = otherPinOffset;
          if (markerStart && offset2) {
            cs2 = {};
            cs2[direction.a] = "+=" + offset2;
            pinnedContainer && (cs2[direction.p] = "-=" + scrollFunc());
            gsap$2.set([markerStart, markerEnd], cs2);
          }
          if (pin && !(_clampingMax && self.end >= _maxScroll(scroller, direction))) {
            cs2 = _getComputedStyle(pin);
            isVertical = direction === _vertical;
            scroll = scrollFunc();
            pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
            if (!max && end > 1) {
              forcedOverflow = (isViewport ? _doc$1.scrollingElement || _docEl : scroller).style;
              forcedOverflow = {
                style: forcedOverflow,
                value: forcedOverflow["overflow" + direction.a.toUpperCase()]
              };
              if (isViewport && _getComputedStyle(_body$2)["overflow" + direction.a.toUpperCase()] !== "scroll") {
                forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
              }
            }
            _swapPinIn(pin, spacer, cs2);
            pinState = _getState(pin);
            bounds = _getBounds(pin, true);
            oppositeScroll = useFixedPosition && _getScrollFunc(scroller, isVertical ? _horizontal : _vertical)();
            if (pinSpacing) {
              spacerState = [pinSpacing + direction.os2, change + otherPinOffset + _px];
              spacerState.t = spacer;
              i2 = pinSpacing === _padding ? _getSize(pin, direction) + change + otherPinOffset : 0;
              if (i2) {
                spacerState.push(direction.d, i2 + _px);
                spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i2 + _px);
              }
              _setState(spacerState);
              if (pinnedContainer) {
                _triggers.forEach(function(t2) {
                  if (t2.pin === pinnedContainer && t2.vars.pinSpacing !== false) {
                    t2._subPinOffset = true;
                  }
                });
              }
              useFixedPosition && scrollFunc(prevScroll);
            } else {
              i2 = _getSize(pin, direction);
              i2 && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i2 + _px);
            }
            if (useFixedPosition) {
              override = {
                top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + _px,
                left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + _px,
                boxSizing: "border-box",
                position: "fixed"
              };
              override[_width] = override["max" + _Width] = Math.ceil(bounds.width) + _px;
              override[_height] = override["max" + _Height] = Math.ceil(bounds.height) + _px;
              override[_margin] = override[_margin + _Top] = override[_margin + _Right] = override[_margin + _Bottom] = override[_margin + _Left] = "0";
              override[_padding] = cs2[_padding];
              override[_padding + _Top] = cs2[_padding + _Top];
              override[_padding + _Right] = cs2[_padding + _Right];
              override[_padding + _Bottom] = cs2[_padding + _Bottom];
              override[_padding + _Left] = cs2[_padding + _Left];
              pinActiveState = _copyState(pinOriginalState, override, pinReparent);
              _refreshingAll && scrollFunc(0);
            }
            if (animation) {
              initted = animation._initted;
              _suppressOverwrites(1);
              animation.render(animation.duration(), true, true);
              pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
              pinMoves = Math.abs(change - pinChange) > 1;
              useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2);
              animation.render(0, true, true);
              initted || animation.invalidate(true);
              animation.parent || animation.totalTime(animation.totalTime());
              _suppressOverwrites(0);
            } else {
              pinChange = change;
            }
            forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
          } else if (trigger && scrollFunc() && !containerAnimation) {
            bounds = trigger.parentNode;
            while (bounds && bounds !== _body$2) {
              if (bounds._pinOffset) {
                start -= bounds._pinOffset;
                end -= bounds._pinOffset;
              }
              bounds = bounds.parentNode;
            }
          }
          revertedPins && revertedPins.forEach(function(t2) {
            return t2.revert(false, true);
          });
          self.start = start;
          self.end = end;
          scroll1 = scroll2 = _refreshingAll ? prevScroll : scrollFunc();
          if (!containerAnimation && !_refreshingAll) {
            scroll1 < prevScroll && scrollFunc(prevScroll);
            self.scroll.rec = 0;
          }
          self.revert(false, true);
          lastRefresh = _getTime();
          if (snapDelayedCall) {
            lastSnap = -1;
            snapDelayedCall.restart(true);
          }
          _refreshing = 0;
          animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true);
          if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh || animation && !animation._initted) {
            animation && !isToggle && (animation._initted || prevProgress || animation.vars.immediateRender !== false) && animation.totalProgress(containerAnimation && start < -1e-3 && !prevProgress ? gsap$2.utils.normalize(start, end, 0) : prevProgress, true);
            self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
          }
          pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
          scrubTween && scrubTween.invalidate();
          if (!isNaN(markerStartOffset)) {
            markerStartOffset -= gsap$2.getProperty(markerStartTrigger, direction.p);
            markerEndOffset -= gsap$2.getProperty(markerEndTrigger, direction.p);
            _shiftMarker(markerStartTrigger, direction, markerStartOffset);
            _shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
            _shiftMarker(markerEndTrigger, direction, markerEndOffset);
            _shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
          }
          isFirstRefresh && !_refreshingAll && self.update();
          if (onRefresh && !_refreshingAll && !executingOnRefresh) {
            executingOnRefresh = true;
            onRefresh(self);
            executingOnRefresh = false;
          }
        };
        self.getVelocity = function() {
          return (scrollFunc() - scroll2) / (_getTime() - _time2) * 1e3 || 0;
        };
        self.endAnimation = function() {
          _endAnimation(self.callbackAnimation);
          if (animation) {
            scrubTween ? scrubTween.progress(1) : !animation.paused() ? _endAnimation(animation, animation.reversed()) : isToggle || _endAnimation(animation, self.direction < 0, 1);
          }
        };
        self.labelToScroll = function(label) {
          return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
          var i2 = _triggers.indexOf(self), a2 = self.direction > 0 ? _triggers.slice(0, i2).reverse() : _triggers.slice(i2 + 1);
          return (_isString(name) ? a2.filter(function(t2) {
            return t2.vars.preventOverlaps === name;
          }) : a2).filter(function(t2) {
            return self.direction > 0 ? t2.end <= start : t2.start >= end;
          });
        };
        self.update = function(reset, recordVelocity, forceFake) {
          if (containerAnimation && !forceFake && !reset) {
            return;
          }
          var scroll = _refreshingAll === true ? prevScroll : self.scroll(), p2 = reset ? 0 : (scroll - start) / change, clipped = p2 < 0 ? 0 : p2 > 1 ? 1 : p2 || 0, prevProgress2 = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
          if (recordVelocity) {
            scroll2 = scroll1;
            scroll1 = containerAnimation ? scrollFunc() : scroll;
            if (snap2) {
              snap22 = snap1;
              snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
            }
          }
          if (anticipatePin && pin && !_refreshing && !_startup && _lastScrollTime) {
            if (!clipped && start < scroll + (scroll - scroll2) / (_getTime() - _time2) * anticipatePin) {
              clipped = 1e-4;
            } else if (clipped === 1 && end > scroll + (scroll - scroll2) / (_getTime() - _time2) * anticipatePin) {
              clipped = 0.9999;
            }
          }
          if (clipped !== prevProgress2 && self.enabled) {
            isActive = self.isActive = !!clipped && clipped < 1;
            wasActive = !!prevProgress2 && prevProgress2 < 1;
            toggled = isActive !== wasActive;
            stateChanged = toggled || !!clipped !== !!prevProgress2;
            self.direction = clipped > prevProgress2 ? 1 : -1;
            self.progress = clipped;
            if (stateChanged && !_refreshing) {
              toggleState = clipped && !prevProgress2 ? 0 : clipped === 1 ? 1 : prevProgress2 === 1 ? 2 : 3;
              if (isToggle) {
                action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState];
                isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
              }
            }
            preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && (_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t2) {
              return t2.endAnimation();
            }));
            if (!isToggle) {
              if (scrubTween && !_refreshing && !_startup) {
                scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start);
                if (scrubTween.resetTo) {
                  scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                } else {
                  scrubTween.vars.totalProgress = clipped;
                  scrubTween.invalidate().restart();
                }
              } else if (animation) {
                animation.totalProgress(clipped, !!(_refreshing && (lastRefresh || reset)));
              }
            }
            if (pin) {
              reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
              if (!useFixedPosition) {
                pinSetter(_round$3(pinStart + pinChange * clipped));
              } else if (stateChanged) {
                isAtMax = !reset && clipped > prevProgress2 && end + 1 > scroll && scroll + 1 >= _maxScroll(scroller, direction);
                if (pinReparent) {
                  if (!reset && (isActive || isAtMax)) {
                    var bounds = _getBounds(pin, true), _offset = scroll - start;
                    _reparent(pin, _body$2, bounds.top + (direction === _vertical ? _offset : 0) + _px, bounds.left + (direction === _vertical ? 0 : _offset) + _px);
                  } else {
                    _reparent(pin, spacer);
                  }
                }
                _setState(isActive || isAtMax ? pinActiveState : pinState);
                pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
              }
            }
            snap2 && !tweenTo.tween && !_refreshing && !_startup && snapDelayedCall.restart(true);
            toggleClass && (toggled || once && clipped && (clipped < 1 || !_limitCallbacks)) && _toArray$1(toggleClass.targets).forEach(function(el) {
              return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
            });
            onUpdate && !isToggle && !reset && onUpdate(self);
            if (stateChanged && !_refreshing) {
              if (isToggle) {
                if (isTakingAction) {
                  if (action === "complete") {
                    animation.pause().totalProgress(1);
                  } else if (action === "reset") {
                    animation.restart(true).pause();
                  } else if (action === "restart") {
                    animation.restart(true);
                  } else {
                    animation[action]();
                  }
                }
                onUpdate && onUpdate(self);
              }
              if (toggled || !_limitCallbacks) {
                onToggle && toggled && _callback(self, onToggle);
                callbacks[toggleState] && _callback(self, callbacks[toggleState]);
                once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0);
                if (!toggled) {
                  toggleState = clipped === 1 ? 1 : 3;
                  callbacks[toggleState] && _callback(self, callbacks[toggleState]);
                }
              }
              if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > (_isNumber$1(fastScrollEnd) ? fastScrollEnd : 2500)) {
                _endAnimation(self.callbackAnimation);
                scrubTween ? scrubTween.progress(1) : _endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
              }
            } else if (isToggle && onUpdate && !_refreshing) {
              onUpdate(self);
            }
          }
          if (markerEndSetter) {
            var n2 = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
            markerStartSetter(n2 + (markerStartTrigger._isFlipped ? 1 : 0));
            markerEndSetter(n2);
          }
          caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
          if (!self.enabled) {
            self.enabled = true;
            _addListener(scroller, "resize", _onResize);
            isViewport || _addListener(scroller, "scroll", _onScroll);
            onRefreshInit && _addListener(ScrollTrigger2, "refreshInit", onRefreshInit);
            if (reset !== false) {
              self.progress = prevProgress = 0;
              scroll1 = scroll2 = lastSnap = scrollFunc();
            }
            refresh !== false && self.refresh();
          }
        };
        self.getTween = function(snap3) {
          return snap3 && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
          if (containerAnimation) {
            var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
            newStart = st.start + _change * newStart / duration;
            newEnd = st.start + _change * newEnd / duration;
          }
          self.refresh(false, false, {
            start: _keepClamp(newStart, keepClamp && !!self._startClamp),
            end: _keepClamp(newEnd, keepClamp && !!self._endClamp)
          }, pinOffset);
          self.update();
        };
        self.adjustPinSpacing = function(amount) {
          if (spacerState && amount) {
            var i2 = spacerState.indexOf(direction.d) + 1;
            spacerState[i2] = parseFloat(spacerState[i2]) + amount + _px;
            spacerState[1] = parseFloat(spacerState[1]) + amount + _px;
            _setState(spacerState);
          }
        };
        self.disable = function(reset, allowAnimation) {
          if (self.enabled) {
            reset !== false && self.revert(true, true);
            self.enabled = self.isActive = false;
            allowAnimation || scrubTween && scrubTween.pause();
            prevScroll = 0;
            pinCache && (pinCache.uncache = 1);
            onRefreshInit && _removeListener(ScrollTrigger2, "refreshInit", onRefreshInit);
            if (snapDelayedCall) {
              snapDelayedCall.pause();
              tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
            }
            if (!isViewport) {
              var i2 = _triggers.length;
              while (i2--) {
                if (_triggers[i2].scroller === scroller && _triggers[i2] !== self) {
                  return;
                }
              }
              _removeListener(scroller, "resize", _onResize);
              isViewport || _removeListener(scroller, "scroll", _onScroll);
            }
          }
        };
        self.kill = function(revert, allowAnimation) {
          self.disable(revert, allowAnimation);
          scrubTween && !allowAnimation && scrubTween.kill();
          id && delete _ids[id];
          var i2 = _triggers.indexOf(self);
          i2 >= 0 && _triggers.splice(i2, 1);
          i2 === _i && _direction > 0 && _i--;
          i2 = 0;
          _triggers.forEach(function(t2) {
            return t2.scroller === self.scroller && (i2 = 1);
          });
          i2 || _refreshingAll || (self.scroll.rec = 0);
          if (animation) {
            animation.scrollTrigger = null;
            revert && animation.revert({
              kill: false
            });
            allowAnimation || animation.kill();
          }
          markerStart && [markerStart, markerEnd, markerStartTrigger, markerEndTrigger].forEach(function(m2) {
            return m2.parentNode && m2.parentNode.removeChild(m2);
          });
          _primary === self && (_primary = 0);
          if (pin) {
            pinCache && (pinCache.uncache = 1);
            i2 = 0;
            _triggers.forEach(function(t2) {
              return t2.pin === pin && i2++;
            });
            i2 || (pinCache.spacer = 0);
          }
          vars.onKill && vars.onKill(self);
        };
        _triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
          var updateFunc = self.update;
          self.update = function() {
            self.update = updateFunc;
            _scrollers.cache++;
            start || end || self.refresh();
          };
          gsap$2.delayedCall(0.01, self.update);
          change = 0.01;
          start = end = 0;
        } else {
          self.refresh();
        }
        pin && _queueRefreshAll();
      };
      ScrollTrigger2.register = function register(core) {
        if (!_coreInitted$1) {
          gsap$2 = core || _getGSAP$1();
          _windowExists() && window.document && ScrollTrigger2.enable();
          _coreInitted$1 = _enabled;
        }
        return _coreInitted$1;
      };
      ScrollTrigger2.defaults = function defaults(config) {
        if (config) {
          for (var p2 in config) {
            _defaults[p2] = config[p2];
          }
        }
        return _defaults;
      };
      ScrollTrigger2.disable = function disable(reset, kill) {
        _enabled = 0;
        _triggers.forEach(function(trigger) {
          return trigger[kill ? "kill" : "disable"](reset);
        });
        _removeListener(_win$1, "wheel", _onScroll);
        _removeListener(_doc$1, "scroll", _onScroll);
        clearInterval(_syncInterval);
        _removeListener(_doc$1, "touchcancel", _passThrough);
        _removeListener(_body$2, "touchstart", _passThrough);
        _multiListener(_removeListener, _doc$1, "pointerdown,touchstart,mousedown", _pointerDownHandler);
        _multiListener(_removeListener, _doc$1, "pointerup,touchend,mouseup", _pointerUpHandler);
        _resizeDelay.kill();
        _iterateAutoRefresh(_removeListener);
        for (var i2 = 0; i2 < _scrollers.length; i2 += 3) {
          _wheelListener(_removeListener, _scrollers[i2], _scrollers[i2 + 1]);
          _wheelListener(_removeListener, _scrollers[i2], _scrollers[i2 + 2]);
        }
      };
      ScrollTrigger2.enable = function enable() {
        _win$1 = window;
        _doc$1 = document;
        _docEl = _doc$1.documentElement;
        _body$2 = _doc$1.body;
        if (gsap$2) {
          _toArray$1 = gsap$2.utils.toArray;
          _clamp = gsap$2.utils.clamp;
          _context = gsap$2.core.context || _passThrough;
          _suppressOverwrites = gsap$2.core.suppressOverwrites || _passThrough;
          _scrollRestoration = _win$1.history.scrollRestoration || "auto";
          _lastScroll = _win$1.pageYOffset || 0;
          gsap$2.core.globals("ScrollTrigger", ScrollTrigger2);
          if (_body$2) {
            _enabled = 1;
            _div100vh = document.createElement("div");
            _div100vh.style.height = "100vh";
            _div100vh.style.position = "absolute";
            _refresh100vh();
            _rafBugFix();
            Observer.register(gsap$2);
            ScrollTrigger2.isTouch = Observer.isTouch;
            _fixIOSBug = Observer.isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent);
            _ignoreMobileResize = Observer.isTouch === 1;
            _addListener(_win$1, "wheel", _onScroll);
            _root = [_win$1, _doc$1, _docEl, _body$2];
            if (gsap$2.matchMedia) {
              ScrollTrigger2.matchMedia = function(vars) {
                var mm = gsap$2.matchMedia(), p2;
                for (p2 in vars) {
                  mm.add(p2, vars[p2]);
                }
                return mm;
              };
              gsap$2.addEventListener("matchMediaInit", function() {
                return _revertAll();
              });
              gsap$2.addEventListener("matchMediaRevert", function() {
                return _revertRecorded();
              });
              gsap$2.addEventListener("matchMedia", function() {
                _refreshAll(0, 1);
                _dispatch("matchMedia");
              });
              gsap$2.matchMedia().add("(orientation: portrait)", function() {
                _setBaseDimensions();
                return _setBaseDimensions;
              });
            } else {
              console.warn("Requires GSAP 3.11.0 or later");
            }
            _setBaseDimensions();
            _addListener(_doc$1, "scroll", _onScroll);
            var bodyHasStyle = _body$2.hasAttribute("style"), bodyStyle = _body$2.style, border = bodyStyle.borderTopStyle, AnimationProto = gsap$2.core.Animation.prototype, bounds, i2;
            AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
              value: function value() {
                return this.time(-0.01, true);
              }
            });
            bodyStyle.borderTopStyle = "solid";
            bounds = _getBounds(_body$2);
            _vertical.m = Math.round(bounds.top + _vertical.sc()) || 0;
            _horizontal.m = Math.round(bounds.left + _horizontal.sc()) || 0;
            border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
            if (!bodyHasStyle) {
              _body$2.setAttribute("style", "");
              _body$2.removeAttribute("style");
            }
            _syncInterval = setInterval(_sync, 250);
            gsap$2.delayedCall(0.5, function() {
              return _startup = 0;
            });
            _addListener(_doc$1, "touchcancel", _passThrough);
            _addListener(_body$2, "touchstart", _passThrough);
            _multiListener(_addListener, _doc$1, "pointerdown,touchstart,mousedown", _pointerDownHandler);
            _multiListener(_addListener, _doc$1, "pointerup,touchend,mouseup", _pointerUpHandler);
            _transformProp$1 = gsap$2.utils.checkPrefix("transform");
            _stateProps.push(_transformProp$1);
            _coreInitted$1 = _getTime();
            _resizeDelay = gsap$2.delayedCall(0.2, _refreshAll).pause();
            _autoRefresh = [_doc$1, "visibilitychange", function() {
              var w2 = _win$1.innerWidth, h2 = _win$1.innerHeight;
              if (_doc$1.hidden) {
                _prevWidth = w2;
                _prevHeight = h2;
              } else if (_prevWidth !== w2 || _prevHeight !== h2) {
                _onResize();
              }
            }, _doc$1, "DOMContentLoaded", _refreshAll, _win$1, "load", _refreshAll, _win$1, "resize", _onResize];
            _iterateAutoRefresh(_addListener);
            _triggers.forEach(function(trigger) {
              return trigger.enable(0, 1);
            });
            for (i2 = 0; i2 < _scrollers.length; i2 += 3) {
              _wheelListener(_removeListener, _scrollers[i2], _scrollers[i2 + 1]);
              _wheelListener(_removeListener, _scrollers[i2], _scrollers[i2 + 2]);
            }
          }
        }
      };
      ScrollTrigger2.config = function config(vars) {
        "limitCallbacks" in vars && (_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval(_syncInterval) || (_syncInterval = ms) && setInterval(_sync, ms);
        "ignoreMobileResize" in vars && (_ignoreMobileResize = ScrollTrigger2.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
          _iterateAutoRefresh(_removeListener) || _iterateAutoRefresh(_addListener, vars.autoRefreshEvents || "none");
          _ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
      };
      ScrollTrigger2.scrollerProxy = function scrollerProxy(target, vars) {
        var t2 = _getTarget(target), i2 = _scrollers.indexOf(t2), isViewport = _isViewport(t2);
        if (~i2) {
          _scrollers.splice(i2, isViewport ? 6 : 2);
        }
        if (vars) {
          isViewport ? _proxies.unshift(_win$1, vars, _body$2, vars, _docEl, vars) : _proxies.unshift(t2, vars);
        }
      };
      ScrollTrigger2.clearMatchMedia = function clearMatchMedia(query) {
        _triggers.forEach(function(t2) {
          return t2._ctx && t2._ctx.query === query && t2._ctx.kill(true, true);
        });
      };
      ScrollTrigger2.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = (_isString(element) ? _getTarget(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? _width : _height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < _win$1.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < _win$1.innerHeight;
      };
      ScrollTrigger2.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        _isString(element) && (element = _getTarget(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? _width : _height], offset = referencePoint == null ? size / 2 : referencePoint in _keywords ? _keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / _win$1.innerWidth : (bounds.top + offset) / _win$1.innerHeight;
      };
      ScrollTrigger2.killAll = function killAll(allowListeners) {
        _triggers.slice(0).forEach(function(t2) {
          return t2.vars.id !== "ScrollSmoother" && t2.kill();
        });
        if (allowListeners !== true) {
          var listeners = _listeners.killAll || [];
          _listeners = {};
          listeners.forEach(function(f2) {
            return f2();
          });
        }
      };
      return ScrollTrigger2;
    }();
    ScrollTrigger.version = "3.13.0";
    ScrollTrigger.saveStyles = function(targets) {
      return targets ? _toArray$1(targets).forEach(function(target) {
        if (target && target.style) {
          var i2 = _savedStyles.indexOf(target);
          i2 >= 0 && _savedStyles.splice(i2, 5);
          _savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), gsap$2.core.getCache(target), _context());
        }
      }) : _savedStyles;
    };
    ScrollTrigger.revert = function(soft, media) {
      return _revertAll(!soft, media);
    };
    ScrollTrigger.create = function(vars, animation) {
      return new ScrollTrigger(vars, animation);
    };
    ScrollTrigger.refresh = function(safe) {
      return safe ? _onResize(true) : (_coreInitted$1 || ScrollTrigger.register()) && _refreshAll(true);
    };
    ScrollTrigger.update = function(force) {
      return ++_scrollers.cache && _updateAll(force === true ? 2 : 0);
    };
    ScrollTrigger.clearScrollMemory = _clearScrollMemory;
    ScrollTrigger.maxScroll = function(element, horizontal) {
      return _maxScroll(element, horizontal ? _horizontal : _vertical);
    };
    ScrollTrigger.getScrollFunc = function(element, horizontal) {
      return _getScrollFunc(_getTarget(element), horizontal ? _horizontal : _vertical);
    };
    ScrollTrigger.getById = function(id) {
      return _ids[id];
    };
    ScrollTrigger.getAll = function() {
      return _triggers.filter(function(t2) {
        return t2.vars.id !== "ScrollSmoother";
      });
    };
    ScrollTrigger.isScrolling = function() {
      return !!_lastScrollTime;
    };
    ScrollTrigger.snapDirectional = _snapDirectional;
    ScrollTrigger.addEventListener = function(type, callback) {
      var a2 = _listeners[type] || (_listeners[type] = []);
      ~a2.indexOf(callback) || a2.push(callback);
    };
    ScrollTrigger.removeEventListener = function(type, callback) {
      var a2 = _listeners[type], i2 = a2 && a2.indexOf(callback);
      i2 >= 0 && a2.splice(i2, 1);
    };
    ScrollTrigger.batch = function(targets, vars) {
      var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback2(type, callback) {
        var elements = [], triggers = [], delay = gsap$2.delayedCall(interval, function() {
          callback(elements, triggers);
          elements = [];
          triggers = [];
        }).pause();
        return function(self) {
          elements.length || delay.restart(true);
          elements.push(self.trigger);
          triggers.push(self);
          batchMax <= elements.length && delay.progress(1);
        };
      }, p2;
      for (p2 in vars) {
        varsCopy[p2] = p2.substr(0, 2) === "on" && _isFunction(vars[p2]) && p2 !== "onRefreshInit" ? proxyCallback(p2, vars[p2]) : vars[p2];
      }
      if (_isFunction(batchMax)) {
        batchMax = batchMax();
        _addListener(ScrollTrigger, "refresh", function() {
          return batchMax = vars.batchMax();
        });
      }
      _toArray$1(targets).forEach(function(target) {
        var config = {};
        for (p2 in varsCopy) {
          config[p2] = varsCopy[p2];
        }
        config.trigger = target;
        result.push(ScrollTrigger.create(config));
      });
      return result;
    };
    var _clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier2(scrollFunc, current, end, max) {
      current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
      return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
    }, _allowNativePanning = function _allowNativePanning2(target, direction) {
      if (direction === true) {
        target.style.removeProperty("touch-action");
      } else {
        target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + (Observer.isTouch ? " pinch-zoom" : "") : "none";
      }
      target === _docEl && _allowNativePanning2(_body$2, direction);
    }, _overflow = {
      auto: 1,
      scroll: 1
    }, _nestedScroll = function _nestedScroll2(_ref5) {
      var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
      var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || gsap$2.core.getCache(node), time = _getTime(), cs;
      if (!cache._isScrollT || time - cache._isScrollT > 2e3) {
        while (node && node !== _body$2 && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !(_overflow[(cs = _getComputedStyle(node)).overflowY] || _overflow[cs.overflowX]))) {
          node = node.parentNode;
        }
        cache._isScroll = node && node !== target && !_isViewport(node) && (_overflow[(cs = _getComputedStyle(node)).overflowY] || _overflow[cs.overflowX]);
        cache._isScrollT = time;
      }
      if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
      }
    }, _inputObserver = function _inputObserver2(target, type, inputs, nested) {
      return Observer.create({
        target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type,
        onWheel: nested = nested && _nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
          return inputs && _addListener(_doc$1, Observer.eventTypes[0], _captureInputs, false, true);
        },
        onDisable: function onDisable() {
          return _removeListener(_doc$1, Observer.eventTypes[0], _captureInputs, true);
        }
      });
    }, _inputExp = /(input|label|select|textarea)/i, _inputIsFocused, _captureInputs = function _captureInputs2(e2) {
      var isInput = _inputExp.test(e2.target.tagName);
      if (isInput || _inputIsFocused) {
        e2._gsapAllow = true;
        _inputIsFocused = isInput;
      }
    }, _getScrollNormalizer = function _getScrollNormalizer2(vars) {
      _isObject(vars) || (vars = {});
      vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
      vars.type || (vars.type = "wheel,touch");
      vars.debounce = !!vars.debounce;
      vars.id = vars.id || "normalizer";
      var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = _getTarget(vars.target) || _docEl, smoother = gsap$2.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = _fixIOSBug && (vars.content && _getTarget(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = _getScrollFunc(target, _vertical), scrollFuncX = _getScrollFunc(target, _horizontal), scale = 1, initialScale = (Observer.isTouch && _win$1.visualViewport ? _win$1.visualViewport.scale * _win$1.visualViewport.width : _win$1.outerWidth) / _win$1.innerWidth, wheelRefresh = 0, resolveMomentumDuration = _isFunction(momentum) ? function() {
        return momentum(self);
      } : function() {
        return momentum || 2.8;
      }, lastRefreshID, skipTouchMove, inputObserver = _inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove2() {
        return skipTouchMove = false;
      }, scrollClampX = _passThrough, scrollClampY = _passThrough, updateClamps = function updateClamps2() {
        maxY = _maxScroll(target, _vertical);
        scrollClampY = _clamp(_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = _clamp(0, _maxScroll(target, _horizontal)));
        lastRefreshID = _refreshID;
      }, removeContentOffset = function removeContentOffset2() {
        content._gsap.y = _round$3(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
      }, ignoreDrag = function ignoreDrag2() {
        if (skipTouchMove) {
          requestAnimationFrame(resumeTouchMove);
          var offset = _round$3(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
          if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
            scrollFuncY.offset = scroll - scrollFuncY.v;
            var y2 = _round$3((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
            content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y2 + ", 0, 1)";
            content._gsap.y = y2 + "px";
            scrollFuncY.cacheID = _scrollers.cache;
            _updateAll();
          }
          return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
      }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize2() {
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) {
          scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
        }
      };
      content && gsap$2.set(content, {
        y: "+=0"
      });
      vars.ignoreCheck = function(e2) {
        return _fixIOSBug && e2.type === "touchmove" && ignoreDrag() || scale > 1.05 && e2.type !== "touchstart" || self.isGesturing || e2.touches && e2.touches.length > 1;
      };
      vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = _round$3((_win$1.visualViewport && _win$1.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && _allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = _refreshID;
      };
      vars.onRelease = vars.onGestureStart = function(self2, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) {
          onStopDelayedCall.restart(true);
        } else {
          _scrollers.cache++;
          var dur = resolveMomentumDuration(), currentScroll, endScroll;
          if (normalizeScrollX) {
            currentScroll = scrollFuncX();
            endScroll = currentScroll + dur * 0.05 * -self2.velocityX / 0.227;
            dur *= _clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, _maxScroll(target, _horizontal));
            tween.vars.scrollX = scrollClampX(endScroll);
          }
          currentScroll = scrollFuncY();
          endScroll = currentScroll + dur * 0.05 * -self2.velocityY / 0.227;
          dur *= _clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, _maxScroll(target, _vertical));
          tween.vars.scrollY = scrollClampY(endScroll);
          tween.invalidate().duration(dur).play(0.01);
          if (_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) {
            gsap$2.to({}, {
              onUpdate: onResize,
              duration: dur
            });
          }
        }
        onRelease && onRelease(self2);
      };
      vars.onWheel = function() {
        tween._ts && tween.pause();
        if (_getTime() - wheelRefresh > 1e3) {
          lastRefreshID = 0;
          wheelRefresh = _getTime();
        }
      };
      vars.onChange = function(self2, dx, dy, xArray, yArray) {
        _refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self2.startX - self2.x) : scrollFuncX() + dx - xArray[1]));
        if (dy) {
          scrollFuncY.offset && removeContentOffset();
          var isTouch = yArray[2] === dy, y2 = isTouch ? startScrollY + self2.startY - self2.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y2);
          isTouch && y2 !== yClamped && (startScrollY += yClamped - y2);
          scrollFuncY(yClamped);
        }
        (dy || dx) && _updateAll();
      };
      vars.onEnable = function() {
        _allowNativePanning(target, normalizeScrollX ? false : "x");
        ScrollTrigger.addEventListener("refresh", onResize);
        _addListener(_win$1, "resize", onResize);
        if (scrollFuncY.smooth) {
          scrollFuncY.target.style.scrollBehavior = "auto";
          scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
      };
      vars.onDisable = function() {
        _allowNativePanning(target, true);
        _removeListener(_win$1, "resize", onResize);
        ScrollTrigger.removeEventListener("refresh", onResize);
        inputObserver.kill();
      };
      vars.lockAxis = vars.lockAxis !== false;
      self = new Observer(vars);
      self.iOS = _fixIOSBug;
      _fixIOSBug && !scrollFuncY() && scrollFuncY(1);
      _fixIOSBug && gsap$2.ticker.add(_passThrough);
      onStopDelayedCall = self._dc;
      tween = gsap$2.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
          scrollY: _interruptionTracker(scrollFuncY, scrollFuncY(), function() {
            return tween.pause();
          })
        },
        onUpdate: _updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
      });
      return self;
    };
    ScrollTrigger.sort = function(func) {
      if (_isFunction(func)) {
        return _triggers.sort(func);
      }
      var scroll = _win$1.pageYOffset || 0;
      ScrollTrigger.getAll().forEach(function(t2) {
        return t2._sortY = t2.trigger ? scroll + t2.trigger.getBoundingClientRect().top : t2.start + _win$1.innerHeight;
      });
      return _triggers.sort(func || function(a2, b2) {
        return (a2.vars.refreshPriority || 0) * -1e6 + (a2.vars.containerAnimation ? 1e6 : a2._sortY) - ((b2.vars.containerAnimation ? 1e6 : b2._sortY) + (b2.vars.refreshPriority || 0) * -1e6);
      });
    };
    ScrollTrigger.observe = function(vars) {
      return new Observer(vars);
    };
    ScrollTrigger.normalizeScroll = function(vars) {
      if (typeof vars === "undefined") {
        return _normalizer;
      }
      if (vars === true && _normalizer) {
        return _normalizer.enable();
      }
      if (vars === false) {
        _normalizer && _normalizer.kill();
        _normalizer = vars;
        return;
      }
      var normalizer = vars instanceof Observer ? vars : _getScrollNormalizer(vars);
      _normalizer && _normalizer.target === normalizer.target && _normalizer.kill();
      _isViewport(normalizer.target) && (_normalizer = normalizer);
      return normalizer;
    };
    ScrollTrigger.core = {
      // smaller file size way to leverage in ScrollSmoother and Observer
      _getVelocityProp,
      _inputObserver,
      _scrollers,
      _proxies,
      bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
          _lastScrollTime || _dispatch("scrollStart");
          _lastScrollTime = _getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
          return _refreshing;
        }
      }
    };
    _getGSAP$1() && gsap$2.registerPlugin(ScrollTrigger);
    /*!
     * paths 3.13.0
     * https://gsap.com
     *
     * Copyright 2008-2025, GreenSock. All rights reserved.
     * Subject to the terms at https://gsap.com/standard-license
     * @author: Jack Doyle, jack@greensock.com
    */
    var _svgPathExp = /[achlmqstvz]|(-?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/ig, _scientific = /[\+\-]?\d*\.?\d+e[\+\-]?\d+/ig, _DEG2RAD$1 = Math.PI / 180, _sin = Math.sin, _cos = Math.cos, _abs = Math.abs, _sqrt = Math.sqrt, _isNumber = function _isNumber2(value) {
      return typeof value === "number";
    }, _roundingNum = 1e5, _round$2 = function _round2(value) {
      return Math.round(value * _roundingNum) / _roundingNum || 0;
    };
    function transformRawPath(rawPath, a2, b2, c2, d2, tx, ty) {
      var j2 = rawPath.length, segment, l2, i2, x2, y2;
      while (--j2 > -1) {
        segment = rawPath[j2];
        l2 = segment.length;
        for (i2 = 0; i2 < l2; i2 += 2) {
          x2 = segment[i2];
          y2 = segment[i2 + 1];
          segment[i2] = x2 * a2 + y2 * c2 + tx;
          segment[i2 + 1] = x2 * b2 + y2 * d2 + ty;
        }
      }
      rawPath._dirty = 1;
      return rawPath;
    }
    function arcToSegment(lastX, lastY, rx, ry, angle, largeArcFlag, sweepFlag, x2, y2) {
      if (lastX === x2 && lastY === y2) {
        return;
      }
      rx = _abs(rx);
      ry = _abs(ry);
      var angleRad = angle % 360 * _DEG2RAD$1, cosAngle = _cos(angleRad), sinAngle = _sin(angleRad), PI = Math.PI, TWOPI = PI * 2, dx2 = (lastX - x2) / 2, dy2 = (lastY - y2) / 2, x1 = cosAngle * dx2 + sinAngle * dy2, y1 = -sinAngle * dx2 + cosAngle * dy2, x1_sq = x1 * x1, y1_sq = y1 * y1, radiiCheck = x1_sq / (rx * rx) + y1_sq / (ry * ry);
      if (radiiCheck > 1) {
        rx = _sqrt(radiiCheck) * rx;
        ry = _sqrt(radiiCheck) * ry;
      }
      var rx_sq = rx * rx, ry_sq = ry * ry, sq = (rx_sq * ry_sq - rx_sq * y1_sq - ry_sq * x1_sq) / (rx_sq * y1_sq + ry_sq * x1_sq);
      if (sq < 0) {
        sq = 0;
      }
      var coef = (largeArcFlag === sweepFlag ? -1 : 1) * _sqrt(sq), cx1 = coef * (rx * y1 / ry), cy1 = coef * -(ry * x1 / rx), sx2 = (lastX + x2) / 2, sy2 = (lastY + y2) / 2, cx = sx2 + (cosAngle * cx1 - sinAngle * cy1), cy = sy2 + (sinAngle * cx1 + cosAngle * cy1), ux = (x1 - cx1) / rx, uy = (y1 - cy1) / ry, vx = (-x1 - cx1) / rx, vy = (-y1 - cy1) / ry, temp = ux * ux + uy * uy, angleStart = (uy < 0 ? -1 : 1) * Math.acos(ux / _sqrt(temp)), angleExtent = (ux * vy - uy * vx < 0 ? -1 : 1) * Math.acos((ux * vx + uy * vy) / _sqrt(temp * (vx * vx + vy * vy)));
      isNaN(angleExtent) && (angleExtent = PI);
      if (!sweepFlag && angleExtent > 0) {
        angleExtent -= TWOPI;
      } else if (sweepFlag && angleExtent < 0) {
        angleExtent += TWOPI;
      }
      angleStart %= TWOPI;
      angleExtent %= TWOPI;
      var segments = Math.ceil(_abs(angleExtent) / (TWOPI / 4)), rawPath = [], angleIncrement = angleExtent / segments, controlLength = 4 / 3 * _sin(angleIncrement / 2) / (1 + _cos(angleIncrement / 2)), ma = cosAngle * rx, mb = sinAngle * rx, mc = sinAngle * -ry, md = cosAngle * ry, i2;
      for (i2 = 0; i2 < segments; i2++) {
        angle = angleStart + i2 * angleIncrement;
        x1 = _cos(angle);
        y1 = _sin(angle);
        ux = _cos(angle += angleIncrement);
        uy = _sin(angle);
        rawPath.push(x1 - controlLength * y1, y1 + controlLength * x1, ux + controlLength * uy, uy - controlLength * ux, ux, uy);
      }
      for (i2 = 0; i2 < rawPath.length; i2 += 2) {
        x1 = rawPath[i2];
        y1 = rawPath[i2 + 1];
        rawPath[i2] = x1 * ma + y1 * mc + cx;
        rawPath[i2 + 1] = x1 * mb + y1 * md + cy;
      }
      rawPath[i2 - 2] = x2;
      rawPath[i2 - 1] = y2;
      return rawPath;
    }
    function stringToRawPath(d2) {
      var a2 = (d2 + "").replace(_scientific, function(m2) {
        var n2 = +m2;
        return n2 < 1e-4 && n2 > -1e-4 ? 0 : n2;
      }).match(_svgPathExp) || [], path = [], relativeX = 0, relativeY = 0, twoThirds = 2 / 3, elements = a2.length, points = 0, errorMessage = "ERROR: malformed path: " + d2, i2, j2, x2, y2, command, isRelative, segment, startX, startY, difX, difY, beziers, prevCommand, flag1, flag2, line = function line2(sx, sy, ex, ey) {
        difX = (ex - sx) / 3;
        difY = (ey - sy) / 3;
        segment.push(sx + difX, sy + difY, ex - difX, ey - difY, ex, ey);
      };
      if (!d2 || !isNaN(a2[0]) || isNaN(a2[1])) {
        console.log(errorMessage);
        return path;
      }
      for (i2 = 0; i2 < elements; i2++) {
        prevCommand = command;
        if (isNaN(a2[i2])) {
          command = a2[i2].toUpperCase();
          isRelative = command !== a2[i2];
        } else {
          i2--;
        }
        x2 = +a2[i2 + 1];
        y2 = +a2[i2 + 2];
        if (isRelative) {
          x2 += relativeX;
          y2 += relativeY;
        }
        if (!i2) {
          startX = x2;
          startY = y2;
        }
        if (command === "M") {
          if (segment) {
            if (segment.length < 8) {
              path.length -= 1;
            } else {
              points += segment.length;
            }
          }
          relativeX = startX = x2;
          relativeY = startY = y2;
          segment = [x2, y2];
          path.push(segment);
          i2 += 2;
          command = "L";
        } else if (command === "C") {
          if (!segment) {
            segment = [0, 0];
          }
          if (!isRelative) {
            relativeX = relativeY = 0;
          }
          segment.push(x2, y2, relativeX + a2[i2 + 3] * 1, relativeY + a2[i2 + 4] * 1, relativeX += a2[i2 + 5] * 1, relativeY += a2[i2 + 6] * 1);
          i2 += 6;
        } else if (command === "S") {
          difX = relativeX;
          difY = relativeY;
          if (prevCommand === "C" || prevCommand === "S") {
            difX += relativeX - segment[segment.length - 4];
            difY += relativeY - segment[segment.length - 3];
          }
          if (!isRelative) {
            relativeX = relativeY = 0;
          }
          segment.push(difX, difY, x2, y2, relativeX += a2[i2 + 3] * 1, relativeY += a2[i2 + 4] * 1);
          i2 += 4;
        } else if (command === "Q") {
          difX = relativeX + (x2 - relativeX) * twoThirds;
          difY = relativeY + (y2 - relativeY) * twoThirds;
          if (!isRelative) {
            relativeX = relativeY = 0;
          }
          relativeX += a2[i2 + 3] * 1;
          relativeY += a2[i2 + 4] * 1;
          segment.push(difX, difY, relativeX + (x2 - relativeX) * twoThirds, relativeY + (y2 - relativeY) * twoThirds, relativeX, relativeY);
          i2 += 4;
        } else if (command === "T") {
          difX = relativeX - segment[segment.length - 4];
          difY = relativeY - segment[segment.length - 3];
          segment.push(relativeX + difX, relativeY + difY, x2 + (relativeX + difX * 1.5 - x2) * twoThirds, y2 + (relativeY + difY * 1.5 - y2) * twoThirds, relativeX = x2, relativeY = y2);
          i2 += 2;
        } else if (command === "H") {
          line(relativeX, relativeY, relativeX = x2, relativeY);
          i2 += 1;
        } else if (command === "V") {
          line(relativeX, relativeY, relativeX, relativeY = x2 + (isRelative ? relativeY - relativeX : 0));
          i2 += 1;
        } else if (command === "L" || command === "Z") {
          if (command === "Z") {
            x2 = startX;
            y2 = startY;
            segment.closed = true;
          }
          if (command === "L" || _abs(relativeX - x2) > 0.5 || _abs(relativeY - y2) > 0.5) {
            line(relativeX, relativeY, x2, y2);
            if (command === "L") {
              i2 += 2;
            }
          }
          relativeX = x2;
          relativeY = y2;
        } else if (command === "A") {
          flag1 = a2[i2 + 4];
          flag2 = a2[i2 + 5];
          difX = a2[i2 + 6];
          difY = a2[i2 + 7];
          j2 = 7;
          if (flag1.length > 1) {
            if (flag1.length < 3) {
              difY = difX;
              difX = flag2;
              j2--;
            } else {
              difY = flag2;
              difX = flag1.substr(2);
              j2 -= 2;
            }
            flag2 = flag1.charAt(1);
            flag1 = flag1.charAt(0);
          }
          beziers = arcToSegment(relativeX, relativeY, +a2[i2 + 1], +a2[i2 + 2], +a2[i2 + 3], +flag1, +flag2, (isRelative ? relativeX : 0) + difX * 1, (isRelative ? relativeY : 0) + difY * 1);
          i2 += j2;
          if (beziers) {
            for (j2 = 0; j2 < beziers.length; j2++) {
              segment.push(beziers[j2]);
            }
          }
          relativeX = segment[segment.length - 2];
          relativeY = segment[segment.length - 1];
        } else {
          console.log(errorMessage);
        }
      }
      i2 = segment.length;
      if (i2 < 6) {
        path.pop();
        i2 = 0;
      } else if (segment[0] === segment[i2 - 2] && segment[1] === segment[i2 - 1]) {
        segment.closed = true;
      }
      path.totalPoints = points + i2;
      return path;
    }
    function rawPathToString(rawPath) {
      if (_isNumber(rawPath[0])) {
        rawPath = [rawPath];
      }
      var result = "", l2 = rawPath.length, sl, s2, i2, segment;
      for (s2 = 0; s2 < l2; s2++) {
        segment = rawPath[s2];
        result += "M" + _round$2(segment[0]) + "," + _round$2(segment[1]) + " C";
        sl = segment.length;
        for (i2 = 2; i2 < sl; i2++) {
          result += _round$2(segment[i2++]) + "," + _round$2(segment[i2++]) + " " + _round$2(segment[i2++]) + "," + _round$2(segment[i2++]) + " " + _round$2(segment[i2++]) + "," + _round$2(segment[i2]) + " ";
        }
        if (segment.closed) {
          result += "z";
        }
      }
      return result;
    }
    /*!
     * CustomEase 3.13.0
     * https://gsap.com
     *
     * @license Copyright 2008-2025, GreenSock. All rights reserved.
     * Subject to the terms at https://gsap.com/standard-license
     * @author: Jack Doyle, jack@greensock.com
    */
    var gsap$1, _coreInitted, _getGSAP = function _getGSAP2() {
      return gsap$1 || typeof window !== "undefined" && (gsap$1 = window.gsap) && gsap$1.registerPlugin && gsap$1;
    }, _initCore = function _initCore2() {
      gsap$1 = _getGSAP();
      if (gsap$1) {
        gsap$1.registerEase("_CE", CustomEase.create);
        _coreInitted = 1;
      } else {
        console.warn("Please gsap.registerPlugin(CustomEase)");
      }
    }, _bigNum = 1e20, _round$1 = function _round2(value) {
      return ~~(value * 1e3 + (value < 0 ? -0.5 : 0.5)) / 1e3;
    }, _numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/gi, _needsParsingExp = /[cLlsSaAhHvVtTqQ]/g, _findMinimum = function _findMinimum2(values) {
      var l2 = values.length, min = _bigNum, i2;
      for (i2 = 1; i2 < l2; i2 += 6) {
        +values[i2] < min && (min = +values[i2]);
      }
      return min;
    }, _normalize = function _normalize2(values, height, originY) {
      if (!originY && originY !== 0) {
        originY = Math.max(+values[values.length - 1], +values[1]);
      }
      var tx = +values[0] * -1, ty = -originY, l2 = values.length, sx = 1 / (+values[l2 - 2] + tx), sy = -height || (Math.abs(+values[l2 - 1] - +values[1]) < 0.01 * (+values[l2 - 2] - +values[0]) ? _findMinimum(values) + ty : +values[l2 - 1] + ty), i2;
      if (sy) {
        sy = 1 / sy;
      } else {
        sy = -sx;
      }
      for (i2 = 0; i2 < l2; i2 += 2) {
        values[i2] = (+values[i2] + tx) * sx;
        values[i2 + 1] = (+values[i2 + 1] + ty) * sy;
      }
    }, _bezierToPoints = function _bezierToPoints2(x1, y1, x2, y2, x3, y3, x4, y4, threshold, points, index) {
      var x12 = (x1 + x2) / 2, y12 = (y1 + y2) / 2, x23 = (x2 + x3) / 2, y23 = (y2 + y3) / 2, x34 = (x3 + x4) / 2, y34 = (y3 + y4) / 2, x123 = (x12 + x23) / 2, y123 = (y12 + y23) / 2, x234 = (x23 + x34) / 2, y234 = (y23 + y34) / 2, x1234 = (x123 + x234) / 2, y1234 = (y123 + y234) / 2, dx = x4 - x1, dy = y4 - y1, d2 = Math.abs((x2 - x4) * dy - (y2 - y4) * dx), d3 = Math.abs((x3 - x4) * dy - (y3 - y4) * dx), length;
      if (!points) {
        points = [{
          x: x1,
          y: y1
        }, {
          x: x4,
          y: y4
        }];
        index = 1;
      }
      points.splice(index || points.length - 1, 0, {
        x: x1234,
        y: y1234
      });
      if ((d2 + d3) * (d2 + d3) > threshold * (dx * dx + dy * dy)) {
        length = points.length;
        _bezierToPoints2(x1, y1, x12, y12, x123, y123, x1234, y1234, threshold, points, index);
        _bezierToPoints2(x1234, y1234, x234, y234, x34, y34, x4, y4, threshold, points, index + 1 + (points.length - length));
      }
      return points;
    };
    var CustomEase = /* @__PURE__ */ function() {
      function CustomEase2(id, data, config) {
        _coreInitted || _initCore();
        this.id = id;
        this.setData(data, config);
      }
      var _proto = CustomEase2.prototype;
      _proto.setData = function setData(data, config) {
        config = config || {};
        data = data || "0,0,1,1";
        var values = data.match(_numExp), closest = 1, points = [], lookup = [], precision = config.precision || 1, fast = precision <= 1, l2, a1, a2, i2, inc, j2, point, prevPoint, p2;
        this.data = data;
        if (_needsParsingExp.test(data) || ~data.indexOf("M") && data.indexOf("C") < 0) {
          values = stringToRawPath(data)[0];
        }
        l2 = values.length;
        if (l2 === 4) {
          values.unshift(0, 0);
          values.push(1, 1);
          l2 = 8;
        } else if ((l2 - 2) % 6) {
          throw "Invalid CustomEase";
        }
        if (+values[0] !== 0 || +values[l2 - 2] !== 1) {
          _normalize(values, config.height, config.originY);
        }
        this.segment = values;
        for (i2 = 2; i2 < l2; i2 += 6) {
          a1 = {
            x: +values[i2 - 2],
            y: +values[i2 - 1]
          };
          a2 = {
            x: +values[i2 + 4],
            y: +values[i2 + 5]
          };
          points.push(a1, a2);
          _bezierToPoints(a1.x, a1.y, +values[i2], +values[i2 + 1], +values[i2 + 2], +values[i2 + 3], a2.x, a2.y, 1 / (precision * 2e5), points, points.length - 1);
        }
        l2 = points.length;
        for (i2 = 0; i2 < l2; i2++) {
          point = points[i2];
          prevPoint = points[i2 - 1] || point;
          if ((point.x > prevPoint.x || prevPoint.y !== point.y && prevPoint.x === point.x || point === prevPoint) && point.x <= 1) {
            prevPoint.cx = point.x - prevPoint.x;
            prevPoint.cy = point.y - prevPoint.y;
            prevPoint.n = point;
            prevPoint.nx = point.x;
            if (fast && i2 > 1 && Math.abs(prevPoint.cy / prevPoint.cx - points[i2 - 2].cy / points[i2 - 2].cx) > 2) {
              fast = 0;
            }
            if (prevPoint.cx < closest) {
              if (!prevPoint.cx) {
                prevPoint.cx = 1e-3;
                if (i2 === l2 - 1) {
                  prevPoint.x -= 1e-3;
                  closest = Math.min(closest, 1e-3);
                  fast = 0;
                }
              } else {
                closest = prevPoint.cx;
              }
            }
          } else {
            points.splice(i2--, 1);
            l2--;
          }
        }
        l2 = 1 / closest + 1 | 0;
        inc = 1 / l2;
        j2 = 0;
        point = points[0];
        if (fast) {
          for (i2 = 0; i2 < l2; i2++) {
            p2 = i2 * inc;
            if (point.nx < p2) {
              point = points[++j2];
            }
            a1 = point.y + (p2 - point.x) / point.cx * point.cy;
            lookup[i2] = {
              x: p2,
              cx: inc,
              y: a1,
              cy: 0,
              nx: 9
            };
            if (i2) {
              lookup[i2 - 1].cy = a1 - lookup[i2 - 1].y;
            }
          }
          j2 = points[points.length - 1];
          lookup[l2 - 1].cy = j2.y - a1;
          lookup[l2 - 1].cx = j2.x - lookup[lookup.length - 1].x;
        } else {
          for (i2 = 0; i2 < l2; i2++) {
            if (point.nx < i2 * inc) {
              point = points[++j2];
            }
            lookup[i2] = point;
          }
          if (j2 < points.length - 1) {
            lookup[i2 - 1] = points[points.length - 2];
          }
        }
        this.ease = function(p3) {
          var point2 = lookup[p3 * l2 | 0] || lookup[l2 - 1];
          if (point2.nx < p3) {
            point2 = point2.n;
          }
          return point2.y + (p3 - point2.x) / point2.cx * point2.cy;
        };
        this.ease.custom = this;
        this.id && gsap$1 && gsap$1.registerEase(this.id, this.ease);
        return this;
      };
      _proto.getSVGData = function getSVGData(config) {
        return CustomEase2.getSVGData(this, config);
      };
      CustomEase2.create = function create(id, data, config) {
        return new CustomEase2(id, data, config).ease;
      };
      CustomEase2.register = function register(core) {
        gsap$1 = core;
        _initCore();
      };
      CustomEase2.get = function get(id) {
        return gsap$1.parseEase(id);
      };
      CustomEase2.getSVGData = function getSVGData(ease, config) {
        config = config || {};
        var width = config.width || 100, height = config.height || 100, x2 = config.x || 0, y2 = (config.y || 0) + height, e2 = gsap$1.utils.toArray(config.path)[0], a2, slope, i2, inc, tx, ty, precision, threshold, prevX, prevY;
        if (config.invert) {
          height = -height;
          y2 = 0;
        }
        if (typeof ease === "string") {
          ease = gsap$1.parseEase(ease);
        }
        if (ease.custom) {
          ease = ease.custom;
        }
        if (ease instanceof CustomEase2) {
          a2 = rawPathToString(transformRawPath([ease.segment], width, 0, 0, -height, x2, y2));
        } else {
          a2 = [x2, y2];
          precision = Math.max(5, (config.precision || 1) * 200);
          inc = 1 / precision;
          precision += 2;
          threshold = 5 / precision;
          prevX = _round$1(x2 + inc * width);
          prevY = _round$1(y2 + ease(inc) * -height);
          slope = (prevY - y2) / (prevX - x2);
          for (i2 = 2; i2 < precision; i2++) {
            tx = _round$1(x2 + i2 * inc * width);
            ty = _round$1(y2 + ease(i2 * inc) * -height);
            if (Math.abs((ty - prevY) / (tx - prevX) - slope) > threshold || i2 === precision - 1) {
              a2.push(prevX, prevY);
              slope = (ty - prevY) / (tx - prevX);
            }
            prevX = tx;
            prevY = ty;
          }
          a2 = "M" + a2.join(",");
        }
        e2 && e2.setAttribute("d", a2);
        return a2;
      };
      return CustomEase2;
    }();
    CustomEase.version = "3.13.0";
    CustomEase.headless = true;
    _getGSAP() && gsap$1.registerPlugin(CustomEase);
    /*!
     * matrix 3.13.0
     * https://gsap.com
     *
     * Copyright 2008-2025, GreenSock. All rights reserved.
     * Subject to the terms at https://gsap.com/standard-license
     * @author: Jack Doyle, jack@greensock.com
    */
    var _doc, _win, _docElement, _body$1, _divContainer, _svgContainer, _identityMatrix, _gEl, _transformProp = "transform", _transformOriginProp = _transformProp + "Origin", _hasOffsetBug, _setDoc = function _setDoc2(element) {
      var doc = element.ownerDocument || element;
      if (!(_transformProp in element.style) && "msTransform" in element.style) {
        _transformProp = "msTransform";
        _transformOriginProp = _transformProp + "Origin";
      }
      while (doc.parentNode && (doc = doc.parentNode)) {
      }
      _win = window;
      _identityMatrix = new Matrix2D();
      if (doc) {
        _doc = doc;
        _docElement = doc.documentElement;
        _body$1 = doc.body;
        _gEl = _doc.createElementNS("http://www.w3.org/2000/svg", "g");
        _gEl.style.transform = "none";
        var d1 = doc.createElement("div"), d2 = doc.createElement("div"), root = doc && (doc.body || doc.firstElementChild);
        if (root && root.appendChild) {
          root.appendChild(d1);
          d1.appendChild(d2);
          d1.setAttribute("style", "position:static;transform:translate3d(0,0,1px)");
          _hasOffsetBug = d2.offsetParent !== d1;
          root.removeChild(d1);
        }
      }
      return doc;
    }, _forceNonZeroScale = function _forceNonZeroScale2(e2) {
      var a2, cache;
      while (e2 && e2 !== _body$1) {
        cache = e2._gsap;
        cache && cache.uncache && cache.get(e2, "x");
        if (cache && !cache.scaleX && !cache.scaleY && cache.renderTransform) {
          cache.scaleX = cache.scaleY = 1e-4;
          cache.renderTransform(1, cache);
          a2 ? a2.push(cache) : a2 = [cache];
        }
        e2 = e2.parentNode;
      }
      return a2;
    }, _svgTemps = [], _divTemps = [], _getDocScrollTop = function _getDocScrollTop2() {
      return _win.pageYOffset || _doc.scrollTop || _docElement.scrollTop || _body$1.scrollTop || 0;
    }, _getDocScrollLeft = function _getDocScrollLeft2() {
      return _win.pageXOffset || _doc.scrollLeft || _docElement.scrollLeft || _body$1.scrollLeft || 0;
    }, _svgOwner = function _svgOwner2(element) {
      return element.ownerSVGElement || ((element.tagName + "").toLowerCase() === "svg" ? element : null);
    }, _isFixed = function _isFixed2(element) {
      if (_win.getComputedStyle(element).position === "fixed") {
        return true;
      }
      element = element.parentNode;
      if (element && element.nodeType === 1) {
        return _isFixed2(element);
      }
    }, _createSibling = function _createSibling2(element, i2) {
      if (element.parentNode && (_doc || _setDoc(element))) {
        var svg = _svgOwner(element), ns = svg ? svg.getAttribute("xmlns") || "http://www.w3.org/2000/svg" : "http://www.w3.org/1999/xhtml", type = svg ? i2 ? "rect" : "g" : "div", x2 = i2 !== 2 ? 0 : 100, y2 = i2 === 3 ? 100 : 0, css = "position:absolute;display:block;pointer-events:none;margin:0;padding:0;", e2 = _doc.createElementNS ? _doc.createElementNS(ns.replace(/^https/, "http"), type) : _doc.createElement(type);
        if (i2) {
          if (!svg) {
            if (!_divContainer) {
              _divContainer = _createSibling2(element);
              _divContainer.style.cssText = css;
            }
            e2.style.cssText = css + "width:0.1px;height:0.1px;top:" + y2 + "px;left:" + x2 + "px";
            _divContainer.appendChild(e2);
          } else {
            _svgContainer || (_svgContainer = _createSibling2(element));
            e2.setAttribute("width", 0.01);
            e2.setAttribute("height", 0.01);
            e2.setAttribute("transform", "translate(" + x2 + "," + y2 + ")");
            _svgContainer.appendChild(e2);
          }
        }
        return e2;
      }
      throw "Need document and parent.";
    }, _consolidate = function _consolidate2(m2) {
      var c2 = new Matrix2D(), i2 = 0;
      for (; i2 < m2.numberOfItems; i2++) {
        c2.multiply(m2.getItem(i2).matrix);
      }
      return c2;
    }, _getCTM = function _getCTM2(svg) {
      var m2 = svg.getCTM(), transform;
      if (!m2) {
        transform = svg.style[_transformProp];
        svg.style[_transformProp] = "none";
        svg.appendChild(_gEl);
        m2 = _gEl.getCTM();
        svg.removeChild(_gEl);
        transform ? svg.style[_transformProp] = transform : svg.style.removeProperty(_transformProp.replace(/([A-Z])/g, "-$1").toLowerCase());
      }
      return m2 || _identityMatrix.clone();
    }, _placeSiblings = function _placeSiblings2(element, adjustGOffset) {
      var svg = _svgOwner(element), isRootSVG = element === svg, siblings = svg ? _svgTemps : _divTemps, parent = element.parentNode, appendToEl = parent && !svg && parent.shadowRoot && parent.shadowRoot.appendChild ? parent.shadowRoot : parent, container, m2, b2, x2, y2, cs;
      if (element === _win) {
        return element;
      }
      siblings.length || siblings.push(_createSibling(element, 1), _createSibling(element, 2), _createSibling(element, 3));
      container = svg ? _svgContainer : _divContainer;
      if (svg) {
        if (isRootSVG) {
          b2 = _getCTM(element);
          x2 = -b2.e / b2.a;
          y2 = -b2.f / b2.d;
          m2 = _identityMatrix;
        } else if (element.getBBox) {
          b2 = element.getBBox();
          m2 = element.transform ? element.transform.baseVal : {};
          m2 = !m2.numberOfItems ? _identityMatrix : m2.numberOfItems > 1 ? _consolidate(m2) : m2.getItem(0).matrix;
          x2 = m2.a * b2.x + m2.c * b2.y;
          y2 = m2.b * b2.x + m2.d * b2.y;
        } else {
          m2 = new Matrix2D();
          x2 = y2 = 0;
        }
        if (adjustGOffset && element.tagName.toLowerCase() === "g") {
          x2 = y2 = 0;
        }
        (isRootSVG ? svg : parent).appendChild(container);
        container.setAttribute("transform", "matrix(" + m2.a + "," + m2.b + "," + m2.c + "," + m2.d + "," + (m2.e + x2) + "," + (m2.f + y2) + ")");
      } else {
        x2 = y2 = 0;
        if (_hasOffsetBug) {
          m2 = element.offsetParent;
          b2 = element;
          while (b2 && (b2 = b2.parentNode) && b2 !== m2 && b2.parentNode) {
            if ((_win.getComputedStyle(b2)[_transformProp] + "").length > 4) {
              x2 = b2.offsetLeft;
              y2 = b2.offsetTop;
              b2 = 0;
            }
          }
        }
        cs = _win.getComputedStyle(element);
        if (cs.position !== "absolute" && cs.position !== "fixed") {
          m2 = element.offsetParent;
          while (parent && parent !== m2) {
            x2 += parent.scrollLeft || 0;
            y2 += parent.scrollTop || 0;
            parent = parent.parentNode;
          }
        }
        b2 = container.style;
        b2.top = element.offsetTop - y2 + "px";
        b2.left = element.offsetLeft - x2 + "px";
        b2[_transformProp] = cs[_transformProp];
        b2[_transformOriginProp] = cs[_transformOriginProp];
        b2.position = cs.position === "fixed" ? "fixed" : "absolute";
        appendToEl.appendChild(container);
      }
      return container;
    }, _setMatrix = function _setMatrix2(m2, a2, b2, c2, d2, e2, f2) {
      m2.a = a2;
      m2.b = b2;
      m2.c = c2;
      m2.d = d2;
      m2.e = e2;
      m2.f = f2;
      return m2;
    };
    var Matrix2D = /* @__PURE__ */ function() {
      function Matrix2D2(a2, b2, c2, d2, e2, f2) {
        if (a2 === void 0) {
          a2 = 1;
        }
        if (b2 === void 0) {
          b2 = 0;
        }
        if (c2 === void 0) {
          c2 = 0;
        }
        if (d2 === void 0) {
          d2 = 1;
        }
        if (e2 === void 0) {
          e2 = 0;
        }
        if (f2 === void 0) {
          f2 = 0;
        }
        _setMatrix(this, a2, b2, c2, d2, e2, f2);
      }
      var _proto = Matrix2D2.prototype;
      _proto.inverse = function inverse() {
        var a2 = this.a, b2 = this.b, c2 = this.c, d2 = this.d, e2 = this.e, f2 = this.f, determinant = a2 * d2 - b2 * c2 || 1e-10;
        return _setMatrix(this, d2 / determinant, -b2 / determinant, -c2 / determinant, a2 / determinant, (c2 * f2 - d2 * e2) / determinant, -(a2 * f2 - b2 * e2) / determinant);
      };
      _proto.multiply = function multiply(matrix) {
        var a2 = this.a, b2 = this.b, c2 = this.c, d2 = this.d, e2 = this.e, f2 = this.f, a22 = matrix.a, b22 = matrix.c, c22 = matrix.b, d22 = matrix.d, e22 = matrix.e, f22 = matrix.f;
        return _setMatrix(this, a22 * a2 + c22 * c2, a22 * b2 + c22 * d2, b22 * a2 + d22 * c2, b22 * b2 + d22 * d2, e2 + e22 * a2 + f22 * c2, f2 + e22 * b2 + f22 * d2);
      };
      _proto.clone = function clone() {
        return new Matrix2D2(this.a, this.b, this.c, this.d, this.e, this.f);
      };
      _proto.equals = function equals(matrix) {
        var a2 = this.a, b2 = this.b, c2 = this.c, d2 = this.d, e2 = this.e, f2 = this.f;
        return a2 === matrix.a && b2 === matrix.b && c2 === matrix.c && d2 === matrix.d && e2 === matrix.e && f2 === matrix.f;
      };
      _proto.apply = function apply(point, decoratee) {
        if (decoratee === void 0) {
          decoratee = {};
        }
        var x2 = point.x, y2 = point.y, a2 = this.a, b2 = this.b, c2 = this.c, d2 = this.d, e2 = this.e, f2 = this.f;
        decoratee.x = x2 * a2 + y2 * c2 + e2 || 0;
        decoratee.y = x2 * b2 + y2 * d2 + f2 || 0;
        return decoratee;
      };
      return Matrix2D2;
    }();
    function getGlobalMatrix(element, inverse, adjustGOffset, includeScrollInFixed) {
      if (!element || !element.parentNode || (_doc || _setDoc(element)).documentElement === element) {
        return new Matrix2D();
      }
      var zeroScales = _forceNonZeroScale(element), svg = _svgOwner(element), temps = svg ? _svgTemps : _divTemps, container = _placeSiblings(element, adjustGOffset), b1 = temps[0].getBoundingClientRect(), b2 = temps[1].getBoundingClientRect(), b3 = temps[2].getBoundingClientRect(), parent = container.parentNode, isFixed = !includeScrollInFixed && _isFixed(element), m2 = new Matrix2D((b2.left - b1.left) / 100, (b2.top - b1.top) / 100, (b3.left - b1.left) / 100, (b3.top - b1.top) / 100, b1.left + (isFixed ? 0 : _getDocScrollLeft()), b1.top + (isFixed ? 0 : _getDocScrollTop()));
      parent.removeChild(container);
      if (zeroScales) {
        b1 = zeroScales.length;
        while (b1--) {
          b2 = zeroScales[b1];
          b2.scaleX = b2.scaleY = 0;
          b2.renderTransform(1, b2);
        }
      }
      return inverse ? m2.inverse() : m2;
    }
    /*!
     * Flip 3.13.0
     * https://gsap.com
     *
     * @license Copyright 2008-2025, GreenSock. All rights reserved.
     * Subject to the terms at https://gsap.com/standard-license
     * @author: Jack Doyle, jack@greensock.com
    */
    var _id = 1, _toArray, gsap, _batch, _batchAction, _body, _closestTenth, _getStyleSaver, _forEachBatch = function _forEachBatch2(batch, name) {
      return batch.actions.forEach(function(a2) {
        return a2.vars[name] && a2.vars[name](a2);
      });
    }, _batchLookup = {}, _RAD2DEG = 180 / Math.PI, _DEG2RAD = Math.PI / 180, _emptyObj = {}, _dashedNameLookup = {}, _memoizedRemoveProps = {}, _listToArray = function _listToArray2(list) {
      return typeof list === "string" ? list.split(" ").join("").split(",") : list;
    }, _callbacks = _listToArray("onStart,onUpdate,onComplete,onReverseComplete,onInterrupt"), _removeProps = _listToArray("transform,transformOrigin,width,height,position,top,left,opacity,zIndex,maxWidth,maxHeight,minWidth,minHeight"), _getEl = function _getEl2(target) {
      return _toArray(target)[0] || console.warn("Element not found:", target);
    }, _round = function _round2(value) {
      return Math.round(value * 1e4) / 1e4 || 0;
    }, _toggleClass = function _toggleClass2(targets, className, action) {
      return targets.forEach(function(el) {
        return el.classList[action](className);
      });
    }, _reserved = {
      zIndex: 1,
      kill: 1,
      simple: 1,
      spin: 1,
      clearProps: 1,
      targets: 1,
      toggleClass: 1,
      onComplete: 1,
      onUpdate: 1,
      onInterrupt: 1,
      onStart: 1,
      delay: 1,
      repeat: 1,
      repeatDelay: 1,
      yoyo: 1,
      scale: 1,
      fade: 1,
      absolute: 1,
      props: 1,
      onEnter: 1,
      onLeave: 1,
      custom: 1,
      paused: 1,
      nested: 1,
      prune: 1,
      absoluteOnLeave: 1
    }, _fitReserved = {
      zIndex: 1,
      simple: 1,
      clearProps: 1,
      scale: 1,
      absolute: 1,
      fitChild: 1,
      getVars: 1,
      props: 1
    }, _camelToDashed = function _camelToDashed2(p2) {
      return p2.replace(/([A-Z])/g, "-$1").toLowerCase();
    }, _copy = function _copy2(obj, exclude) {
      var result = {}, p2;
      for (p2 in obj) {
        exclude[p2] || (result[p2] = obj[p2]);
      }
      return result;
    }, _memoizedProps = {}, _memoizeProps = function _memoizeProps2(props) {
      var p2 = _memoizedProps[props] = _listToArray(props);
      _memoizedRemoveProps[props] = p2.concat(_removeProps);
      return p2;
    }, _getInverseGlobalMatrix = function _getInverseGlobalMatrix2(el) {
      var cache = el._gsap || gsap.core.getCache(el);
      if (cache.gmCache === gsap.ticker.frame) {
        return cache.gMatrix;
      }
      cache.gmCache = gsap.ticker.frame;
      return cache.gMatrix = getGlobalMatrix(el, true, false, true);
    }, _getDOMDepth = function _getDOMDepth2(el, invert, level) {
      if (level === void 0) {
        level = 0;
      }
      var parent = el.parentNode, inc = 1e3 * Math.pow(10, level) * (invert ? -1 : 1), l2 = invert ? -inc * 900 : 0;
      while (el) {
        l2 += inc;
        el = el.previousSibling;
      }
      return parent ? l2 + _getDOMDepth2(parent, invert, level + 1) : l2;
    }, _orderByDOMDepth = function _orderByDOMDepth2(comps, invert, isElStates) {
      comps.forEach(function(comp) {
        return comp.d = _getDOMDepth(isElStates ? comp.element : comp.t, invert);
      });
      comps.sort(function(c1, c2) {
        return c1.d - c2.d;
      });
      return comps;
    }, _recordInlineStyles = function _recordInlineStyles2(elState, props) {
      var style = elState.element.style, a2 = elState.css = elState.css || [], i2 = props.length, p2, v2;
      while (i2--) {
        p2 = props[i2];
        v2 = style[p2] || style.getPropertyValue(p2);
        a2.push(v2 ? p2 : _dashedNameLookup[p2] || (_dashedNameLookup[p2] = _camelToDashed(p2)), v2);
      }
      return style;
    }, _applyInlineStyles = function _applyInlineStyles2(state) {
      var css = state.css, style = state.element.style, i2 = 0;
      state.cache.uncache = 1;
      for (; i2 < css.length; i2 += 2) {
        css[i2 + 1] ? style[css[i2]] = css[i2 + 1] : style.removeProperty(css[i2]);
      }
      if (!css[css.indexOf("transform") + 1] && style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
      }
    }, _setFinalStates = function _setFinalStates2(comps, onlyTransforms) {
      comps.forEach(function(c2) {
        return c2.a.cache.uncache = 1;
      });
      onlyTransforms || comps.finalStates.forEach(_applyInlineStyles);
    }, _absoluteProps = "paddingTop,paddingRight,paddingBottom,paddingLeft,gridArea,transition".split(","), _makeAbsolute = function _makeAbsolute2(elState, fallbackNode, ignoreBatch) {
      var element = elState.element, width = elState.width, height = elState.height, uncache = elState.uncache, getProp = elState.getProp, style = element.style, i2 = 4, result, displayIsNone, cs;
      typeof fallbackNode !== "object" && (fallbackNode = elState);
      if (_batch && ignoreBatch !== 1) {
        _batch._abs.push({
          t: element,
          b: elState,
          a: elState,
          sd: 0
        });
        _batch._final.push(function() {
          return (elState.cache.uncache = 1) && _applyInlineStyles(elState);
        });
        return element;
      }
      displayIsNone = getProp("display") === "none";
      if (!elState.isVisible || displayIsNone) {
        displayIsNone && (_recordInlineStyles(elState, ["display"]).display = fallbackNode.display);
        elState.matrix = fallbackNode.matrix;
        elState.width = width = elState.width || fallbackNode.width;
        elState.height = height = elState.height || fallbackNode.height;
      }
      _recordInlineStyles(elState, _absoluteProps);
      cs = window.getComputedStyle(element);
      while (i2--) {
        style[_absoluteProps[i2]] = cs[_absoluteProps[i2]];
      }
      style.gridArea = "1 / 1 / 1 / 1";
      style.transition = "none";
      style.position = "absolute";
      style.width = width + "px";
      style.height = height + "px";
      style.top || (style.top = "0px");
      style.left || (style.left = "0px");
      if (uncache) {
        result = new ElementState(element);
      } else {
        result = _copy(elState, _emptyObj);
        result.position = "absolute";
        if (elState.simple) {
          var bounds = element.getBoundingClientRect();
          result.matrix = new Matrix2D(1, 0, 0, 1, bounds.left + _getDocScrollLeft(), bounds.top + _getDocScrollTop());
        } else {
          result.matrix = getGlobalMatrix(element, false, false, true);
        }
      }
      result = _fit(result, elState, true);
      elState.x = _closestTenth(result.x, 0.01);
      elState.y = _closestTenth(result.y, 0.01);
      return element;
    }, _filterComps = function _filterComps2(comps, targets) {
      if (targets !== true) {
        targets = _toArray(targets);
        comps = comps.filter(function(c2) {
          if (targets.indexOf((c2.sd < 0 ? c2.b : c2.a).element) !== -1) {
            return true;
          } else {
            c2.t._gsap.renderTransform(1);
            if (c2.b.isVisible) {
              c2.t.style.width = c2.b.width + "px";
              c2.t.style.height = c2.b.height + "px";
            }
          }
        });
      }
      return comps;
    }, _makeCompsAbsolute = function _makeCompsAbsolute2(comps) {
      return _orderByDOMDepth(comps, true).forEach(function(c2) {
        return (c2.a.isVisible || c2.b.isVisible) && _makeAbsolute(c2.sd < 0 ? c2.b : c2.a, c2.b, 1);
      });
    }, _findElStateInState = function _findElStateInState2(state, other) {
      return other && state.idLookup[_parseElementState(other).id] || state.elementStates[0];
    }, _parseElementState = function _parseElementState2(elOrNode, props, simple, other) {
      return elOrNode instanceof ElementState ? elOrNode : elOrNode instanceof FlipState ? _findElStateInState(elOrNode, other) : new ElementState(typeof elOrNode === "string" ? _getEl(elOrNode) || console.warn(elOrNode + " not found") : elOrNode, props, simple);
    }, _recordProps = function _recordProps2(elState, props) {
      var getProp = gsap.getProperty(elState.element, null, "native"), obj = elState.props = {}, i2 = props.length;
      while (i2--) {
        obj[props[i2]] = (getProp(props[i2]) + "").trim();
      }
      obj.zIndex && (obj.zIndex = parseFloat(obj.zIndex) || 0);
      return elState;
    }, _applyProps = function _applyProps2(element, props) {
      var style = element.style || element, p2;
      for (p2 in props) {
        style[p2] = props[p2];
      }
    }, _getID = function _getID2(el) {
      var id = el.getAttribute("data-flip-id");
      id || el.setAttribute("data-flip-id", id = "auto-" + _id++);
      return id;
    }, _elementsFromElementStates = function _elementsFromElementStates2(elStates) {
      return elStates.map(function(elState) {
        return elState.element;
      });
    }, _handleCallback = function _handleCallback2(callback, elStates, tl) {
      return callback && elStates.length && tl.add(callback(_elementsFromElementStates(elStates), tl, new FlipState(elStates, 0, true)), 0);
    }, _fit = function _fit2(fromState, toState, scale, applyProps, fitChild, vars) {
      var element = fromState.element, cache = fromState.cache, parent = fromState.parent, x2 = fromState.x, y2 = fromState.y, width = toState.width, height = toState.height, scaleX = toState.scaleX, scaleY = toState.scaleY, rotation = toState.rotation, bounds = toState.bounds, styles = vars && _getStyleSaver && _getStyleSaver(element, "transform,width,height"), dimensionState = fromState, _toState$matrix = toState.matrix, e2 = _toState$matrix.e, f2 = _toState$matrix.f, deep = fromState.bounds.width !== bounds.width || fromState.bounds.height !== bounds.height || fromState.scaleX !== scaleX || fromState.scaleY !== scaleY || fromState.rotation !== rotation, simple = !deep && fromState.simple && toState.simple && !fitChild, skewX, fromPoint, toPoint, getProp, parentMatrix, matrix, bbox;
      if (simple || !parent) {
        scaleX = scaleY = 1;
        rotation = skewX = 0;
      } else {
        parentMatrix = _getInverseGlobalMatrix(parent);
        matrix = parentMatrix.clone().multiply(toState.ctm ? toState.matrix.clone().multiply(toState.ctm) : toState.matrix);
        rotation = _round(Math.atan2(matrix.b, matrix.a) * _RAD2DEG);
        skewX = _round(Math.atan2(matrix.c, matrix.d) * _RAD2DEG + rotation) % 360;
        scaleX = Math.sqrt(Math.pow(matrix.a, 2) + Math.pow(matrix.b, 2));
        scaleY = Math.sqrt(Math.pow(matrix.c, 2) + Math.pow(matrix.d, 2)) * Math.cos(skewX * _DEG2RAD);
        if (fitChild) {
          fitChild = _toArray(fitChild)[0];
          getProp = gsap.getProperty(fitChild);
          bbox = fitChild.getBBox && typeof fitChild.getBBox === "function" && fitChild.getBBox();
          dimensionState = {
            scaleX: getProp("scaleX"),
            scaleY: getProp("scaleY"),
            width: bbox ? bbox.width : Math.ceil(parseFloat(getProp("width", "px"))),
            height: bbox ? bbox.height : parseFloat(getProp("height", "px"))
          };
        }
        cache.rotation = rotation + "deg";
        cache.skewX = skewX + "deg";
      }
      if (scale) {
        scaleX *= width === dimensionState.width || !dimensionState.width ? 1 : width / dimensionState.width;
        scaleY *= height === dimensionState.height || !dimensionState.height ? 1 : height / dimensionState.height;
        cache.scaleX = scaleX;
        cache.scaleY = scaleY;
      } else {
        width = _closestTenth(width * scaleX / dimensionState.scaleX, 0);
        height = _closestTenth(height * scaleY / dimensionState.scaleY, 0);
        element.style.width = width + "px";
        element.style.height = height + "px";
      }
      applyProps && _applyProps(element, toState.props);
      if (simple || !parent) {
        x2 += e2 - fromState.matrix.e;
        y2 += f2 - fromState.matrix.f;
      } else if (deep || parent !== toState.parent) {
        cache.renderTransform(1, cache);
        matrix = getGlobalMatrix(fitChild || element, false, false, true);
        fromPoint = parentMatrix.apply({
          x: matrix.e,
          y: matrix.f
        });
        toPoint = parentMatrix.apply({
          x: e2,
          y: f2
        });
        x2 += toPoint.x - fromPoint.x;
        y2 += toPoint.y - fromPoint.y;
      } else {
        parentMatrix.e = parentMatrix.f = 0;
        toPoint = parentMatrix.apply({
          x: e2 - fromState.matrix.e,
          y: f2 - fromState.matrix.f
        });
        x2 += toPoint.x;
        y2 += toPoint.y;
      }
      x2 = _closestTenth(x2, 0.02);
      y2 = _closestTenth(y2, 0.02);
      if (vars && !(vars instanceof ElementState)) {
        styles && styles.revert();
      } else {
        cache.x = x2 + "px";
        cache.y = y2 + "px";
        cache.renderTransform(1, cache);
      }
      if (vars) {
        vars.x = x2;
        vars.y = y2;
        vars.rotation = rotation;
        vars.skewX = skewX;
        if (scale) {
          vars.scaleX = scaleX;
          vars.scaleY = scaleY;
        } else {
          vars.width = width;
          vars.height = height;
        }
      }
      return vars || cache;
    }, _parseState = function _parseState2(targetsOrState, vars) {
      return targetsOrState instanceof FlipState ? targetsOrState : new FlipState(targetsOrState, vars);
    }, _getChangingElState = function _getChangingElState2(toState, fromState, id) {
      var to1 = toState.idLookup[id], to2 = toState.alt[id];
      return to2.isVisible && (!(fromState.getElementState(to2.element) || to2).isVisible || !to1.isVisible) ? to2 : to1;
    }, _bodyMetrics = [], _bodyProps = "width,height,overflowX,overflowY".split(","), _bodyLocked, _lockBodyScroll = function _lockBodyScroll2(lock) {
      if (lock !== _bodyLocked) {
        var s2 = _body.style, w2 = _body.clientWidth === window.outerWidth, h2 = _body.clientHeight === window.outerHeight, i2 = 4;
        if (lock && (w2 || h2)) {
          while (i2--) {
            _bodyMetrics[i2] = s2[_bodyProps[i2]];
          }
          if (w2) {
            s2.width = _body.clientWidth + "px";
            s2.overflowY = "hidden";
          }
          if (h2) {
            s2.height = _body.clientHeight + "px";
            s2.overflowX = "hidden";
          }
          _bodyLocked = lock;
        } else if (_bodyLocked) {
          while (i2--) {
            _bodyMetrics[i2] ? s2[_bodyProps[i2]] = _bodyMetrics[i2] : s2.removeProperty(_camelToDashed(_bodyProps[i2]));
          }
          _bodyLocked = lock;
        }
      }
    }, _fromTo = function _fromTo2(fromState, toState, vars, relative) {
      fromState instanceof FlipState && toState instanceof FlipState || console.warn("Not a valid state object.");
      vars = vars || {};
      var _vars = vars, clearProps = _vars.clearProps, onEnter = _vars.onEnter, onLeave = _vars.onLeave, absolute = _vars.absolute, absoluteOnLeave = _vars.absoluteOnLeave, custom = _vars.custom, delay = _vars.delay, paused = _vars.paused, repeat = _vars.repeat, repeatDelay = _vars.repeatDelay, yoyo = _vars.yoyo, toggleClass = _vars.toggleClass, nested = _vars.nested, _zIndex = _vars.zIndex, scale = _vars.scale, fade = _vars.fade, stagger = _vars.stagger, spin = _vars.spin, prune = _vars.prune, props = ("props" in vars ? vars : fromState).props, tweenVars = _copy(vars, _reserved), animation = gsap.timeline({
        delay,
        paused,
        repeat,
        repeatDelay,
        yoyo,
        data: "isFlip"
      }), remainingProps = tweenVars, entering = [], leaving = [], comps = [], swapOutTargets = [], spinNum = spin === true ? 1 : spin || 0, spinFunc = typeof spin === "function" ? spin : function() {
        return spinNum;
      }, interrupted = fromState.interrupted || toState.interrupted, addFunc = animation[relative !== 1 ? "to" : "from"], v2, p2, endTime, i2, el, comp, state, targets, finalStates, fromNode, toNode, run, a2, b2;
      for (p2 in toState.idLookup) {
        toNode = !toState.alt[p2] ? toState.idLookup[p2] : _getChangingElState(toState, fromState, p2);
        el = toNode.element;
        fromNode = fromState.idLookup[p2];
        fromState.alt[p2] && el === fromNode.element && (fromState.alt[p2].isVisible || !toNode.isVisible) && (fromNode = fromState.alt[p2]);
        if (fromNode) {
          comp = {
            t: el,
            b: fromNode,
            a: toNode,
            sd: fromNode.element === el ? 0 : toNode.isVisible ? 1 : -1
          };
          comps.push(comp);
          if (comp.sd) {
            if (comp.sd < 0) {
              comp.b = toNode;
              comp.a = fromNode;
            }
            interrupted && _recordInlineStyles(comp.b, props ? _memoizedRemoveProps[props] : _removeProps);
            fade && comps.push(comp.swap = {
              t: fromNode.element,
              b: comp.b,
              a: comp.a,
              sd: -comp.sd,
              swap: comp
            });
          }
          el._flip = fromNode.element._flip = _batch ? _batch.timeline : animation;
        } else if (toNode.isVisible) {
          comps.push({
            t: el,
            b: _copy(toNode, {
              isVisible: 1
            }),
            a: toNode,
            sd: 0,
            entering: 1
          });
          el._flip = _batch ? _batch.timeline : animation;
        }
      }
      props && (_memoizedProps[props] || _memoizeProps(props)).forEach(function(p3) {
        return tweenVars[p3] = function(i3) {
          return comps[i3].a.props[p3];
        };
      });
      comps.finalStates = finalStates = [];
      run = function run2() {
        _orderByDOMDepth(comps);
        _lockBodyScroll(true);
        for (i2 = 0; i2 < comps.length; i2++) {
          comp = comps[i2];
          a2 = comp.a;
          b2 = comp.b;
          if (prune && !a2.isDifferent(b2) && !comp.entering) {
            comps.splice(i2--, 1);
          } else {
            el = comp.t;
            nested && !(comp.sd < 0) && i2 && (a2.matrix = getGlobalMatrix(el, false, false, true));
            if (b2.isVisible && a2.isVisible) {
              if (comp.sd < 0) {
                state = new ElementState(el, props, fromState.simple);
                _fit(state, a2, scale, 0, 0, state);
                state.matrix = getGlobalMatrix(el, false, false, true);
                state.css = comp.b.css;
                comp.a = a2 = state;
                fade && (el.style.opacity = interrupted ? b2.opacity : a2.opacity);
                stagger && swapOutTargets.push(el);
              } else if (comp.sd > 0 && fade) {
                el.style.opacity = interrupted ? a2.opacity - b2.opacity : "0";
              }
              _fit(a2, b2, scale, props);
            } else if (b2.isVisible !== a2.isVisible) {
              if (!b2.isVisible) {
                a2.isVisible && entering.push(a2);
                comps.splice(i2--, 1);
              } else if (!a2.isVisible) {
                b2.css = a2.css;
                leaving.push(b2);
                comps.splice(i2--, 1);
                absolute && nested && _fit(a2, b2, scale, props);
              }
            }
            if (!scale) {
              el.style.maxWidth = Math.max(a2.width, b2.width) + "px";
              el.style.maxHeight = Math.max(a2.height, b2.height) + "px";
              el.style.minWidth = Math.min(a2.width, b2.width) + "px";
              el.style.minHeight = Math.min(a2.height, b2.height) + "px";
            }
            nested && toggleClass && el.classList.add(toggleClass);
          }
          finalStates.push(a2);
        }
        var classTargets;
        if (toggleClass) {
          classTargets = finalStates.map(function(s2) {
            return s2.element;
          });
          nested && classTargets.forEach(function(e2) {
            return e2.classList.remove(toggleClass);
          });
        }
        _lockBodyScroll(false);
        if (scale) {
          tweenVars.scaleX = function(i3) {
            return comps[i3].a.scaleX;
          };
          tweenVars.scaleY = function(i3) {
            return comps[i3].a.scaleY;
          };
        } else {
          tweenVars.width = function(i3) {
            return comps[i3].a.width + "px";
          };
          tweenVars.height = function(i3) {
            return comps[i3].a.height + "px";
          };
          tweenVars.autoRound = vars.autoRound || false;
        }
        tweenVars.x = function(i3) {
          return comps[i3].a.x + "px";
        };
        tweenVars.y = function(i3) {
          return comps[i3].a.y + "px";
        };
        tweenVars.rotation = function(i3) {
          return comps[i3].a.rotation + (spin ? spinFunc(i3, targets[i3], targets) * 360 : 0);
        };
        tweenVars.skewX = function(i3) {
          return comps[i3].a.skewX;
        };
        targets = comps.map(function(c2) {
          return c2.t;
        });
        if (_zIndex || _zIndex === 0) {
          tweenVars.modifiers = {
            zIndex: function zIndex() {
              return _zIndex;
            }
          };
          tweenVars.zIndex = _zIndex;
          tweenVars.immediateRender = vars.immediateRender !== false;
        }
        fade && (tweenVars.opacity = function(i3) {
          return comps[i3].sd < 0 ? 0 : comps[i3].sd > 0 ? comps[i3].a.opacity : "+=0";
        });
        if (swapOutTargets.length) {
          stagger = gsap.utils.distribute(stagger);
          var dummyArray = targets.slice(swapOutTargets.length);
          tweenVars.stagger = function(i3, el2) {
            return stagger(~swapOutTargets.indexOf(el2) ? targets.indexOf(comps[i3].swap.t) : i3, el2, dummyArray);
          };
        }
        _callbacks.forEach(function(name) {
          return vars[name] && animation.eventCallback(name, vars[name], vars[name + "Params"]);
        });
        if (custom && targets.length) {
          remainingProps = _copy(tweenVars, _reserved);
          if ("scale" in custom) {
            custom.scaleX = custom.scaleY = custom.scale;
            delete custom.scale;
          }
          for (p2 in custom) {
            v2 = _copy(custom[p2], _fitReserved);
            v2[p2] = tweenVars[p2];
            !("duration" in v2) && "duration" in tweenVars && (v2.duration = tweenVars.duration);
            v2.stagger = tweenVars.stagger;
            addFunc.call(animation, targets, v2, 0);
            delete remainingProps[p2];
          }
        }
        if (targets.length || leaving.length || entering.length) {
          toggleClass && animation.add(function() {
            return _toggleClass(classTargets, toggleClass, animation._zTime < 0 ? "remove" : "add");
          }, 0) && !paused && _toggleClass(classTargets, toggleClass, "add");
          targets.length && addFunc.call(animation, targets, remainingProps, 0);
        }
        _handleCallback(onEnter, entering, animation);
        _handleCallback(onLeave, leaving, animation);
        var batchTl = _batch && _batch.timeline;
        if (batchTl) {
          batchTl.add(animation, 0);
          _batch._final.push(function() {
            return _setFinalStates(comps, !clearProps);
          });
        }
        endTime = animation.duration();
        animation.call(function() {
          var forward = animation.time() >= endTime;
          forward && !batchTl && _setFinalStates(comps, !clearProps);
          toggleClass && _toggleClass(classTargets, toggleClass, forward ? "remove" : "add");
        });
      };
      absoluteOnLeave && (absolute = comps.filter(function(comp2) {
        return !comp2.sd && !comp2.a.isVisible && comp2.b.isVisible;
      }).map(function(comp2) {
        return comp2.a.element;
      }));
      if (_batch) {
        var _batch$_abs;
        absolute && (_batch$_abs = _batch._abs).push.apply(_batch$_abs, _filterComps(comps, absolute));
        _batch._run.push(run);
      } else {
        absolute && _makeCompsAbsolute(_filterComps(comps, absolute));
        run();
      }
      var anim = _batch ? _batch.timeline : animation;
      anim.revert = function() {
        return _killFlip(anim, 1, 1);
      };
      return anim;
    }, _interrupt = function _interrupt2(tl) {
      tl.vars.onInterrupt && tl.vars.onInterrupt.apply(tl, tl.vars.onInterruptParams || []);
      tl.getChildren(true, false, true).forEach(_interrupt2);
    }, _killFlip = function _killFlip2(tl, action, force) {
      if (tl && tl.progress() < 1 && (!tl.paused() || force)) {
        if (action) {
          _interrupt(tl);
          action < 2 && tl.progress(1);
          tl.kill();
        }
        return true;
      }
    }, _createLookup = function _createLookup2(state) {
      var lookup = state.idLookup = {}, alt = state.alt = {}, elStates = state.elementStates, i2 = elStates.length, elState;
      while (i2--) {
        elState = elStates[i2];
        lookup[elState.id] ? alt[elState.id] = elState : lookup[elState.id] = elState;
      }
    };
    var FlipState = /* @__PURE__ */ function() {
      function FlipState2(targets, vars, targetsAreElementStates) {
        this.props = vars && vars.props;
        this.simple = !!(vars && vars.simple);
        if (targetsAreElementStates) {
          this.targets = _elementsFromElementStates(targets);
          this.elementStates = targets;
          _createLookup(this);
        } else {
          this.targets = _toArray(targets);
          var soft = vars && (vars.kill === false || vars.batch && !vars.kill);
          _batch && !soft && _batch._kill.push(this);
          this.update(soft || !!_batch);
        }
      }
      var _proto = FlipState2.prototype;
      _proto.update = function update(soft) {
        var _this = this;
        this.elementStates = this.targets.map(function(el) {
          return new ElementState(el, _this.props, _this.simple);
        });
        _createLookup(this);
        this.interrupt(soft);
        this.recordInlineStyles();
        return this;
      };
      _proto.clear = function clear() {
        this.targets.length = this.elementStates.length = 0;
        _createLookup(this);
        return this;
      };
      _proto.fit = function fit(state, scale, nested) {
        var elStatesInOrder = _orderByDOMDepth(this.elementStates.slice(0), false, true), toElStates = (state || this).idLookup, i2 = 0, fromNode, toNode;
        for (; i2 < elStatesInOrder.length; i2++) {
          fromNode = elStatesInOrder[i2];
          nested && (fromNode.matrix = getGlobalMatrix(fromNode.element, false, false, true));
          toNode = toElStates[fromNode.id];
          toNode && _fit(fromNode, toNode, scale, true, 0, fromNode);
          fromNode.matrix = getGlobalMatrix(fromNode.element, false, false, true);
        }
        return this;
      };
      _proto.getProperty = function getProperty(element, property) {
        var es = this.getElementState(element) || _emptyObj;
        return (property in es ? es : es.props || _emptyObj)[property];
      };
      _proto.add = function add(state) {
        var i2 = state.targets.length, lookup = this.idLookup, alt = this.alt, index, es, es2;
        while (i2--) {
          es = state.elementStates[i2];
          es2 = lookup[es.id];
          if (es2 && (es.element === es2.element || alt[es.id] && alt[es.id].element === es.element)) {
            index = this.elementStates.indexOf(es.element === es2.element ? es2 : alt[es.id]);
            this.targets.splice(index, 1, state.targets[i2]);
            this.elementStates.splice(index, 1, es);
          } else {
            this.targets.push(state.targets[i2]);
            this.elementStates.push(es);
          }
        }
        state.interrupted && (this.interrupted = true);
        state.simple || (this.simple = false);
        _createLookup(this);
        return this;
      };
      _proto.compare = function compare(state) {
        var l1 = state.idLookup, l2 = this.idLookup, unchanged = [], changed = [], enter = [], leave = [], targets = [], a1 = state.alt, a2 = this.alt, place = function place2(s12, s22, el2) {
          return (s12.isVisible !== s22.isVisible ? s12.isVisible ? enter : leave : s12.isVisible ? changed : unchanged).push(el2) && targets.push(el2);
        }, placeIfDoesNotExist = function placeIfDoesNotExist2(s12, s22, el2) {
          return targets.indexOf(el2) < 0 && place(s12, s22, el2);
        }, s1, s2, p2, el, s1Alt, s2Alt, c1, c2;
        for (p2 in l1) {
          s1Alt = a1[p2];
          s2Alt = a2[p2];
          s1 = !s1Alt ? l1[p2] : _getChangingElState(state, this, p2);
          el = s1.element;
          s2 = l2[p2];
          if (s2Alt) {
            c2 = s2.isVisible || !s2Alt.isVisible && el === s2.element ? s2 : s2Alt;
            c1 = s1Alt && !s1.isVisible && !s1Alt.isVisible && c2.element === s1Alt.element ? s1Alt : s1;
            if (c1.isVisible && c2.isVisible && c1.element !== c2.element) {
              (c1.isDifferent(c2) ? changed : unchanged).push(c1.element, c2.element);
              targets.push(c1.element, c2.element);
            } else {
              place(c1, c2, c1.element);
            }
            s1Alt && c1.element === s1Alt.element && (s1Alt = l1[p2]);
            placeIfDoesNotExist(c1.element !== s2.element && s1Alt ? s1Alt : c1, s2, s2.element);
            placeIfDoesNotExist(s1Alt && s1Alt.element === s2Alt.element ? s1Alt : c1, s2Alt, s2Alt.element);
            s1Alt && placeIfDoesNotExist(s1Alt, s2Alt.element === s1Alt.element ? s2Alt : s2, s1Alt.element);
          } else {
            !s2 ? enter.push(el) : !s2.isDifferent(s1) ? unchanged.push(el) : place(s1, s2, el);
            s1Alt && placeIfDoesNotExist(s1Alt, s2, s1Alt.element);
          }
        }
        for (p2 in l2) {
          if (!l1[p2]) {
            leave.push(l2[p2].element);
            a2[p2] && leave.push(a2[p2].element);
          }
        }
        return {
          changed,
          unchanged,
          enter,
          leave
        };
      };
      _proto.recordInlineStyles = function recordInlineStyles() {
        var props = _memoizedRemoveProps[this.props] || _removeProps, i2 = this.elementStates.length;
        while (i2--) {
          _recordInlineStyles(this.elementStates[i2], props);
        }
      };
      _proto.interrupt = function interrupt(soft) {
        var _this2 = this;
        var timelines = [];
        this.targets.forEach(function(t2) {
          var tl = t2._flip, foundInProgress = _killFlip(tl, soft ? 0 : 1);
          soft && foundInProgress && timelines.indexOf(tl) < 0 && tl.add(function() {
            return _this2.updateVisibility();
          });
          foundInProgress && timelines.push(tl);
        });
        !soft && timelines.length && this.updateVisibility();
        this.interrupted || (this.interrupted = !!timelines.length);
      };
      _proto.updateVisibility = function updateVisibility() {
        this.elementStates.forEach(function(es) {
          var b2 = es.element.getBoundingClientRect();
          es.isVisible = !!(b2.width || b2.height || b2.top || b2.left);
          es.uncache = 1;
        });
      };
      _proto.getElementState = function getElementState(element) {
        return this.elementStates[this.targets.indexOf(_getEl(element))];
      };
      _proto.makeAbsolute = function makeAbsolute() {
        return _orderByDOMDepth(this.elementStates.slice(0), true, true).map(_makeAbsolute);
      };
      return FlipState2;
    }();
    var ElementState = /* @__PURE__ */ function() {
      function ElementState2(element, props, simple) {
        this.element = element;
        this.update(props, simple);
      }
      var _proto2 = ElementState2.prototype;
      _proto2.isDifferent = function isDifferent(state) {
        var b1 = this.bounds, b2 = state.bounds;
        return b1.top !== b2.top || b1.left !== b2.left || b1.width !== b2.width || b1.height !== b2.height || !this.matrix.equals(state.matrix) || this.opacity !== state.opacity || this.props && state.props && JSON.stringify(this.props) !== JSON.stringify(state.props);
      };
      _proto2.update = function update(props, simple) {
        var self = this, element = self.element, getProp = gsap.getProperty(element), cache = gsap.core.getCache(element), bounds = element.getBoundingClientRect(), bbox = element.getBBox && typeof element.getBBox === "function" && element.nodeName.toLowerCase() !== "svg" && element.getBBox(), m2 = simple ? new Matrix2D(1, 0, 0, 1, bounds.left + _getDocScrollLeft(), bounds.top + _getDocScrollTop()) : getGlobalMatrix(element, false, false, true);
        cache.uncache = 1;
        self.getProp = getProp;
        self.element = element;
        self.id = _getID(element);
        self.matrix = m2;
        self.cache = cache;
        self.bounds = bounds;
        self.isVisible = !!(bounds.width || bounds.height || bounds.left || bounds.top);
        self.display = getProp("display");
        self.position = getProp("position");
        self.parent = element.parentNode;
        self.x = getProp("x");
        self.y = getProp("y");
        self.scaleX = cache.scaleX;
        self.scaleY = cache.scaleY;
        self.rotation = getProp("rotation");
        self.skewX = getProp("skewX");
        self.opacity = getProp("opacity");
        self.width = bbox ? bbox.width : _closestTenth(getProp("width", "px"), 0.04);
        self.height = bbox ? bbox.height : _closestTenth(getProp("height", "px"), 0.04);
        props && _recordProps(self, _memoizedProps[props] || _memoizeProps(props));
        self.ctm = element.getCTM && element.nodeName.toLowerCase() === "svg" && _getCTM(element).inverse();
        self.simple = simple || _round(m2.a) === 1 && !_round(m2.b) && !_round(m2.c) && _round(m2.d) === 1;
        self.uncache = 0;
      };
      return ElementState2;
    }();
    var FlipAction = /* @__PURE__ */ function() {
      function FlipAction2(vars, batch) {
        this.vars = vars;
        this.batch = batch;
        this.states = [];
        this.timeline = batch.timeline;
      }
      var _proto3 = FlipAction2.prototype;
      _proto3.getStateById = function getStateById(id) {
        var i2 = this.states.length;
        while (i2--) {
          if (this.states[i2].idLookup[id]) {
            return this.states[i2];
          }
        }
      };
      _proto3.kill = function kill() {
        this.batch.remove(this);
      };
      return FlipAction2;
    }();
    var FlipBatch = /* @__PURE__ */ function() {
      function FlipBatch2(id) {
        this.id = id;
        this.actions = [];
        this._kill = [];
        this._final = [];
        this._abs = [];
        this._run = [];
        this.data = {};
        this.state = new FlipState();
        this.timeline = gsap.timeline();
      }
      var _proto4 = FlipBatch2.prototype;
      _proto4.add = function add(config) {
        var result = this.actions.filter(function(action) {
          return action.vars === config;
        });
        if (result.length) {
          return result[0];
        }
        result = new FlipAction(typeof config === "function" ? {
          animate: config
        } : config, this);
        this.actions.push(result);
        return result;
      };
      _proto4.remove = function remove(action) {
        var i2 = this.actions.indexOf(action);
        i2 >= 0 && this.actions.splice(i2, 1);
        return this;
      };
      _proto4.getState = function getState(merge) {
        var _this3 = this;
        var prevBatch = _batch, prevAction = _batchAction;
        _batch = this;
        this.state.clear();
        this._kill.length = 0;
        this.actions.forEach(function(action) {
          if (action.vars.getState) {
            action.states.length = 0;
            _batchAction = action;
            action.state = action.vars.getState(action);
          }
          merge && action.states.forEach(function(s2) {
            return _this3.state.add(s2);
          });
        });
        _batchAction = prevAction;
        _batch = prevBatch;
        this.killConflicts();
        return this;
      };
      _proto4.animate = function animate() {
        var _this4 = this;
        var prevBatch = _batch, tl = this.timeline, i2 = this.actions.length, finalStates, endTime;
        _batch = this;
        tl.clear();
        this._abs.length = this._final.length = this._run.length = 0;
        this.actions.forEach(function(a2) {
          a2.vars.animate && a2.vars.animate(a2);
          var onEnter = a2.vars.onEnter, onLeave = a2.vars.onLeave, targets = a2.targets, s2, result;
          if (targets && targets.length && (onEnter || onLeave)) {
            s2 = new FlipState();
            a2.states.forEach(function(state) {
              return s2.add(state);
            });
            result = s2.compare(Flip.getState(targets));
            result.enter.length && onEnter && onEnter(result.enter);
            result.leave.length && onLeave && onLeave(result.leave);
          }
        });
        _makeCompsAbsolute(this._abs);
        this._run.forEach(function(f2) {
          return f2();
        });
        endTime = tl.duration();
        finalStates = this._final.slice(0);
        tl.add(function() {
          if (endTime <= tl.time()) {
            finalStates.forEach(function(f2) {
              return f2();
            });
            _forEachBatch(_this4, "onComplete");
          }
        });
        _batch = prevBatch;
        while (i2--) {
          this.actions[i2].vars.once && this.actions[i2].kill();
        }
        _forEachBatch(this, "onStart");
        tl.restart();
        return this;
      };
      _proto4.loadState = function loadState(done) {
        done || (done = function done2() {
          return 0;
        });
        var queue = [];
        this.actions.forEach(function(c2) {
          if (c2.vars.loadState) {
            var i2, f2 = function f3(targets) {
              targets && (c2.targets = targets);
              i2 = queue.indexOf(f3);
              if (~i2) {
                queue.splice(i2, 1);
                queue.length || done();
              }
            };
            queue.push(f2);
            c2.vars.loadState(f2);
          }
        });
        queue.length || done();
        return this;
      };
      _proto4.setState = function setState() {
        this.actions.forEach(function(c2) {
          return c2.targets = c2.vars.setState && c2.vars.setState(c2);
        });
        return this;
      };
      _proto4.killConflicts = function killConflicts(soft) {
        this.state.interrupt(soft);
        this._kill.forEach(function(state) {
          return state.interrupt(soft);
        });
        return this;
      };
      _proto4.run = function run(skipGetState, merge) {
        var _this5 = this;
        if (this !== _batch) {
          skipGetState || this.getState(merge);
          this.loadState(function() {
            if (!_this5._killed) {
              _this5.setState();
              _this5.animate();
            }
          });
        }
        return this;
      };
      _proto4.clear = function clear(stateOnly) {
        this.state.clear();
        stateOnly || (this.actions.length = 0);
      };
      _proto4.getStateById = function getStateById(id) {
        var i2 = this.actions.length, s2;
        while (i2--) {
          s2 = this.actions[i2].getStateById(id);
          if (s2) {
            return s2;
          }
        }
        return this.state.idLookup[id] && this.state;
      };
      _proto4.kill = function kill() {
        this._killed = 1;
        this.clear();
        delete _batchLookup[this.id];
      };
      return FlipBatch2;
    }();
    var Flip = /* @__PURE__ */ function() {
      function Flip2() {
      }
      Flip2.getState = function getState(targets, vars) {
        var state = _parseState(targets, vars);
        _batchAction && _batchAction.states.push(state);
        vars && vars.batch && Flip2.batch(vars.batch).state.add(state);
        return state;
      };
      Flip2.from = function from(state, vars) {
        vars = vars || {};
        "clearProps" in vars || (vars.clearProps = true);
        return _fromTo(state, _parseState(vars.targets || state.targets, {
          props: vars.props || state.props,
          simple: vars.simple,
          kill: !!vars.kill
        }), vars, -1);
      };
      Flip2.to = function to(state, vars) {
        return _fromTo(state, _parseState(vars.targets || state.targets, {
          props: vars.props || state.props,
          simple: vars.simple,
          kill: !!vars.kill
        }), vars, 1);
      };
      Flip2.fromTo = function fromTo(fromState, toState, vars) {
        return _fromTo(fromState, toState, vars);
      };
      Flip2.fit = function fit(fromEl, toEl, vars) {
        var v2 = vars ? _copy(vars, _fitReserved) : {}, _ref = vars || v2, absolute = _ref.absolute, scale = _ref.scale, getVars = _ref.getVars, props = _ref.props, runBackwards = _ref.runBackwards, onComplete = _ref.onComplete, simple = _ref.simple, fitChild = vars && vars.fitChild && _getEl(vars.fitChild), before = _parseElementState(toEl, props, simple, fromEl), after = _parseElementState(fromEl, 0, simple, before), inlineProps = props ? _memoizedRemoveProps[props] : _removeProps, ctx = gsap.context();
        props && _applyProps(v2, before.props);
        _recordInlineStyles(after, inlineProps);
        if (runBackwards) {
          "immediateRender" in v2 || (v2.immediateRender = true);
          v2.onComplete = function() {
            _applyInlineStyles(after);
            onComplete && onComplete.apply(this, arguments);
          };
        }
        absolute && _makeAbsolute(after, before);
        v2 = _fit(after, before, scale || fitChild, !v2.duration && props, fitChild, v2.duration || getVars ? v2 : 0);
        typeof vars === "object" && "zIndex" in vars && (v2.zIndex = vars.zIndex);
        ctx && !getVars && ctx.add(function() {
          return function() {
            return _applyInlineStyles(after);
          };
        });
        return getVars ? v2 : v2.duration ? gsap.to(after.element, v2) : null;
      };
      Flip2.makeAbsolute = function makeAbsolute(targetsOrStates, vars) {
        return (targetsOrStates instanceof FlipState ? targetsOrStates : new FlipState(targetsOrStates, vars)).makeAbsolute();
      };
      Flip2.batch = function batch(id) {
        id || (id = "default");
        return _batchLookup[id] || (_batchLookup[id] = new FlipBatch(id));
      };
      Flip2.killFlipsOf = function killFlipsOf(targets, complete) {
        (targets instanceof FlipState ? targets.targets : _toArray(targets)).forEach(function(t2) {
          return t2 && _killFlip(t2._flip, complete !== false ? 1 : 2);
        });
      };
      Flip2.isFlipping = function isFlipping(target) {
        var f2 = Flip2.getByTarget(target);
        return !!f2 && f2.isActive();
      };
      Flip2.getByTarget = function getByTarget(target) {
        return (_getEl(target) || _emptyObj)._flip;
      };
      Flip2.getElementState = function getElementState(target, props) {
        return new ElementState(_getEl(target), props);
      };
      Flip2.convertCoordinates = function convertCoordinates(fromElement, toElement, point) {
        var m2 = getGlobalMatrix(toElement, true, true).multiply(getGlobalMatrix(fromElement));
        return point ? m2.apply(point) : m2;
      };
      Flip2.register = function register(core) {
        _body = typeof document !== "undefined" && document.body;
        if (_body) {
          gsap = core;
          _setDoc(_body);
          _toArray = gsap.utils.toArray;
          _getStyleSaver = gsap.core.getStyleSaver;
          var snap2 = gsap.utils.snap(0.1);
          _closestTenth = function _closestTenth2(value, add) {
            return snap2(parseFloat(value) + add);
          };
        }
      };
      return Flip2;
    }();
    Flip.version = "3.13.0";
    typeof window !== "undefined" && window.gsap && window.gsap.registerPlugin(Flip);
    var version = "1.3.8";
    function clamp(min, input, max) {
      return Math.max(min, Math.min(input, max));
    }
    function lerp(x2, y2, t2) {
      return (1 - t2) * x2 + t2 * y2;
    }
    function damp(x2, y2, lambda, deltaTime) {
      return lerp(x2, y2, 1 - Math.exp(-lambda * deltaTime));
    }
    function modulo(n2, d2) {
      return (n2 % d2 + d2) % d2;
    }
    var Animate = class {
      constructor() {
        __publicField(this, "isRunning", false);
        __publicField(this, "value", 0);
        __publicField(this, "from", 0);
        __publicField(this, "to", 0);
        __publicField(this, "currentTime", 0);
        // These are instanciated in the fromTo method
        __publicField(this, "lerp");
        __publicField(this, "duration");
        __publicField(this, "easing");
        __publicField(this, "onUpdate");
      }
      /**
       * Advance the animation by the given delta time
       *
       * @param deltaTime - The time in seconds to advance the animation
       */
      advance(deltaTime) {
        var _a2;
        if (!this.isRunning) return;
        let completed = false;
        if (this.duration && this.easing) {
          this.currentTime += deltaTime;
          const linearProgress = clamp(0, this.currentTime / this.duration, 1);
          completed = linearProgress >= 1;
          const easedProgress = completed ? 1 : this.easing(linearProgress);
          this.value = this.from + (this.to - this.from) * easedProgress;
        } else if (this.lerp) {
          this.value = damp(this.value, this.to, this.lerp * 60, deltaTime);
          if (Math.round(this.value) === this.to) {
            this.value = this.to;
            completed = true;
          }
        } else {
          this.value = this.to;
          completed = true;
        }
        if (completed) {
          this.stop();
        }
        (_a2 = this.onUpdate) == null ? void 0 : _a2.call(this, this.value, completed);
      }
      /** Stop the animation */
      stop() {
        this.isRunning = false;
      }
      /**
       * Set up the animation from a starting value to an ending value
       * with optional parameters for lerping, duration, easing, and onUpdate callback
       *
       * @param from - The starting value
       * @param to - The ending value
       * @param options - Options for the animation
       */
      fromTo(from, to, { lerp: lerp2, duration, easing, onStart, onUpdate }) {
        this.from = this.value = from;
        this.to = to;
        this.lerp = lerp2;
        this.duration = duration;
        this.easing = easing;
        this.currentTime = 0;
        this.isRunning = true;
        onStart == null ? void 0 : onStart();
        this.onUpdate = onUpdate;
      }
    };
    function debounce(callback, delay) {
      let timer;
      return function(...args) {
        let context = this;
        clearTimeout(timer);
        timer = setTimeout(() => {
          timer = void 0;
          callback.apply(context, args);
        }, delay);
      };
    }
    var Dimensions = class {
      constructor(wrapper, content, { autoResize = true, debounce: debounceValue = 250 } = {}) {
        __publicField(this, "width", 0);
        __publicField(this, "height", 0);
        __publicField(this, "scrollHeight", 0);
        __publicField(this, "scrollWidth", 0);
        // These are instanciated in the constructor as they need information from the options
        __publicField(this, "debouncedResize");
        __publicField(this, "wrapperResizeObserver");
        __publicField(this, "contentResizeObserver");
        __publicField(this, "resize", () => {
          this.onWrapperResize();
          this.onContentResize();
        });
        __publicField(this, "onWrapperResize", () => {
          if (this.wrapper instanceof Window) {
            this.width = window.innerWidth;
            this.height = window.innerHeight;
          } else {
            this.width = this.wrapper.clientWidth;
            this.height = this.wrapper.clientHeight;
          }
        });
        __publicField(this, "onContentResize", () => {
          if (this.wrapper instanceof Window) {
            this.scrollHeight = this.content.scrollHeight;
            this.scrollWidth = this.content.scrollWidth;
          } else {
            this.scrollHeight = this.wrapper.scrollHeight;
            this.scrollWidth = this.wrapper.scrollWidth;
          }
        });
        this.wrapper = wrapper;
        this.content = content;
        if (autoResize) {
          this.debouncedResize = debounce(this.resize, debounceValue);
          if (this.wrapper instanceof Window) {
            window.addEventListener("resize", this.debouncedResize, false);
          } else {
            this.wrapperResizeObserver = new ResizeObserver(this.debouncedResize);
            this.wrapperResizeObserver.observe(this.wrapper);
          }
          this.contentResizeObserver = new ResizeObserver(this.debouncedResize);
          this.contentResizeObserver.observe(this.content);
        }
        this.resize();
      }
      destroy() {
        var _a2, _b2;
        (_a2 = this.wrapperResizeObserver) == null ? void 0 : _a2.disconnect();
        (_b2 = this.contentResizeObserver) == null ? void 0 : _b2.disconnect();
        if (this.wrapper === window && this.debouncedResize) {
          window.removeEventListener("resize", this.debouncedResize, false);
        }
      }
      get limit() {
        return {
          x: this.scrollWidth - this.width,
          y: this.scrollHeight - this.height
        };
      }
    };
    var Emitter = class {
      constructor() {
        __publicField(this, "events", {});
      }
      /**
       * Emit an event with the given data
       * @param event Event name
       * @param args Data to pass to the event handlers
       */
      emit(event, ...args) {
        var _a2;
        let callbacks = this.events[event] || [];
        for (let i2 = 0, length = callbacks.length; i2 < length; i2++) {
          (_a2 = callbacks[i2]) == null ? void 0 : _a2.call(callbacks, ...args);
        }
      }
      /**
       * Add a callback to the event
       * @param event Event name
       * @param cb Callback function
       * @returns Unsubscribe function
       */
      on(event, cb) {
        var _a2;
        ((_a2 = this.events[event]) == null ? void 0 : _a2.push(cb)) || (this.events[event] = [cb]);
        return () => {
          var _a3;
          this.events[event] = (_a3 = this.events[event]) == null ? void 0 : _a3.filter((i2) => cb !== i2);
        };
      }
      /**
       * Remove a callback from the event
       * @param event Event name
       * @param callback Callback function
       */
      off(event, callback) {
        var _a2;
        this.events[event] = (_a2 = this.events[event]) == null ? void 0 : _a2.filter((i2) => callback !== i2);
      }
      /**
       * Remove all event listeners and clean up
       */
      destroy() {
        this.events = {};
      }
    };
    var LINE_HEIGHT = 100 / 6;
    var listenerOptions = { passive: false };
    var VirtualScroll = class {
      constructor(element, options = { wheelMultiplier: 1, touchMultiplier: 1 }) {
        __publicField(this, "touchStart", {
          x: 0,
          y: 0
        });
        __publicField(this, "lastDelta", {
          x: 0,
          y: 0
        });
        __publicField(this, "window", {
          width: 0,
          height: 0
        });
        __publicField(this, "emitter", new Emitter());
        /**
         * Event handler for 'touchstart' event
         *
         * @param event Touch event
         */
        __publicField(this, "onTouchStart", (event) => {
          const { clientX, clientY } = event.targetTouches ? event.targetTouches[0] : event;
          this.touchStart.x = clientX;
          this.touchStart.y = clientY;
          this.lastDelta = {
            x: 0,
            y: 0
          };
          this.emitter.emit("scroll", {
            deltaX: 0,
            deltaY: 0,
            event
          });
        });
        /** Event handler for 'touchmove' event */
        __publicField(this, "onTouchMove", (event) => {
          const { clientX, clientY } = event.targetTouches ? event.targetTouches[0] : event;
          const deltaX = -(clientX - this.touchStart.x) * this.options.touchMultiplier;
          const deltaY = -(clientY - this.touchStart.y) * this.options.touchMultiplier;
          this.touchStart.x = clientX;
          this.touchStart.y = clientY;
          this.lastDelta = {
            x: deltaX,
            y: deltaY
          };
          this.emitter.emit("scroll", {
            deltaX,
            deltaY,
            event
          });
        });
        __publicField(this, "onTouchEnd", (event) => {
          this.emitter.emit("scroll", {
            deltaX: this.lastDelta.x,
            deltaY: this.lastDelta.y,
            event
          });
        });
        /** Event handler for 'wheel' event */
        __publicField(this, "onWheel", (event) => {
          let { deltaX, deltaY, deltaMode } = event;
          const multiplierX = deltaMode === 1 ? LINE_HEIGHT : deltaMode === 2 ? this.window.width : 1;
          const multiplierY = deltaMode === 1 ? LINE_HEIGHT : deltaMode === 2 ? this.window.height : 1;
          deltaX *= multiplierX;
          deltaY *= multiplierY;
          deltaX *= this.options.wheelMultiplier;
          deltaY *= this.options.wheelMultiplier;
          this.emitter.emit("scroll", { deltaX, deltaY, event });
        });
        __publicField(this, "onWindowResize", () => {
          this.window = {
            width: window.innerWidth,
            height: window.innerHeight
          };
        });
        this.element = element;
        this.options = options;
        window.addEventListener("resize", this.onWindowResize, false);
        this.onWindowResize();
        this.element.addEventListener("wheel", this.onWheel, listenerOptions);
        this.element.addEventListener(
          "touchstart",
          this.onTouchStart,
          listenerOptions
        );
        this.element.addEventListener(
          "touchmove",
          this.onTouchMove,
          listenerOptions
        );
        this.element.addEventListener("touchend", this.onTouchEnd, listenerOptions);
      }
      /**
       * Add an event listener for the given event and callback
       *
       * @param event Event name
       * @param callback Callback function
       */
      on(event, callback) {
        return this.emitter.on(event, callback);
      }
      /** Remove all event listeners and clean up */
      destroy() {
        this.emitter.destroy();
        window.removeEventListener("resize", this.onWindowResize, false);
        this.element.removeEventListener("wheel", this.onWheel, listenerOptions);
        this.element.removeEventListener(
          "touchstart",
          this.onTouchStart,
          listenerOptions
        );
        this.element.removeEventListener(
          "touchmove",
          this.onTouchMove,
          listenerOptions
        );
        this.element.removeEventListener(
          "touchend",
          this.onTouchEnd,
          listenerOptions
        );
      }
    };
    var defaultEasing = (t2) => Math.min(1, 1.001 - Math.pow(2, -10 * t2));
    var Lenis = class {
      constructor({
        wrapper = window,
        content = document.documentElement,
        eventsTarget = wrapper,
        smoothWheel = true,
        syncTouch = false,
        syncTouchLerp = 0.075,
        touchInertiaExponent = 1.7,
        duration,
        // in seconds
        easing,
        lerp: lerp2 = 0.1,
        infinite = false,
        orientation = "vertical",
        // vertical, horizontal
        gestureOrientation = "vertical",
        // vertical, horizontal, both
        touchMultiplier = 1,
        wheelMultiplier = 1,
        autoResize = true,
        prevent,
        virtualScroll,
        overscroll = true,
        autoRaf = false,
        anchors = false,
        autoToggle = false,
        // https://caniuse.com/?search=transition-behavior
        allowNestedScroll = false,
        __experimental__naiveDimensions = false
      } = {}) {
        __publicField(this, "_isScrolling", false);
        // true when scroll is animating
        __publicField(this, "_isStopped", false);
        // true if user should not be able to scroll - enable/disable programmatically
        __publicField(this, "_isLocked", false);
        // same as isStopped but enabled/disabled when scroll reaches target
        __publicField(this, "_preventNextNativeScrollEvent", false);
        __publicField(this, "_resetVelocityTimeout", null);
        __publicField(this, "__rafID", null);
        /**
         * Whether or not the user is touching the screen
         */
        __publicField(this, "isTouching");
        /**
         * The time in ms since the lenis instance was created
         */
        __publicField(this, "time", 0);
        /**
         * User data that will be forwarded through the scroll event
         *
         * @example
         * lenis.scrollTo(100, {
         *   userData: {
         *     foo: 'bar'
         *   }
         * })
         */
        __publicField(this, "userData", {});
        /**
         * The last velocity of the scroll
         */
        __publicField(this, "lastVelocity", 0);
        /**
         * The current velocity of the scroll
         */
        __publicField(this, "velocity", 0);
        /**
         * The direction of the scroll
         */
        __publicField(this, "direction", 0);
        /**
         * The options passed to the lenis instance
         */
        __publicField(this, "options");
        /**
         * The target scroll value
         */
        __publicField(this, "targetScroll");
        /**
         * The animated scroll value
         */
        __publicField(this, "animatedScroll");
        // These are instanciated here as they don't need information from the options
        __publicField(this, "animate", new Animate());
        __publicField(this, "emitter", new Emitter());
        // These are instanciated in the constructor as they need information from the options
        __publicField(this, "dimensions");
        // This is not private because it's used in the Snap class
        __publicField(this, "virtualScroll");
        __publicField(this, "onScrollEnd", (e2) => {
          if (!(e2 instanceof CustomEvent)) {
            if (this.isScrolling === "smooth" || this.isScrolling === false) {
              e2.stopPropagation();
            }
          }
        });
        __publicField(this, "dispatchScrollendEvent", () => {
          this.options.wrapper.dispatchEvent(
            new CustomEvent("scrollend", {
              bubbles: this.options.wrapper === window,
              // cancelable: false,
              detail: {
                lenisScrollEnd: true
              }
            })
          );
        });
        __publicField(this, "onTransitionEnd", (event) => {
          if (event.propertyName.includes("overflow")) {
            const property = this.isHorizontal ? "overflow-x" : "overflow-y";
            const overflow = getComputedStyle(this.rootElement)[property];
            if (["hidden", "clip"].includes(overflow)) {
              this.internalStop();
            } else {
              this.internalStart();
            }
          }
        });
        __publicField(this, "onClick", (event) => {
          const path = event.composedPath();
          const anchor = path.find(
            (node) => {
              var _a2, _b2, _c;
              return node instanceof HTMLAnchorElement && (((_a2 = node.getAttribute("href")) == null ? void 0 : _a2.startsWith("#")) || ((_b2 = node.getAttribute("href")) == null ? void 0 : _b2.startsWith("/#")) || ((_c = node.getAttribute("href")) == null ? void 0 : _c.startsWith("./#")));
            }
          );
          if (anchor) {
            const id = anchor.getAttribute("href");
            if (id) {
              const options = typeof this.options.anchors === "object" && this.options.anchors ? this.options.anchors : void 0;
              let target = `#${id.split("#")[1]}`;
              if (["#", "/#", "./#", "#top", "/#top", "./#top"].includes(id)) {
                target = 0;
              }
              this.scrollTo(target, options);
            }
          }
        });
        __publicField(this, "onPointerDown", (event) => {
          if (event.button === 1) {
            this.reset();
          }
        });
        __publicField(this, "onVirtualScroll", (data) => {
          if (typeof this.options.virtualScroll === "function" && this.options.virtualScroll(data) === false)
            return;
          const { deltaX, deltaY, event } = data;
          this.emitter.emit("virtual-scroll", { deltaX, deltaY, event });
          if (event.ctrlKey) return;
          if (event.lenisStopPropagation) return;
          const isTouch = event.type.includes("touch");
          const isWheel = event.type.includes("wheel");
          this.isTouching = event.type === "touchstart" || event.type === "touchmove";
          const isClickOrTap = deltaX === 0 && deltaY === 0;
          const isTapToStop = this.options.syncTouch && isTouch && event.type === "touchstart" && isClickOrTap && !this.isStopped && !this.isLocked;
          if (isTapToStop) {
            this.reset();
            return;
          }
          const isUnknownGesture = this.options.gestureOrientation === "vertical" && deltaY === 0 || this.options.gestureOrientation === "horizontal" && deltaX === 0;
          if (isClickOrTap || isUnknownGesture) {
            return;
          }
          let composedPath = event.composedPath();
          composedPath = composedPath.slice(0, composedPath.indexOf(this.rootElement));
          const prevent = this.options.prevent;
          if (!!composedPath.find(
            (node) => {
              var _a2, _b2, _c;
              return node instanceof HTMLElement && (typeof prevent === "function" && (prevent == null ? void 0 : prevent(node)) || ((_a2 = node.hasAttribute) == null ? void 0 : _a2.call(node, "data-lenis-prevent")) || isTouch && ((_b2 = node.hasAttribute) == null ? void 0 : _b2.call(node, "data-lenis-prevent-touch")) || isWheel && ((_c = node.hasAttribute) == null ? void 0 : _c.call(node, "data-lenis-prevent-wheel")) || this.options.allowNestedScroll && this.checkNestedScroll(node, { deltaX, deltaY }));
            }
          ))
            return;
          if (this.isStopped || this.isLocked) {
            if (event.cancelable) {
              event.preventDefault();
            }
            return;
          }
          const isSmooth = this.options.syncTouch && isTouch || this.options.smoothWheel && isWheel;
          if (!isSmooth) {
            this.isScrolling = "native";
            this.animate.stop();
            event.lenisStopPropagation = true;
            return;
          }
          let delta = deltaY;
          if (this.options.gestureOrientation === "both") {
            delta = Math.abs(deltaY) > Math.abs(deltaX) ? deltaY : deltaX;
          } else if (this.options.gestureOrientation === "horizontal") {
            delta = deltaX;
          }
          if (!this.options.overscroll || this.options.infinite || this.options.wrapper !== window && (this.animatedScroll > 0 && this.animatedScroll < this.limit || this.animatedScroll === 0 && deltaY > 0 || this.animatedScroll === this.limit && deltaY < 0)) {
            event.lenisStopPropagation = true;
          }
          if (event.cancelable) {
            event.preventDefault();
          }
          const isSyncTouch = isTouch && this.options.syncTouch;
          const isTouchEnd = isTouch && event.type === "touchend";
          const hasTouchInertia = isTouchEnd;
          if (hasTouchInertia) {
            delta = Math.sign(this.velocity) * Math.pow(Math.abs(this.velocity), this.options.touchInertiaExponent);
          }
          this.scrollTo(this.targetScroll + delta, {
            programmatic: false,
            ...isSyncTouch ? {
              lerp: hasTouchInertia ? this.options.syncTouchLerp : 1
              // immediate: !hasTouchInertia,
            } : {
              lerp: this.options.lerp,
              duration: this.options.duration,
              easing: this.options.easing
            }
          });
        });
        __publicField(this, "onNativeScroll", () => {
          if (this._resetVelocityTimeout !== null) {
            clearTimeout(this._resetVelocityTimeout);
            this._resetVelocityTimeout = null;
          }
          if (this._preventNextNativeScrollEvent) {
            this._preventNextNativeScrollEvent = false;
            return;
          }
          if (this.isScrolling === false || this.isScrolling === "native") {
            const lastScroll = this.animatedScroll;
            this.animatedScroll = this.targetScroll = this.actualScroll;
            this.lastVelocity = this.velocity;
            this.velocity = this.animatedScroll - lastScroll;
            this.direction = Math.sign(
              this.animatedScroll - lastScroll
            );
            if (!this.isStopped) {
              this.isScrolling = "native";
            }
            this.emit();
            if (this.velocity !== 0) {
              this._resetVelocityTimeout = setTimeout(() => {
                this.lastVelocity = this.velocity;
                this.velocity = 0;
                this.isScrolling = false;
                this.emit();
              }, 400);
            }
          }
        });
        /**
         * RequestAnimationFrame for lenis
         *
         * @param time The time in ms from an external clock like `requestAnimationFrame` or Tempus
         */
        __publicField(this, "raf", (time) => {
          const deltaTime = time - (this.time || time);
          this.time = time;
          this.animate.advance(deltaTime * 1e-3);
          if (this.options.autoRaf) {
            this.__rafID = requestAnimationFrame(this.raf);
          }
        });
        window.lenisVersion = version;
        if (!wrapper || wrapper === document.documentElement) {
          wrapper = window;
        }
        if (typeof duration === "number" && typeof easing !== "function") {
          easing = defaultEasing;
        } else if (typeof easing === "function" && typeof duration !== "number") {
          duration = 1;
        }
        this.options = {
          wrapper,
          content,
          eventsTarget,
          smoothWheel,
          syncTouch,
          syncTouchLerp,
          touchInertiaExponent,
          duration,
          easing,
          lerp: lerp2,
          infinite,
          gestureOrientation,
          orientation,
          touchMultiplier,
          wheelMultiplier,
          autoResize,
          prevent,
          virtualScroll,
          overscroll,
          autoRaf,
          anchors,
          autoToggle,
          allowNestedScroll,
          __experimental__naiveDimensions
        };
        this.dimensions = new Dimensions(wrapper, content, { autoResize });
        this.updateClassName();
        this.targetScroll = this.animatedScroll = this.actualScroll;
        this.options.wrapper.addEventListener("scroll", this.onNativeScroll, false);
        this.options.wrapper.addEventListener("scrollend", this.onScrollEnd, {
          capture: true
        });
        if (this.options.anchors && this.options.wrapper === window) {
          this.options.wrapper.addEventListener(
            "click",
            this.onClick,
            false
          );
        }
        this.options.wrapper.addEventListener(
          "pointerdown",
          this.onPointerDown,
          false
        );
        this.virtualScroll = new VirtualScroll(eventsTarget, {
          touchMultiplier,
          wheelMultiplier
        });
        this.virtualScroll.on("scroll", this.onVirtualScroll);
        if (this.options.autoToggle) {
          this.rootElement.addEventListener("transitionend", this.onTransitionEnd, {
            passive: true
          });
        }
        if (this.options.autoRaf) {
          this.__rafID = requestAnimationFrame(this.raf);
        }
      }
      /**
       * Destroy the lenis instance, remove all event listeners and clean up the class name
       */
      destroy() {
        this.emitter.destroy();
        this.options.wrapper.removeEventListener(
          "scroll",
          this.onNativeScroll,
          false
        );
        this.options.wrapper.removeEventListener("scrollend", this.onScrollEnd, {
          capture: true
        });
        this.options.wrapper.removeEventListener(
          "pointerdown",
          this.onPointerDown,
          false
        );
        if (this.options.anchors && this.options.wrapper === window) {
          this.options.wrapper.removeEventListener(
            "click",
            this.onClick,
            false
          );
        }
        this.virtualScroll.destroy();
        this.dimensions.destroy();
        this.cleanUpClassName();
        if (this.__rafID) {
          cancelAnimationFrame(this.__rafID);
        }
      }
      on(event, callback) {
        return this.emitter.on(event, callback);
      }
      off(event, callback) {
        return this.emitter.off(event, callback);
      }
      setScroll(scroll) {
        if (this.isHorizontal) {
          this.options.wrapper.scrollTo({ left: scroll, behavior: "instant" });
        } else {
          this.options.wrapper.scrollTo({ top: scroll, behavior: "instant" });
        }
      }
      /**
       * Force lenis to recalculate the dimensions
       */
      resize() {
        this.dimensions.resize();
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.emit();
      }
      emit() {
        this.emitter.emit("scroll", this);
      }
      reset() {
        this.isLocked = false;
        this.isScrolling = false;
        this.animatedScroll = this.targetScroll = this.actualScroll;
        this.lastVelocity = this.velocity = 0;
        this.animate.stop();
      }
      /**
       * Start lenis scroll after it has been stopped
       */
      start() {
        if (!this.isStopped) return;
        if (this.options.autoToggle) {
          this.rootElement.style.removeProperty("overflow");
          return;
        }
        this.internalStart();
      }
      internalStart() {
        if (!this.isStopped) return;
        this.reset();
        this.isStopped = false;
        this.emit();
      }
      /**
       * Stop lenis scroll
       */
      stop() {
        if (this.isStopped) return;
        if (this.options.autoToggle) {
          this.rootElement.style.setProperty("overflow", "clip");
          return;
        }
        this.internalStop();
      }
      internalStop() {
        if (this.isStopped) return;
        this.reset();
        this.isStopped = true;
        this.emit();
      }
      /**
       * Scroll to a target value
       *
       * @param target The target value to scroll to
       * @param options The options for the scroll
       *
       * @example
       * lenis.scrollTo(100, {
       *   offset: 100,
       *   duration: 1,
       *   easing: (t) => 1 - Math.cos((t * Math.PI) / 2),
       *   lerp: 0.1,
       *   onStart: () => {
       *     console.log('onStart')
       *   },
       *   onComplete: () => {
       *     console.log('onComplete')
       *   },
       * })
       */
      scrollTo(target, {
        offset = 0,
        immediate = false,
        lock = false,
        duration = this.options.duration,
        easing = this.options.easing,
        lerp: lerp2 = this.options.lerp,
        onStart,
        onComplete,
        force = false,
        // scroll even if stopped
        programmatic = true,
        // called from outside of the class
        userData
      } = {}) {
        if ((this.isStopped || this.isLocked) && !force) return;
        if (typeof target === "string" && ["top", "left", "start"].includes(target)) {
          target = 0;
        } else if (typeof target === "string" && ["bottom", "right", "end"].includes(target)) {
          target = this.limit;
        } else {
          let node;
          if (typeof target === "string") {
            node = document.querySelector(target);
          } else if (target instanceof HTMLElement && (target == null ? void 0 : target.nodeType)) {
            node = target;
          }
          if (node) {
            if (this.options.wrapper !== window) {
              const wrapperRect = this.rootElement.getBoundingClientRect();
              offset -= this.isHorizontal ? wrapperRect.left : wrapperRect.top;
            }
            const rect = node.getBoundingClientRect();
            target = (this.isHorizontal ? rect.left : rect.top) + this.animatedScroll;
          }
        }
        if (typeof target !== "number") return;
        target += offset;
        target = Math.round(target);
        if (this.options.infinite) {
          if (programmatic) {
            this.targetScroll = this.animatedScroll = this.scroll;
            const distance = target - this.animatedScroll;
            if (distance > this.limit / 2) {
              target = target - this.limit;
            } else if (distance < -this.limit / 2) {
              target = target + this.limit;
            }
          }
        } else {
          target = clamp(0, target, this.limit);
        }
        if (target === this.targetScroll) {
          onStart == null ? void 0 : onStart(this);
          onComplete == null ? void 0 : onComplete(this);
          return;
        }
        this.userData = userData ?? {};
        if (immediate) {
          this.animatedScroll = this.targetScroll = target;
          this.setScroll(this.scroll);
          this.reset();
          this.preventNextNativeScrollEvent();
          this.emit();
          onComplete == null ? void 0 : onComplete(this);
          this.userData = {};
          requestAnimationFrame(() => {
            this.dispatchScrollendEvent();
          });
          return;
        }
        if (!programmatic) {
          this.targetScroll = target;
        }
        if (typeof duration === "number" && typeof easing !== "function") {
          easing = defaultEasing;
        } else if (typeof easing === "function" && typeof duration !== "number") {
          duration = 1;
        }
        this.animate.fromTo(this.animatedScroll, target, {
          duration,
          easing,
          lerp: lerp2,
          onStart: () => {
            if (lock) this.isLocked = true;
            this.isScrolling = "smooth";
            onStart == null ? void 0 : onStart(this);
          },
          onUpdate: (value, completed) => {
            this.isScrolling = "smooth";
            this.lastVelocity = this.velocity;
            this.velocity = value - this.animatedScroll;
            this.direction = Math.sign(this.velocity);
            this.animatedScroll = value;
            this.setScroll(this.scroll);
            if (programmatic) {
              this.targetScroll = value;
            }
            if (!completed) this.emit();
            if (completed) {
              this.reset();
              this.emit();
              onComplete == null ? void 0 : onComplete(this);
              this.userData = {};
              requestAnimationFrame(() => {
                this.dispatchScrollendEvent();
              });
              this.preventNextNativeScrollEvent();
            }
          }
        });
      }
      preventNextNativeScrollEvent() {
        this._preventNextNativeScrollEvent = true;
        requestAnimationFrame(() => {
          this._preventNextNativeScrollEvent = false;
        });
      }
      checkNestedScroll(node, { deltaX, deltaY }) {
        const time = Date.now();
        const cache = node._lenis ?? (node._lenis = {});
        let hasOverflowX, hasOverflowY, isScrollableX, isScrollableY, scrollWidth, scrollHeight, clientWidth, clientHeight;
        const gestureOrientation = this.options.gestureOrientation;
        if (time - (cache.time ?? 0) > 2e3) {
          cache.time = Date.now();
          const computedStyle = window.getComputedStyle(node);
          cache.computedStyle = computedStyle;
          const overflowXString = computedStyle.overflowX;
          const overflowYString = computedStyle.overflowY;
          hasOverflowX = ["auto", "overlay", "scroll"].includes(overflowXString);
          hasOverflowY = ["auto", "overlay", "scroll"].includes(overflowYString);
          cache.hasOverflowX = hasOverflowX;
          cache.hasOverflowY = hasOverflowY;
          if (!hasOverflowX && !hasOverflowY) return false;
          if (gestureOrientation === "vertical" && !hasOverflowY) return false;
          if (gestureOrientation === "horizontal" && !hasOverflowX) return false;
          scrollWidth = node.scrollWidth;
          scrollHeight = node.scrollHeight;
          clientWidth = node.clientWidth;
          clientHeight = node.clientHeight;
          isScrollableX = scrollWidth > clientWidth;
          isScrollableY = scrollHeight > clientHeight;
          cache.isScrollableX = isScrollableX;
          cache.isScrollableY = isScrollableY;
          cache.scrollWidth = scrollWidth;
          cache.scrollHeight = scrollHeight;
          cache.clientWidth = clientWidth;
          cache.clientHeight = clientHeight;
        } else {
          isScrollableX = cache.isScrollableX;
          isScrollableY = cache.isScrollableY;
          hasOverflowX = cache.hasOverflowX;
          hasOverflowY = cache.hasOverflowY;
          scrollWidth = cache.scrollWidth;
          scrollHeight = cache.scrollHeight;
          clientWidth = cache.clientWidth;
          clientHeight = cache.clientHeight;
        }
        if (!hasOverflowX && !hasOverflowY || !isScrollableX && !isScrollableY) {
          return false;
        }
        if (gestureOrientation === "vertical" && (!hasOverflowY || !isScrollableY))
          return false;
        if (gestureOrientation === "horizontal" && (!hasOverflowX || !isScrollableX))
          return false;
        let orientation;
        if (gestureOrientation === "horizontal") {
          orientation = "x";
        } else if (gestureOrientation === "vertical") {
          orientation = "y";
        } else {
          const isScrollingX = deltaX !== 0;
          const isScrollingY = deltaY !== 0;
          if (isScrollingX && hasOverflowX && isScrollableX) {
            orientation = "x";
          }
          if (isScrollingY && hasOverflowY && isScrollableY) {
            orientation = "y";
          }
        }
        if (!orientation) return false;
        let scroll, maxScroll, delta, hasOverflow, isScrollable;
        if (orientation === "x") {
          scroll = node.scrollLeft;
          maxScroll = scrollWidth - clientWidth;
          delta = deltaX;
          hasOverflow = hasOverflowX;
          isScrollable = isScrollableX;
        } else if (orientation === "y") {
          scroll = node.scrollTop;
          maxScroll = scrollHeight - clientHeight;
          delta = deltaY;
          hasOverflow = hasOverflowY;
          isScrollable = isScrollableY;
        } else {
          return false;
        }
        const willScroll = delta > 0 ? scroll < maxScroll : scroll > 0;
        return willScroll && hasOverflow && isScrollable;
      }
      /**
       * The root element on which lenis is instanced
       */
      get rootElement() {
        return this.options.wrapper === window ? document.documentElement : this.options.wrapper;
      }
      /**
       * The limit which is the maximum scroll value
       */
      get limit() {
        if (this.options.__experimental__naiveDimensions) {
          if (this.isHorizontal) {
            return this.rootElement.scrollWidth - this.rootElement.clientWidth;
          } else {
            return this.rootElement.scrollHeight - this.rootElement.clientHeight;
          }
        } else {
          return this.dimensions.limit[this.isHorizontal ? "x" : "y"];
        }
      }
      /**
       * Whether or not the scroll is horizontal
       */
      get isHorizontal() {
        return this.options.orientation === "horizontal";
      }
      /**
       * The actual scroll value
       */
      get actualScroll() {
        const wrapper = this.options.wrapper;
        return this.isHorizontal ? wrapper.scrollX ?? wrapper.scrollLeft : wrapper.scrollY ?? wrapper.scrollTop;
      }
      /**
       * The current scroll value
       */
      get scroll() {
        return this.options.infinite ? modulo(this.animatedScroll, this.limit) : this.animatedScroll;
      }
      /**
       * The progress of the scroll relative to the limit
       */
      get progress() {
        return this.limit === 0 ? 1 : this.scroll / this.limit;
      }
      /**
       * Current scroll state
       */
      get isScrolling() {
        return this._isScrolling;
      }
      set isScrolling(value) {
        if (this._isScrolling !== value) {
          this._isScrolling = value;
          this.updateClassName();
        }
      }
      /**
       * Check if lenis is stopped
       */
      get isStopped() {
        return this._isStopped;
      }
      set isStopped(value) {
        if (this._isStopped !== value) {
          this._isStopped = value;
          this.updateClassName();
        }
      }
      /**
       * Check if lenis is locked
       */
      get isLocked() {
        return this._isLocked;
      }
      set isLocked(value) {
        if (this._isLocked !== value) {
          this._isLocked = value;
          this.updateClassName();
        }
      }
      /**
       * Check if lenis is smooth scrolling
       */
      get isSmooth() {
        return this.isScrolling === "smooth";
      }
      /**
       * The class name applied to the wrapper element
       */
      get className() {
        let className = "lenis";
        if (this.options.autoToggle) className += " lenis-autoToggle";
        if (this.isStopped) className += " lenis-stopped";
        if (this.isLocked) className += " lenis-locked";
        if (this.isScrolling) className += " lenis-scrolling";
        if (this.isScrolling === "smooth") className += " lenis-smooth";
        return className;
      }
      updateClassName() {
        this.cleanUpClassName();
        this.rootElement.className = `${this.rootElement.className} ${this.className}`.trim();
      }
      cleanUpClassName() {
        this.rootElement.className = this.rootElement.className.replace(/lenis(-\w+)?/g, "").trim();
      }
    };
    function t(t2, n2) {
      for (var r2 = 0; r2 < n2.length; r2++) {
        var i2 = n2[r2];
        i2.enumerable = i2.enumerable || false, i2.configurable = true, "value" in i2 && (i2.writable = true), Object.defineProperty(t2, "symbol" == typeof (e2 = function(t3, n3) {
          if ("object" != typeof t3 || null === t3) return t3;
          var r3 = t3[Symbol.toPrimitive];
          if (void 0 !== r3) {
            var i3 = r3.call(t3, "string");
            if ("object" != typeof i3) return i3;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(t3);
        }(i2.key)) ? e2 : String(e2), i2);
      }
      var e2;
    }
    function n(n2, r2, i2) {
      return r2 && t(n2.prototype, r2), Object.defineProperty(n2, "prototype", { writable: false }), n2;
    }
    function r() {
      return r = Object.assign ? Object.assign.bind() : function(t2) {
        for (var n2 = 1; n2 < arguments.length; n2++) {
          var r2 = arguments[n2];
          for (var i2 in r2) Object.prototype.hasOwnProperty.call(r2, i2) && (t2[i2] = r2[i2]);
        }
        return t2;
      }, r.apply(this, arguments);
    }
    function i(t2, n2) {
      t2.prototype = Object.create(n2.prototype), t2.prototype.constructor = t2, o(t2, n2);
    }
    function e(t2) {
      return e = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t3) {
        return t3.__proto__ || Object.getPrototypeOf(t3);
      }, e(t2);
    }
    function o(t2, n2) {
      return o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t3, n3) {
        return t3.__proto__ = n3, t3;
      }, o(t2, n2);
    }
    function u() {
      if ("undefined" == typeof Reflect || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if ("function" == typeof Proxy) return true;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), true;
      } catch (t2) {
        return false;
      }
    }
    function s(t2, n2, r2) {
      return s = u() ? Reflect.construct.bind() : function(t3, n3, r3) {
        var i2 = [null];
        i2.push.apply(i2, n3);
        var e2 = new (Function.bind.apply(t3, i2))();
        return r3 && o(e2, r3.prototype), e2;
      }, s.apply(null, arguments);
    }
    function f(t2) {
      var n2 = "function" == typeof Map ? /* @__PURE__ */ new Map() : void 0;
      return f = function(t3) {
        if (null === t3 || -1 === Function.toString.call(t3).indexOf("[native code]")) return t3;
        if ("function" != typeof t3) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== n2) {
          if (n2.has(t3)) return n2.get(t3);
          n2.set(t3, r2);
        }
        function r2() {
          return s(t3, arguments, e(this).constructor);
        }
        return r2.prototype = Object.create(t3.prototype, { constructor: { value: r2, enumerable: false, writable: true, configurable: true } }), o(r2, t3);
      }, f(t2);
    }
    function c(t2) {
      if (void 0 === t2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return t2;
    }
    var a, h = function() {
      this.before = void 0, this.beforeLeave = void 0, this.leave = void 0, this.afterLeave = void 0, this.beforeEnter = void 0, this.enter = void 0, this.afterEnter = void 0, this.after = void 0;
    };
    !function(t2) {
      t2[t2.off = 0] = "off", t2[t2.error = 1] = "error", t2[t2.warning = 2] = "warning", t2[t2.info = 3] = "info", t2[t2.debug = 4] = "debug";
    }(a || (a = {}));
    var v = a.off, d = /* @__PURE__ */ function() {
      function t2(t3) {
        this.t = void 0, this.t = t3;
      }
      t2.getLevel = function() {
        return v;
      }, t2.setLevel = function(t3) {
        return v = a[t3];
      };
      var n2 = t2.prototype;
      return n2.error = function() {
        this.i(console.error, a.error, [].slice.call(arguments));
      }, n2.warn = function() {
        this.i(console.warn, a.warning, [].slice.call(arguments));
      }, n2.info = function() {
        this.i(console.info, a.info, [].slice.call(arguments));
      }, n2.debug = function() {
        this.i(console.log, a.debug, [].slice.call(arguments));
      }, n2.i = function(n3, r2, i2) {
        r2 <= t2.getLevel() && n3.apply(console, ["[" + this.t + "] "].concat(i2));
      }, t2;
    }();
    function l(t2) {
      return t2.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    }
    function p(t2) {
      return t2 && t2.sensitive ? "" : "i";
    }
    var m = { container: "container", history: "history", namespace: "namespace", prefix: "data-barba", prevent: "prevent", wrapper: "wrapper" }, w = new (/* @__PURE__ */ function() {
      function t2() {
        this.o = m, this.u = void 0, this.h = { after: null, before: null, parent: null };
      }
      var n2 = t2.prototype;
      return n2.toString = function(t3) {
        return t3.outerHTML;
      }, n2.toDocument = function(t3) {
        return this.u || (this.u = new DOMParser()), this.u.parseFromString(t3, "text/html");
      }, n2.toElement = function(t3) {
        var n3 = document.createElement("div");
        return n3.innerHTML = t3, n3;
      }, n2.getHtml = function(t3) {
        return void 0 === t3 && (t3 = document), this.toString(t3.documentElement);
      }, n2.getWrapper = function(t3) {
        return void 0 === t3 && (t3 = document), t3.querySelector("[" + this.o.prefix + '="' + this.o.wrapper + '"]');
      }, n2.getContainer = function(t3) {
        return void 0 === t3 && (t3 = document), t3.querySelector("[" + this.o.prefix + '="' + this.o.container + '"]');
      }, n2.removeContainer = function(t3) {
        document.body.contains(t3) && (this.v(t3), t3.parentNode.removeChild(t3));
      }, n2.addContainer = function(t3, n3) {
        var r2 = this.getContainer() || this.h.before;
        r2 ? this.l(t3, r2) : this.h.after ? this.h.after.parentNode.insertBefore(t3, this.h.after) : this.h.parent ? this.h.parent.appendChild(t3) : n3.appendChild(t3);
      }, n2.getSibling = function() {
        return this.h;
      }, n2.getNamespace = function(t3) {
        void 0 === t3 && (t3 = document);
        var n3 = t3.querySelector("[" + this.o.prefix + "-" + this.o.namespace + "]");
        return n3 ? n3.getAttribute(this.o.prefix + "-" + this.o.namespace) : null;
      }, n2.getHref = function(t3) {
        if (t3.tagName && "a" === t3.tagName.toLowerCase()) {
          if ("string" == typeof t3.href) return t3.href;
          var n3 = t3.getAttribute("href") || t3.getAttribute("xlink:href");
          if (n3) return this.resolveUrl(n3.baseVal || n3);
        }
        return null;
      }, n2.resolveUrl = function() {
        var t3 = [].slice.call(arguments).length;
        if (0 === t3) throw new Error("resolveUrl requires at least one argument; got none.");
        var n3 = document.createElement("base");
        if (n3.href = arguments[0], 1 === t3) return n3.href;
        var r2 = document.getElementsByTagName("head")[0];
        r2.insertBefore(n3, r2.firstChild);
        for (var i2, e2 = document.createElement("a"), o2 = 1; o2 < t3; o2++) e2.href = arguments[o2], n3.href = i2 = e2.href;
        return r2.removeChild(n3), i2;
      }, n2.l = function(t3, n3) {
        n3.parentNode.insertBefore(t3, n3.nextSibling);
      }, n2.v = function(t3) {
        return this.h = { after: t3.nextElementSibling, before: t3.previousElementSibling, parent: t3.parentElement }, this.h;
      }, t2;
    }())(), b = /* @__PURE__ */ function() {
      function t2() {
        this.p = void 0, this.m = [], this.P = -1;
      }
      var i2 = t2.prototype;
      return i2.init = function(t3, n2) {
        this.p = "barba";
        var r2 = { data: {}, ns: n2, scroll: { x: window.scrollX, y: window.scrollY }, url: t3 };
        this.P = 0, this.m.push(r2);
        var i3 = { from: this.p, index: this.P, states: [].concat(this.m) };
        window.history && window.history.replaceState(i3, "", t3);
      }, i2.change = function(t3, n2, r2) {
        if (r2 && r2.state) {
          var i3 = r2.state, e2 = i3.index;
          n2 = this.g(this.P - e2), this.replace(i3.states), this.P = e2;
        } else this.add(t3, n2);
        return n2;
      }, i2.add = function(t3, n2, r2, i3) {
        var e2 = null != r2 ? r2 : this.R(n2), o2 = { data: null != i3 ? i3 : {}, ns: "tmp", scroll: { x: window.scrollX, y: window.scrollY }, url: t3 };
        switch (e2) {
          case "push":
            this.P = this.size, this.m.push(o2);
            break;
          case "replace":
            this.set(this.P, o2);
        }
        var u2 = { from: this.p, index: this.P, states: [].concat(this.m) };
        switch (e2) {
          case "push":
            window.history && window.history.pushState(u2, "", t3);
            break;
          case "replace":
            window.history && window.history.replaceState(u2, "", t3);
        }
      }, i2.store = function(t3, n2) {
        var i3 = n2 || this.P, e2 = this.get(i3);
        e2.data = r({}, e2.data, t3), this.set(i3, e2);
        var o2 = { from: this.p, index: this.P, states: [].concat(this.m) };
        window.history.replaceState(o2, "");
      }, i2.update = function(t3, n2) {
        var i3 = n2 || this.P, e2 = r({}, this.get(i3), t3);
        this.set(i3, e2);
      }, i2.remove = function(t3) {
        t3 ? this.m.splice(t3, 1) : this.m.pop(), this.P--;
      }, i2.clear = function() {
        this.m = [], this.P = -1;
      }, i2.replace = function(t3) {
        this.m = t3;
      }, i2.get = function(t3) {
        return this.m[t3];
      }, i2.set = function(t3, n2) {
        return this.m[t3] = n2;
      }, i2.R = function(t3) {
        var n2 = "push", r2 = t3, i3 = m.prefix + "-" + m.history;
        return r2.hasAttribute && r2.hasAttribute(i3) && (n2 = r2.getAttribute(i3)), n2;
      }, i2.g = function(t3) {
        return Math.abs(t3) > 1 ? t3 > 0 ? "forward" : "back" : 0 === t3 ? "popstate" : t3 > 0 ? "back" : "forward";
      }, n(t2, [{ key: "current", get: function() {
        return this.m[this.P];
      } }, { key: "previous", get: function() {
        return this.P < 1 ? null : this.m[this.P - 1];
      } }, { key: "size", get: function() {
        return this.m.length;
      } }]), t2;
    }(), y = new b(), P = function(t2, n2) {
      try {
        var r2 = function() {
          if (!n2.next.html) return Promise.resolve(t2).then(function(t3) {
            var r3 = n2.next;
            if (t3) {
              var i2 = w.toElement(t3.html);
              r3.namespace = w.getNamespace(i2), r3.container = w.getContainer(i2), r3.url = t3.url, r3.html = t3.html, y.update({ ns: r3.namespace });
              var e2 = w.toDocument(t3.html);
              document.title = e2.title;
            }
          });
        }();
        return Promise.resolve(r2 && r2.then ? r2.then(function() {
        }) : void 0);
      } catch (t3) {
        return Promise.reject(t3);
      }
    }, E = function t2(n2, r2, i2) {
      return n2 instanceof RegExp ? function(t3, n3) {
        if (!n3) return t3;
        for (var r3 = /\((?:\?<(.*?)>)?(?!\?)/g, i3 = 0, e2 = r3.exec(t3.source); e2; ) n3.push({ name: e2[1] || i3++, prefix: "", suffix: "", modifier: "", pattern: "" }), e2 = r3.exec(t3.source);
        return t3;
      }(n2, r2) : Array.isArray(n2) ? function(n3, r3, i3) {
        var e2 = n3.map(function(n4) {
          return t2(n4, r3, i3).source;
        });
        return new RegExp("(?:".concat(e2.join("|"), ")"), p(i3));
      }(n2, r2, i2) : function(t3, n3, r3) {
        return function(t4, n4, r4) {
          void 0 === r4 && (r4 = {});
          for (var i3 = r4.strict, e2 = void 0 !== i3 && i3, o2 = r4.start, u2 = void 0 === o2 || o2, s2 = r4.end, f2 = void 0 === s2 || s2, c2 = r4.encode, a2 = void 0 === c2 ? function(t5) {
            return t5;
          } : c2, h2 = r4.delimiter, v2 = void 0 === h2 ? "/#?" : h2, d2 = r4.endsWith, m2 = "[".concat(l(void 0 === d2 ? "" : d2), "]|$"), w2 = "[".concat(l(v2), "]"), b2 = u2 ? "^" : "", y2 = 0, P2 = t4; y2 < P2.length; y2++) {
            var E2 = P2[y2];
            if ("string" == typeof E2) b2 += l(a2(E2));
            else {
              var g2 = l(a2(E2.prefix)), x2 = l(a2(E2.suffix));
              if (E2.pattern) if (n4 && n4.push(E2), g2 || x2) if ("+" === E2.modifier || "*" === E2.modifier) {
                var R2 = "*" === E2.modifier ? "?" : "";
                b2 += "(?:".concat(g2, "((?:").concat(E2.pattern, ")(?:").concat(x2).concat(g2, "(?:").concat(E2.pattern, "))*)").concat(x2, ")").concat(R2);
              } else b2 += "(?:".concat(g2, "(").concat(E2.pattern, ")").concat(x2, ")").concat(E2.modifier);
              else b2 += "+" === E2.modifier || "*" === E2.modifier ? "((?:".concat(E2.pattern, ")").concat(E2.modifier, ")") : "(".concat(E2.pattern, ")").concat(E2.modifier);
              else b2 += "(?:".concat(g2).concat(x2, ")").concat(E2.modifier);
            }
          }
          if (f2) e2 || (b2 += "".concat(w2, "?")), b2 += r4.endsWith ? "(?=".concat(m2, ")") : "$";
          else {
            var k2 = t4[t4.length - 1], O2 = "string" == typeof k2 ? w2.indexOf(k2[k2.length - 1]) > -1 : void 0 === k2;
            e2 || (b2 += "(?:".concat(w2, "(?=").concat(m2, "))?")), O2 || (b2 += "(?=".concat(w2, "|").concat(m2, ")"));
          }
          return new RegExp(b2, p(r4));
        }(function(t4, n4) {
          void 0 === n4 && (n4 = {});
          for (var r4 = function(t5) {
            for (var n5 = [], r5 = 0; r5 < t5.length; ) {
              var i4 = t5[r5];
              if ("*" !== i4 && "+" !== i4 && "?" !== i4) if ("\\" !== i4) if ("{" !== i4) if ("}" !== i4) if (":" !== i4) if ("(" !== i4) n5.push({ type: "CHAR", index: r5, value: t5[r5++] });
              else {
                var e3 = 1, o3 = "";
                if ("?" === t5[s3 = r5 + 1]) throw new TypeError('Pattern cannot start with "?" at '.concat(s3));
                for (; s3 < t5.length; ) if ("\\" !== t5[s3]) {
                  if (")" === t5[s3]) {
                    if (0 == --e3) {
                      s3++;
                      break;
                    }
                  } else if ("(" === t5[s3] && (e3++, "?" !== t5[s3 + 1])) throw new TypeError("Capturing groups are not allowed at ".concat(s3));
                  o3 += t5[s3++];
                } else o3 += t5[s3++] + t5[s3++];
                if (e3) throw new TypeError("Unbalanced pattern at ".concat(r5));
                if (!o3) throw new TypeError("Missing pattern at ".concat(r5));
                n5.push({ type: "PATTERN", index: r5, value: o3 }), r5 = s3;
              }
              else {
                for (var u3 = "", s3 = r5 + 1; s3 < t5.length; ) {
                  var f3 = t5.charCodeAt(s3);
                  if (!(f3 >= 48 && f3 <= 57 || f3 >= 65 && f3 <= 90 || f3 >= 97 && f3 <= 122 || 95 === f3)) break;
                  u3 += t5[s3++];
                }
                if (!u3) throw new TypeError("Missing parameter name at ".concat(r5));
                n5.push({ type: "NAME", index: r5, value: u3 }), r5 = s3;
              }
              else n5.push({ type: "CLOSE", index: r5, value: t5[r5++] });
              else n5.push({ type: "OPEN", index: r5, value: t5[r5++] });
              else n5.push({ type: "ESCAPED_CHAR", index: r5++, value: t5[r5++] });
              else n5.push({ type: "MODIFIER", index: r5, value: t5[r5++] });
            }
            return n5.push({ type: "END", index: r5, value: "" }), n5;
          }(t4), i3 = n4.prefixes, e2 = void 0 === i3 ? "./" : i3, o2 = "[^".concat(l(n4.delimiter || "/#?"), "]+?"), u2 = [], s2 = 0, f2 = 0, c2 = "", a2 = function(t5) {
            if (f2 < r4.length && r4[f2].type === t5) return r4[f2++].value;
          }, h2 = function(t5) {
            var n5 = a2(t5);
            if (void 0 !== n5) return n5;
            var i4 = r4[f2], e3 = i4.index;
            throw new TypeError("Unexpected ".concat(i4.type, " at ").concat(e3, ", expected ").concat(t5));
          }, v2 = function() {
            for (var t5, n5 = ""; t5 = a2("CHAR") || a2("ESCAPED_CHAR"); ) n5 += t5;
            return n5;
          }; f2 < r4.length; ) {
            var d2 = a2("CHAR"), p2 = a2("NAME"), m2 = a2("PATTERN");
            if (p2 || m2) -1 === e2.indexOf(b2 = d2 || "") && (c2 += b2, b2 = ""), c2 && (u2.push(c2), c2 = ""), u2.push({ name: p2 || s2++, prefix: b2, suffix: "", pattern: m2 || o2, modifier: a2("MODIFIER") || "" });
            else {
              var w2 = d2 || a2("ESCAPED_CHAR");
              if (w2) c2 += w2;
              else if (c2 && (u2.push(c2), c2 = ""), a2("OPEN")) {
                var b2 = v2(), y2 = a2("NAME") || "", P2 = a2("PATTERN") || "", E2 = v2();
                h2("CLOSE"), u2.push({ name: y2 || (P2 ? s2++ : ""), pattern: y2 && !P2 ? o2 : P2, prefix: b2, suffix: E2, modifier: a2("MODIFIER") || "" });
              } else h2("END");
            }
          }
          return u2;
        }(t3, r3), n3, r3);
      }(n2, r2, i2);
    }, g = { __proto__: null, update: P, nextTick: function() {
      return new Promise(function(t2) {
        window.requestAnimationFrame(t2);
      });
    }, pathToRegexp: E }, x = function() {
      return window.location.origin;
    }, R = function(t2) {
      return void 0 === t2 && (t2 = window.location.href), k(t2).port;
    }, k = function(t2) {
      var n2, r2 = t2.match(/:\d+/);
      if (null === r2) /^http/.test(t2) && (n2 = 80), /^https/.test(t2) && (n2 = 443);
      else {
        var i2 = r2[0].substring(1);
        n2 = parseInt(i2, 10);
      }
      var e2, o2 = t2.replace(x(), ""), u2 = {}, s2 = o2.indexOf("#");
      s2 >= 0 && (e2 = o2.slice(s2 + 1), o2 = o2.slice(0, s2));
      var f2 = o2.indexOf("?");
      return f2 >= 0 && (u2 = O(o2.slice(f2 + 1)), o2 = o2.slice(0, f2)), { hash: e2, path: o2, port: n2, query: u2 };
    }, O = function(t2) {
      return t2.split("&").reduce(function(t3, n2) {
        var r2 = n2.split("=");
        return t3[r2[0]] = r2[1], t3;
      }, {});
    }, T = function(t2) {
      return void 0 === t2 && (t2 = window.location.href), t2.replace(/(\/#.*|\/|#.*)$/, "");
    }, A = { __proto__: null, getHref: function() {
      return window.location.href;
    }, getAbsoluteHref: function(t2, n2) {
      return void 0 === n2 && (n2 = document.baseURI), new URL(t2, n2).href;
    }, getOrigin: x, getPort: R, getPath: function(t2) {
      return void 0 === t2 && (t2 = window.location.href), k(t2).path;
    }, getQuery: function(t2, n2) {
      return void 0 === n2 && (n2 = false), n2 ? JSON.stringify(k(t2).query) : k(t2).query;
    }, getHash: function(t2) {
      return k(t2).hash;
    }, parse: k, parseQuery: O, clean: T };
    function j(t2, n2, i2, e2, o2) {
      return void 0 === n2 && (n2 = 2e3), new Promise(function(u2, s2) {
        var f2 = new XMLHttpRequest();
        f2.onreadystatechange = function() {
          if (f2.readyState === XMLHttpRequest.DONE) {
            if (200 === f2.status) {
              var n3 = "" !== f2.responseURL && f2.responseURL !== t2 ? f2.responseURL : t2;
              u2({ html: f2.responseText, url: r({ href: n3 }, k(n3)) }), e2.update(t2, { status: "fulfilled", target: n3 });
            } else if (f2.status) {
              var o3 = { status: f2.status, statusText: f2.statusText };
              i2(t2, o3), s2(o3), e2.update(t2, { status: "rejected" });
            }
          }
        }, f2.ontimeout = function() {
          var r2 = new Error("Timeout error [" + n2 + "]");
          i2(t2, r2), s2(r2), e2.update(t2, { status: "rejected" });
        }, f2.onerror = function() {
          var n3 = new Error("Fetch error");
          i2(t2, n3), s2(n3), e2.update(t2, { status: "rejected" });
        }, f2.open("GET", t2), f2.timeout = n2, f2.setRequestHeader("Accept", "text/html,application/xhtml+xml,application/xml"), f2.setRequestHeader("x-barba", "yes"), o2.all().forEach(function(t3, n3) {
          f2.setRequestHeader(n3, t3);
        }), f2.send();
      });
    }
    function M(t2) {
      return !!t2 && ("object" == typeof t2 || "function" == typeof t2) && "function" == typeof t2.then;
    }
    function N(t2, n2) {
      return void 0 === n2 && (n2 = {}), function() {
        var r2 = arguments, i2 = false, e2 = new Promise(function(e3, o2) {
          n2.async = function() {
            return i2 = true, function(t3, n3) {
              t3 ? o2(t3) : e3(n3);
            };
          };
          var u2 = t2.apply(n2, [].slice.call(r2));
          i2 || (M(u2) ? u2.then(e3, o2) : e3(u2));
        });
        return e2;
      };
    }
    var S = new (/* @__PURE__ */ function(t2) {
      function n2() {
        var n3;
        return (n3 = t2.call(this) || this).logger = new d("@barba/core"), n3.all = ["ready", "page", "reset", "currentAdded", "currentRemoved", "nextAdded", "nextRemoved", "beforeOnce", "once", "afterOnce", "before", "beforeLeave", "leave", "afterLeave", "beforeEnter", "enter", "afterEnter", "after"], n3.registered = /* @__PURE__ */ new Map(), n3.init(), n3;
      }
      i(n2, t2);
      var r2 = n2.prototype;
      return r2.init = function() {
        var t3 = this;
        this.registered.clear(), this.all.forEach(function(n3) {
          t3[n3] || (t3[n3] = function(r3, i2) {
            t3.registered.has(n3) || t3.registered.set(n3, /* @__PURE__ */ new Set()), t3.registered.get(n3).add({ ctx: i2 || {}, fn: r3 });
          });
        });
      }, r2.do = function(t3) {
        var n3 = arguments, r3 = this;
        if (this.registered.has(t3)) {
          var i2 = Promise.resolve();
          return this.registered.get(t3).forEach(function(t4) {
            i2 = i2.then(function() {
              return N(t4.fn, t4.ctx).apply(void 0, [].slice.call(n3, 1));
            });
          }), i2.catch(function(n4) {
            r3.logger.debug("Hook error [" + t3 + "]"), r3.logger.error(n4);
          });
        }
        return Promise.resolve();
      }, r2.clear = function() {
        var t3 = this;
        this.all.forEach(function(n3) {
          delete t3[n3];
        }), this.init();
      }, r2.help = function() {
        this.logger.info("Available hooks: " + this.all.join(","));
        var t3 = [];
        this.registered.forEach(function(n3, r3) {
          return t3.push(r3);
        }), this.logger.info("Registered hooks: " + t3.join(","));
      }, n2;
    }(h))(), C = /* @__PURE__ */ function() {
      function t2(t3) {
        if (this.k = void 0, this.O = [], "boolean" == typeof t3) this.k = t3;
        else {
          var n2 = Array.isArray(t3) ? t3 : [t3];
          this.O = n2.map(function(t4) {
            return E(t4);
          });
        }
      }
      return t2.prototype.checkHref = function(t3) {
        if ("boolean" == typeof this.k) return this.k;
        var n2 = k(t3).path;
        return this.O.some(function(t4) {
          return null !== t4.exec(n2);
        });
      }, t2;
    }(), L = /* @__PURE__ */ function(t2) {
      function n2(n3) {
        var r2;
        return (r2 = t2.call(this, n3) || this).T = /* @__PURE__ */ new Map(), r2;
      }
      i(n2, t2);
      var e2 = n2.prototype;
      return e2.set = function(t3, n3, r2, i2, e3) {
        return this.T.set(t3, { action: r2, request: n3, status: i2, target: null != e3 ? e3 : t3 }), { action: r2, request: n3, status: i2, target: e3 };
      }, e2.get = function(t3) {
        return this.T.get(t3);
      }, e2.getRequest = function(t3) {
        return this.T.get(t3).request;
      }, e2.getAction = function(t3) {
        return this.T.get(t3).action;
      }, e2.getStatus = function(t3) {
        return this.T.get(t3).status;
      }, e2.getTarget = function(t3) {
        return this.T.get(t3).target;
      }, e2.has = function(t3) {
        return !this.checkHref(t3) && this.T.has(t3);
      }, e2.delete = function(t3) {
        return this.T.delete(t3);
      }, e2.update = function(t3, n3) {
        var i2 = r({}, this.T.get(t3), n3);
        return this.T.set(t3, i2), i2;
      }, n2;
    }(C), H = /* @__PURE__ */ function() {
      function t2() {
        this.A = /* @__PURE__ */ new Map();
      }
      var n2 = t2.prototype;
      return n2.set = function(t3, n3) {
        return this.A.set(t3, n3), { name: n3 };
      }, n2.get = function(t3) {
        return this.A.get(t3);
      }, n2.all = function() {
        return this.A;
      }, n2.has = function(t3) {
        return this.A.has(t3);
      }, n2.delete = function(t3) {
        return this.A.delete(t3);
      }, n2.clear = function() {
        return this.A.clear();
      }, t2;
    }(), _ = function() {
      return !window.history.pushState;
    }, D = function(t2) {
      return !t2.el || !t2.href;
    }, B = function(t2) {
      var n2 = t2.event;
      return n2.which > 1 || n2.metaKey || n2.ctrlKey || n2.shiftKey || n2.altKey;
    }, q = function(t2) {
      var n2 = t2.el;
      return n2.hasAttribute("target") && "_blank" === n2.target;
    }, F = function(t2) {
      var n2 = t2.el;
      return void 0 !== n2.protocol && window.location.protocol !== n2.protocol || void 0 !== n2.hostname && window.location.hostname !== n2.hostname;
    }, I = function(t2) {
      var n2 = t2.el;
      return void 0 !== n2.port && R() !== R(n2.href);
    }, U = function(t2) {
      var n2 = t2.el;
      return n2.getAttribute && "string" == typeof n2.getAttribute("download");
    }, $ = function(t2) {
      return t2.el.hasAttribute(m.prefix + "-" + m.prevent);
    }, Q = function(t2) {
      return Boolean(t2.el.closest("[" + m.prefix + "-" + m.prevent + '="all"]'));
    }, X = function(t2) {
      var n2 = t2.href;
      return T(n2) === T() && R(n2) === R();
    }, z = /* @__PURE__ */ function(t2) {
      function n2(n3) {
        var r3;
        return (r3 = t2.call(this, n3) || this).suite = [], r3.tests = /* @__PURE__ */ new Map(), r3.init(), r3;
      }
      i(n2, t2);
      var r2 = n2.prototype;
      return r2.init = function() {
        this.add("pushState", _), this.add("exists", D), this.add("newTab", B), this.add("blank", q), this.add("corsDomain", F), this.add("corsPort", I), this.add("download", U), this.add("preventSelf", $), this.add("preventAll", Q), this.add("sameUrl", X, false);
      }, r2.add = function(t3, n3, r3) {
        void 0 === r3 && (r3 = true), this.tests.set(t3, n3), r3 && this.suite.push(t3);
      }, r2.run = function(t3, n3, r3, i2) {
        return this.tests.get(t3)({ el: n3, event: r3, href: i2 });
      }, r2.checkLink = function(t3, n3, r3) {
        var i2 = this;
        return this.suite.some(function(e2) {
          return i2.run(e2, t3, n3, r3);
        });
      }, n2;
    }(C), G = /* @__PURE__ */ function(t2) {
      function n2(r2, i2) {
        var e2;
        return void 0 === i2 && (i2 = "Barba error"), (e2 = t2.call.apply(t2, [this].concat([].slice.call(arguments, 2))) || this).error = void 0, e2.label = void 0, e2.error = r2, e2.label = i2, Error.captureStackTrace && Error.captureStackTrace(c(e2), n2), e2.name = "BarbaError", e2;
      }
      return i(n2, t2), n2;
    }(/* @__PURE__ */ f(Error)), J = /* @__PURE__ */ function() {
      function t2(t3) {
        void 0 === t3 && (t3 = []), this.logger = new d("@barba/core"), this.all = [], this.page = [], this.once = [], this.j = [{ name: "namespace", type: "strings" }, { name: "custom", type: "function" }], t3 && (this.all = this.all.concat(t3)), this.update();
      }
      var n2 = t2.prototype;
      return n2.add = function(t3, n3) {
        "rule" === t3 ? this.j.splice(n3.position || 0, 0, n3.value) : this.all.push(n3), this.update();
      }, n2.resolve = function(t3, n3) {
        var r2 = this;
        void 0 === n3 && (n3 = {});
        var i2 = n3.once ? this.once : this.page;
        i2 = i2.filter(n3.self ? function(t4) {
          return t4.name && "self" === t4.name;
        } : function(t4) {
          return !t4.name || "self" !== t4.name;
        });
        var e2 = /* @__PURE__ */ new Map(), o2 = i2.find(function(i3) {
          var o3 = true, u3 = {};
          return n3.self && "self" === i3.name ? (e2.set(i3, u3), true) : (r2.j.reverse().forEach(function(n4) {
            o3 && (o3 = r2.M(i3, n4, t3, u3), i3.from && i3.to && (o3 = r2.M(i3, n4, t3, u3, "from") && r2.M(i3, n4, t3, u3, "to")), i3.from && !i3.to && (o3 = r2.M(i3, n4, t3, u3, "from")), !i3.from && i3.to && (o3 = r2.M(i3, n4, t3, u3, "to")));
          }), e2.set(i3, u3), o3);
        }), u2 = e2.get(o2), s2 = [];
        if (s2.push(n3.once ? "once" : "page"), n3.self && s2.push("self"), u2) {
          var f2, c2 = [o2];
          Object.keys(u2).length > 0 && c2.push(u2), (f2 = this.logger).info.apply(f2, ["Transition found [" + s2.join(",") + "]"].concat(c2));
        } else this.logger.info("No transition found [" + s2.join(",") + "]");
        return o2;
      }, n2.update = function() {
        var t3 = this;
        this.all = this.all.map(function(n3) {
          return t3.N(n3);
        }).sort(function(t4, n3) {
          return t4.priority - n3.priority;
        }).reverse().map(function(t4) {
          return delete t4.priority, t4;
        }), this.page = this.all.filter(function(t4) {
          return void 0 !== t4.leave || void 0 !== t4.enter;
        }), this.once = this.all.filter(function(t4) {
          return void 0 !== t4.once;
        });
      }, n2.M = function(t3, n3, r2, i2, e2) {
        var o2 = true, u2 = false, s2 = t3, f2 = n3.name, c2 = f2, a2 = f2, h2 = f2, v2 = e2 ? s2[e2] : s2, d2 = "to" === e2 ? r2.next : r2.current;
        if (e2 ? v2 && v2[f2] : v2[f2]) {
          switch (n3.type) {
            case "strings":
            default:
              var l2 = Array.isArray(v2[c2]) ? v2[c2] : [v2[c2]];
              d2[c2] && -1 !== l2.indexOf(d2[c2]) && (u2 = true), -1 === l2.indexOf(d2[c2]) && (o2 = false);
              break;
            case "object":
              var p2 = Array.isArray(v2[a2]) ? v2[a2] : [v2[a2]];
              d2[a2] ? (d2[a2].name && -1 !== p2.indexOf(d2[a2].name) && (u2 = true), -1 === p2.indexOf(d2[a2].name) && (o2 = false)) : o2 = false;
              break;
            case "function":
              v2[h2](r2) ? u2 = true : o2 = false;
          }
          u2 && (e2 ? (i2[e2] = i2[e2] || {}, i2[e2][f2] = s2[e2][f2]) : i2[f2] = s2[f2]);
        }
        return o2;
      }, n2.S = function(t3, n3, r2) {
        var i2 = 0;
        return (t3[n3] || t3.from && t3.from[n3] || t3.to && t3.to[n3]) && (i2 += Math.pow(10, r2), t3.from && t3.from[n3] && (i2 += 1), t3.to && t3.to[n3] && (i2 += 2)), i2;
      }, n2.N = function(t3) {
        var n3 = this;
        t3.priority = 0;
        var r2 = 0;
        return this.j.forEach(function(i2, e2) {
          r2 += n3.S(t3, i2.name, e2 + 1);
        }), t3.priority = r2, t3;
      }, t2;
    }();
    function W(t2, n2) {
      try {
        var r2 = t2();
      } catch (t3) {
        return n2(t3);
      }
      return r2 && r2.then ? r2.then(void 0, n2) : r2;
    }
    var K = /* @__PURE__ */ function() {
      function t2(t3) {
        void 0 === t3 && (t3 = []), this.logger = new d("@barba/core"), this.store = void 0, this.C = false, this.store = new J(t3);
      }
      var r2 = t2.prototype;
      return r2.get = function(t3, n2) {
        return this.store.resolve(t3, n2);
      }, r2.doOnce = function(t3) {
        var n2 = t3.data, r3 = t3.transition;
        try {
          var i2 = function() {
            e2.C = false;
          }, e2 = this, o2 = r3 || {};
          e2.C = true;
          var u2 = W(function() {
            return Promise.resolve(e2.L("beforeOnce", n2, o2)).then(function() {
              return Promise.resolve(e2.once(n2, o2)).then(function() {
                return Promise.resolve(e2.L("afterOnce", n2, o2)).then(function() {
                });
              });
            });
          }, function(t4) {
            e2.C = false, e2.logger.debug("Transition error [before/after/once]"), e2.logger.error(t4);
          });
          return Promise.resolve(u2 && u2.then ? u2.then(i2) : i2());
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, r2.doPage = function(t3) {
        var n2 = t3.data, r3 = t3.transition, i2 = t3.page, e2 = t3.wrapper;
        try {
          var o2 = function(t4) {
            u2.C = false;
          }, u2 = this, s2 = r3 || {}, f2 = true === s2.sync || false;
          u2.C = true;
          var c2 = W(function() {
            function t4() {
              return Promise.resolve(u2.L("before", n2, s2)).then(function() {
                function t5(t6) {
                  return Promise.resolve(u2.remove(n2)).then(function() {
                    return Promise.resolve(u2.L("after", n2, s2)).then(function() {
                    });
                  });
                }
                var r5 = function() {
                  if (f2) return W(function() {
                    return Promise.resolve(u2.add(n2, e2)).then(function() {
                      return Promise.resolve(u2.L("beforeLeave", n2, s2)).then(function() {
                        return Promise.resolve(u2.L("beforeEnter", n2, s2)).then(function() {
                          return Promise.resolve(Promise.all([u2.leave(n2, s2), u2.enter(n2, s2)])).then(function() {
                            return Promise.resolve(u2.L("afterLeave", n2, s2)).then(function() {
                              return Promise.resolve(u2.L("afterEnter", n2, s2)).then(function() {
                              });
                            });
                          });
                        });
                      });
                    });
                  }, function(t7) {
                    if (u2.H(t7)) throw new G(t7, "Transition error [sync]");
                  });
                  var t6 = function(t7) {
                    return W(function() {
                      var t8 = function() {
                        if (false !== r6) return Promise.resolve(u2.add(n2, e2)).then(function() {
                          return Promise.resolve(u2.L("beforeEnter", n2, s2)).then(function() {
                            return Promise.resolve(u2.enter(n2, s2, r6)).then(function() {
                              return Promise.resolve(u2.L("afterEnter", n2, s2)).then(function() {
                              });
                            });
                          });
                        });
                      }();
                      if (t8 && t8.then) return t8.then(function() {
                      });
                    }, function(t8) {
                      if (u2.H(t8)) throw new G(t8, "Transition error [before/after/enter]");
                    });
                  }, r6 = false, o3 = W(function() {
                    return Promise.resolve(u2.L("beforeLeave", n2, s2)).then(function() {
                      return Promise.resolve(Promise.all([u2.leave(n2, s2), P(i2, n2)]).then(function(t7) {
                        return t7[0];
                      })).then(function(t7) {
                        return r6 = t7, Promise.resolve(u2.L("afterLeave", n2, s2)).then(function() {
                        });
                      });
                    });
                  }, function(t7) {
                    if (u2.H(t7)) throw new G(t7, "Transition error [before/after/leave]");
                  });
                  return o3 && o3.then ? o3.then(t6) : t6();
                }();
                return r5 && r5.then ? r5.then(t5) : t5();
              });
            }
            var r4 = function() {
              if (f2) return Promise.resolve(P(i2, n2)).then(function() {
              });
            }();
            return r4 && r4.then ? r4.then(t4) : t4();
          }, function(t4) {
            if (u2.C = false, t4.name && "BarbaError" === t4.name) throw u2.logger.debug(t4.label), u2.logger.error(t4.error), t4;
            throw u2.logger.debug("Transition error [page]"), u2.logger.error(t4), t4;
          });
          return Promise.resolve(c2 && c2.then ? c2.then(o2) : o2());
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, r2.once = function(t3, n2) {
        try {
          return Promise.resolve(S.do("once", t3, n2)).then(function() {
            return n2.once ? N(n2.once, n2)(t3) : Promise.resolve();
          });
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, r2.leave = function(t3, n2) {
        try {
          return Promise.resolve(S.do("leave", t3, n2)).then(function() {
            return n2.leave ? N(n2.leave, n2)(t3) : Promise.resolve();
          });
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, r2.enter = function(t3, n2, r3) {
        try {
          return Promise.resolve(S.do("enter", t3, n2)).then(function() {
            return n2.enter ? N(n2.enter, n2)(t3, r3) : Promise.resolve();
          });
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, r2.add = function(t3, n2) {
        try {
          return w.addContainer(t3.next.container, n2), S.do("nextAdded", t3), Promise.resolve();
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, r2.remove = function(t3) {
        try {
          return w.removeContainer(t3.current.container), S.do("currentRemoved", t3), Promise.resolve();
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, r2.H = function(t3) {
        return t3.message ? !/Timeout error|Fetch error/.test(t3.message) : !t3.status;
      }, r2.L = function(t3, n2, r3) {
        try {
          return Promise.resolve(S.do(t3, n2, r3)).then(function() {
            return r3[t3] ? N(r3[t3], r3)(n2) : Promise.resolve();
          });
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, n(t2, [{ key: "isRunning", get: function() {
        return this.C;
      }, set: function(t3) {
        this.C = t3;
      } }, { key: "hasOnce", get: function() {
        return this.store.once.length > 0;
      } }, { key: "hasSelf", get: function() {
        return this.store.all.some(function(t3) {
          return "self" === t3.name;
        });
      } }, { key: "shouldWait", get: function() {
        return this.store.all.some(function(t3) {
          return t3.to && !t3.to.route || t3.sync;
        });
      } }]), t2;
    }(), V = /* @__PURE__ */ function() {
      function t2(t3) {
        var n2 = this;
        this.names = ["beforeLeave", "afterLeave", "beforeEnter", "afterEnter"], this.byNamespace = /* @__PURE__ */ new Map(), 0 !== t3.length && (t3.forEach(function(t4) {
          n2.byNamespace.set(t4.namespace, t4);
        }), this.names.forEach(function(t4) {
          S[t4](n2._(t4));
        }));
      }
      return t2.prototype._ = function(t3) {
        var n2 = this;
        return function(r2) {
          var i2 = t3.match(/enter/i) ? r2.next : r2.current, e2 = n2.byNamespace.get(i2.namespace);
          return e2 && e2[t3] ? N(e2[t3], e2)(r2) : Promise.resolve();
        };
      }, t2;
    }();
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest || (Element.prototype.closest = function(t2) {
      var n2 = this;
      do {
        if (n2.matches(t2)) return n2;
        n2 = n2.parentElement || n2.parentNode;
      } while (null !== n2 && 1 === n2.nodeType);
      return null;
    });
    var Y = { container: null, html: "", namespace: "", url: { hash: "", href: "", path: "", port: null, query: {} } }, Z = new (/* @__PURE__ */ function() {
      function t2() {
        this.version = "2.10.3", this.schemaPage = Y, this.Logger = d, this.logger = new d("@barba/core"), this.plugins = [], this.timeout = void 0, this.cacheIgnore = void 0, this.cacheFirstPage = void 0, this.prefetchIgnore = void 0, this.preventRunning = void 0, this.hooks = S, this.cache = void 0, this.headers = void 0, this.prevent = void 0, this.transitions = void 0, this.views = void 0, this.dom = w, this.helpers = g, this.history = y, this.request = j, this.url = A, this.D = void 0, this.B = void 0, this.q = void 0, this.F = void 0;
      }
      var i2 = t2.prototype;
      return i2.use = function(t3, n2) {
        var r2 = this.plugins;
        r2.indexOf(t3) > -1 ? this.logger.warn("Plugin [" + t3.name + "] already installed.") : "function" == typeof t3.install ? (t3.install(this, n2), r2.push(t3)) : this.logger.warn("Plugin [" + t3.name + '] has no "install" method.');
      }, i2.init = function(t3) {
        var n2 = void 0 === t3 ? {} : t3, i3 = n2.transitions, e2 = void 0 === i3 ? [] : i3, o2 = n2.views, u2 = void 0 === o2 ? [] : o2, s2 = n2.schema, f2 = void 0 === s2 ? m : s2, c2 = n2.requestError, a2 = n2.timeout, h2 = void 0 === a2 ? 2e3 : a2, v2 = n2.cacheIgnore, l2 = void 0 !== v2 && v2, p2 = n2.cacheFirstPage, w2 = void 0 !== p2 && p2, b2 = n2.prefetchIgnore, y2 = void 0 !== b2 && b2, P2 = n2.preventRunning, E2 = void 0 !== P2 && P2, g2 = n2.prevent, x2 = void 0 === g2 ? null : g2, R2 = n2.debug, k2 = n2.logLevel;
        if (d.setLevel(true === (void 0 !== R2 && R2) ? "debug" : void 0 === k2 ? "off" : k2), this.logger.info(this.version), Object.keys(f2).forEach(function(t4) {
          m[t4] && (m[t4] = f2[t4]);
        }), this.B = c2, this.timeout = h2, this.cacheIgnore = l2, this.cacheFirstPage = w2, this.prefetchIgnore = y2, this.preventRunning = E2, this.q = this.dom.getWrapper(), !this.q) throw new Error("[@barba/core] No Barba wrapper found");
        this.I();
        var O2 = this.data.current;
        if (!O2.container) throw new Error("[@barba/core] No Barba container found");
        if (this.cache = new L(l2), this.headers = new H(), this.prevent = new z(y2), this.transitions = new K(e2), this.views = new V(u2), null !== x2) {
          if ("function" != typeof x2) throw new Error("[@barba/core] Prevent should be a function");
          this.prevent.add("preventCustom", x2);
        }
        this.history.init(O2.url.href, O2.namespace), w2 && this.cache.set(O2.url.href, Promise.resolve({ html: O2.html, url: O2.url }), "init", "fulfilled"), this.U = this.U.bind(this), this.$ = this.$.bind(this), this.X = this.X.bind(this), this.G(), this.plugins.forEach(function(t4) {
          return t4.init();
        });
        var T2 = this.data;
        T2.trigger = "barba", T2.next = T2.current, T2.current = r({}, this.schemaPage), this.hooks.do("ready", T2), this.once(T2), this.I();
      }, i2.destroy = function() {
        this.I(), this.J(), this.history.clear(), this.hooks.clear(), this.plugins = [];
      }, i2.force = function(t3) {
        window.location.assign(t3);
      }, i2.go = function(t3, n2, r2) {
        var i3;
        if (void 0 === n2 && (n2 = "barba"), this.F = null, this.transitions.isRunning) this.force(t3);
        else if (!(i3 = "popstate" === n2 ? this.history.current && this.url.getPath(this.history.current.url) === this.url.getPath(t3) && this.url.getQuery(this.history.current.url, true) === this.url.getQuery(t3, true) : this.prevent.run("sameUrl", null, null, t3)) || this.transitions.hasSelf) return n2 = this.history.change(this.cache.has(t3) ? this.cache.get(t3).target : t3, n2, r2), r2 && (r2.stopPropagation(), r2.preventDefault()), this.page(t3, n2, null != r2 ? r2 : void 0, i3);
      }, i2.once = function(t3) {
        try {
          var n2 = this;
          return Promise.resolve(n2.hooks.do("beforeEnter", t3)).then(function() {
            function r2() {
              return Promise.resolve(n2.hooks.do("afterEnter", t3)).then(function() {
              });
            }
            var i3 = function() {
              if (n2.transitions.hasOnce) {
                var r3 = n2.transitions.get(t3, { once: true });
                return Promise.resolve(n2.transitions.doOnce({ transition: r3, data: t3 })).then(function() {
                });
              }
            }();
            return i3 && i3.then ? i3.then(r2) : r2();
          });
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, i2.page = function(t3, n2, i3, e2) {
        try {
          var o2, u2 = function() {
            var t4 = s2.data;
            return Promise.resolve(s2.hooks.do("page", t4)).then(function() {
              var n3 = function(n4, r2) {
                try {
                  var i4 = (u3 = s2.transitions.get(t4, { once: false, self: e2 }), Promise.resolve(s2.transitions.doPage({ data: t4, page: o2, transition: u3, wrapper: s2.q })).then(function() {
                    s2.I();
                  }));
                } catch (t5) {
                  return r2();
                }
                var u3;
                return i4 && i4.then ? i4.then(void 0, r2) : i4;
              }(0, function() {
                0 === d.getLevel() && s2.force(t4.next.url.href);
              });
              if (n3 && n3.then) return n3.then(function() {
              });
            });
          }, s2 = this;
          if (s2.data.next.url = r({ href: t3 }, s2.url.parse(t3)), s2.data.trigger = n2, s2.data.event = i3, s2.cache.has(t3)) o2 = s2.cache.update(t3, { action: "click" }).request;
          else {
            var f2 = s2.request(t3, s2.timeout, s2.onRequestError.bind(s2, n2), s2.cache, s2.headers);
            f2.then(function(r2) {
              r2.url.href !== t3 && s2.history.add(r2.url.href, n2, "replace");
            }), o2 = s2.cache.set(t3, f2, "click", "pending").request;
          }
          var c2 = function() {
            if (s2.transitions.shouldWait) return Promise.resolve(P(o2, s2.data)).then(function() {
            });
          }();
          return Promise.resolve(c2 && c2.then ? c2.then(u2) : u2());
        } catch (t4) {
          return Promise.reject(t4);
        }
      }, i2.onRequestError = function(t3) {
        this.transitions.isRunning = false;
        var n2 = [].slice.call(arguments, 1), r2 = n2[0], i3 = n2[1], e2 = this.cache.getAction(r2);
        return this.cache.delete(r2), this.B && false === this.B(t3, e2, r2, i3) || "click" === e2 && this.force(r2), false;
      }, i2.prefetch = function(t3) {
        var n2 = this;
        t3 = this.url.getAbsoluteHref(t3), this.cache.has(t3) || this.cache.set(t3, this.request(t3, this.timeout, this.onRequestError.bind(this, "barba"), this.cache, this.headers).catch(function(t4) {
          n2.logger.error(t4);
        }), "prefetch", "pending");
      }, i2.G = function() {
        true !== this.prefetchIgnore && (document.addEventListener("mouseover", this.U), document.addEventListener("touchstart", this.U)), document.addEventListener("click", this.$), window.addEventListener("popstate", this.X);
      }, i2.J = function() {
        true !== this.prefetchIgnore && (document.removeEventListener("mouseover", this.U), document.removeEventListener("touchstart", this.U)), document.removeEventListener("click", this.$), window.removeEventListener("popstate", this.X);
      }, i2.U = function(t3) {
        var n2 = this, r2 = this.W(t3);
        if (r2) {
          var i3 = this.url.getAbsoluteHref(this.dom.getHref(r2));
          this.prevent.checkHref(i3) || this.cache.has(i3) || this.cache.set(i3, this.request(i3, this.timeout, this.onRequestError.bind(this, r2), this.cache, this.headers).catch(function(t4) {
            n2.logger.error(t4);
          }), "enter", "pending");
        }
      }, i2.$ = function(t3) {
        var n2 = this.W(t3);
        if (n2) {
          if (this.transitions.isRunning && this.preventRunning) return t3.preventDefault(), void t3.stopPropagation();
          this.F = t3, this.go(this.dom.getHref(n2), n2, t3);
        }
      }, i2.X = function(t3) {
        this.go(this.url.getHref(), "popstate", t3);
      }, i2.W = function(t3) {
        for (var n2 = t3.target; n2 && !this.dom.getHref(n2); ) n2 = n2.parentNode;
        if (n2 && !this.prevent.checkLink(n2, t3, this.dom.getHref(n2))) return n2;
      }, i2.I = function() {
        var t3 = this.url.getHref(), n2 = { container: this.dom.getContainer(), html: this.dom.getHtml(), namespace: this.dom.getNamespace(), url: r({ href: t3 }, this.url.parse(t3)) };
        this.D = { current: n2, event: void 0, next: r({}, this.schemaPage), trigger: void 0 }, this.hooks.do("reset", this.data);
      }, n(t2, [{ key: "data", get: function() {
        return this.D;
      } }, { key: "wrapper", get: function() {
        return this.q;
      } }]), t2;
    }())();
    class VideoPosterGenerator {
      constructor() {
        this.processedVideos = /* @__PURE__ */ new Set();
        this.init();
      }
      init() {
        this.processAllVideos();
        this.observeNewVideos();
      }
      /**
       * Generate poster from first frame of a video
       * @param {HTMLVideoElement} video - The video element
       * @param {Object} options - Configuration options
       */
      generatePoster(video, options = {}) {
        const {
          quality = 0.8,
          format = "image/jpeg",
          width = null,
          height = null
        } = options;
        if (!video || this.processedVideos.has(video)) {
          return Promise.resolve();
        }
        return new Promise((resolve, reject) => {
          var _a2;
          const tempVideo = document.createElement("video");
          tempVideo.crossOrigin = "anonymous";
          tempVideo.muted = true;
          tempVideo.playsInline = true;
          const videoUrl = video.dataset.videoUrl || video.src || ((_a2 = video.querySelector("source")) == null ? void 0 : _a2.src);
          if (!videoUrl) {
            reject(new Error("No video URL found"));
            return;
          }
          tempVideo.src = videoUrl;
          tempVideo.addEventListener("loadeddata", () => {
            try {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              const videoWidth = width || tempVideo.videoWidth || 1920;
              const videoHeight = height || tempVideo.videoHeight || 1080;
              canvas.width = videoWidth;
              canvas.height = videoHeight;
              ctx.drawImage(tempVideo, 0, 0, videoWidth, videoHeight);
              const dataURL = canvas.toDataURL(format, quality);
              video.poster = dataURL;
              this.processedVideos.add(video);
              tempVideo.remove();
              canvas.remove();
              resolve(dataURL);
            } catch (error) {
              tempVideo.remove();
              reject(error);
            }
          }, { once: true });
          tempVideo.addEventListener("error", (e2) => {
            tempVideo.remove();
            reject(new Error("Failed to load video for poster generation"));
          }, { once: true });
          tempVideo.load();
        });
      }
      /**
       * Process all videos with data-video-url attribute
       */
      async processAllVideos() {
        const videos = document.querySelectorAll("video[data-video-url]");
        for (const video of videos) {
          try {
            await this.generatePoster(video);
          } catch (error) {
            console.warn("Failed to generate poster for video:", error);
          }
        }
      }
      /**
       * Watch for new videos added to the DOM
       */
      observeNewVideos() {
        if (typeof MutationObserver === "undefined") {
          return;
        }
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              var _a2;
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.tagName === "VIDEO" && node.dataset.videoUrl) {
                  this.generatePoster(node).catch(console.warn);
                }
                const videos = (_a2 = node.querySelectorAll) == null ? void 0 : _a2.call(node, "video[data-video-url]");
                if (videos) {
                  videos.forEach((video) => {
                    this.generatePoster(video).catch(console.warn);
                  });
                }
              }
            });
          });
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
      /**
       * Generate poster for a specific video by URL
       * @param {string} videoUrl - The video URL
       * @param {Object} options - Configuration options
       */
      async generatePosterFromUrl(videoUrl, options = {}) {
        const tempVideo = document.createElement("video");
        tempVideo.crossOrigin = "anonymous";
        tempVideo.muted = true;
        tempVideo.playsInline = true;
        tempVideo.src = videoUrl;
        return new Promise((resolve, reject) => {
          tempVideo.addEventListener("loadeddata", () => {
            try {
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");
              const { quality = 0.8, format = "image/jpeg", width, height } = options;
              const videoWidth = width || tempVideo.videoWidth || 1920;
              const videoHeight = height || tempVideo.videoHeight || 1080;
              canvas.width = videoWidth;
              canvas.height = videoHeight;
              ctx.drawImage(tempVideo, 0, 0, videoWidth, videoHeight);
              const dataURL = canvas.toDataURL(format, quality);
              tempVideo.remove();
              canvas.remove();
              resolve(dataURL);
            } catch (error) {
              tempVideo.remove();
              reject(error);
            }
          }, { once: true });
          tempVideo.addEventListener("error", () => {
            tempVideo.remove();
            reject(new Error("Failed to load video"));
          }, { once: true });
          tempVideo.load();
        });
      }
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        window.videoPosterGenerator = new VideoPosterGenerator();
      });
    } else {
      window.videoPosterGenerator = new VideoPosterGenerator();
    }
    if (typeof module !== "undefined" && module.exports) {
      module.exports = VideoPosterGenerator;
    }
    class ScrollManager {
      constructor() {
        this.lenis = null;
        this.isInitialized = false;
        this.init();
      }
      async init() {
        if (this.isInitialized) return;
        await this.waitForDependencies();
        this.setupLenis();
        this.setupScrollTrigger();
        this.watchOverlays();
        this.isInitialized = true;
      }
      waitForDependencies() {
        return new Promise((resolve) => {
          const check = () => {
            if (window.gsap && window.ScrollTrigger && window.Lenis) {
              resolve();
            } else {
              setTimeout(check, 50);
            }
          };
          check();
        });
      }
      setupLenis() {
        this.lenis = new window.Lenis({
          // autoRaf: false — we tick it from GSAP below so there is a single loop.
          autoRaf: false,
          // Smooth the TOUCH scroll too. Off (the Lenis default) the browser
          // owns momentum on mobile: it halts abruptly, and it feeds
          // ScrollTrigger positions from natively-dispatched scroll events,
          // which arrive irregularly. With this on, Lenis eases touch to a
          // stop and produces the scroll position inside rAF, so scrubbed
          // animation tracks it exactly.
          syncTouch: true,
          // Glide: lower = longer, floatier coast. 0.075 is the Lenis default.
          syncTouchLerp: 0.08,
          // Momentum strength from a flick. Default 35; a little lower keeps
          // the coast from overshooting where the user expected to stop.
          touchInertiaMultiplier: 28
        });
        this.lenis.on("scroll", window.ScrollTrigger.update);
        this.tick = (time) => {
          var _a2;
          return (_a2 = this.lenis) == null ? void 0 : _a2.raf(time * 1e3);
        };
        window.gsap.ticker.add(this.tick);
        window.gsap.ticker.lagSmoothing(0);
        window.lenis = this.lenis;
      }
      setupScrollTrigger() {
        window.gsap.registerPlugin(window.ScrollTrigger);
        window.ScrollTrigger.config({
          // On mobile the URL bar collapses as you scroll, which fires resize
          // mid-scroll. Without this every trigger recalculates while the user
          // is moving — and vh-sized sections change height at the same time —
          // which lands as a visible jump.
          ignoreMobileResize: true,
          autoRefreshEvents: "visibilitychange,DOMContentLoaded,load,resize"
        });
      }
      /**
       * Freeze Lenis while a drawer / modal is open.
       *
       * The parent theme's drawers (cart, search) lock the page by putting
       * `.lock` on <html> — which is `overflow: hidden`, and that alone is NOT
       * reliable on iOS Safari: the page still drags behind the overlay. Our own
       * menu drawer instead calls lenis.stop() directly. Watch both signals so
       * the page is genuinely held whichever overlay is open.
       *
       * Only acts on a change of state, never on every mutation — otherwise it
       * could call start() during a page transition, which stops Lenis for its
       * own reasons (see main.js).
       */
      watchOverlays() {
        const isOverlayOpen = () => document.documentElement.classList.contains("lock") || !!document.querySelector('.rm-nav[data-navigation-status="active"]');
        let heldByOverlay = false;
        const sync = () => {
          var _a2, _b2;
          const open = isOverlayOpen();
          if (open === heldByOverlay) return;
          heldByOverlay = open;
          if (open) (_a2 = this.lenis) == null ? void 0 : _a2.stop();
          else (_b2 = this.lenis) == null ? void 0 : _b2.start();
        };
        this.overlayObserver = new MutationObserver(sync);
        this.overlayObserver.observe(document.documentElement, {
          attributes: true,
          attributeFilter: ["class", "data-navigation-status"],
          subtree: true
        });
        sync();
      }
      scrollTo(target, options = {}) {
        var _a2;
        (_a2 = this.lenis) == null ? void 0 : _a2.scrollTo(target, options);
      }
      stop() {
        var _a2;
        (_a2 = this.lenis) == null ? void 0 : _a2.stop();
      }
      start() {
        var _a2;
        (_a2 = this.lenis) == null ? void 0 : _a2.start();
      }
      refresh() {
        var _a2;
        (_a2 = window.ScrollTrigger) == null ? void 0 : _a2.refresh();
      }
      destroy() {
        var _a2, _b2, _c;
        (_a2 = this.overlayObserver) == null ? void 0 : _a2.disconnect();
        if (this.tick) (_b2 = window.gsap) == null ? void 0 : _b2.ticker.remove(this.tick);
        (_c = this.lenis) == null ? void 0 : _c.destroy();
        this.lenis = null;
        this.isInitialized = false;
      }
    }
    window.scrollManager = new ScrollManager();
    class SplitLines extends HTMLElement {
      constructor() {
        super();
        this.requireSplit = true;
        this.lastScreenWidth = window.innerWidth;
        this.attachShadow({ mode: "open" });
        this.shadowRoot.appendChild(document.createRange().createContextualFragment("<slot></slot>"));
        this.resizeTimeout = null;
        this.throttledResize = () => {
          clearTimeout(this.resizeTimeout);
          this.resizeTimeout = setTimeout(() => this.onWindowResized(), 100);
        };
        window.addEventListener("resize", this.throttledResize);
        this.mutationObserver = new MutationObserver(() => this.split(true));
        this.mutationObserver.observe(this, {
          characterData: true,
          attributes: false,
          childList: false,
          subtree: true
        });
      }
      connectedCallback() {
        if (this.hasAttribute("split-on-insert")) {
          this.split();
        }
      }
      disconnectedCallback() {
        if (this.resizeTimeout) {
          clearTimeout(this.resizeTimeout);
        }
        window.removeEventListener("resize", this.throttledResize);
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
        }
      }
      get lines() {
        this.split();
        return Array.from(this.shadowRoot.children);
      }
      get preserveLetters() {
        return this.hasAttribute("preserve-letters");
      }
      get manualBreaks() {
        return this.hasAttribute("manual-breaks");
      }
      split(force = false) {
        if (!this.requireSplit && !force) {
          return;
        }
        let content = this.textContent;
        if (this.manualBreaks) {
          content = content.replace(/<br\s*\/?>/gi, "\n");
          const lines = content.split("\n");
          this.shadowRoot.innerHTML = "";
          lines.forEach((line, index) => {
            if (line.trim() === "") return;
            const lineElement = document.createElement("span");
            lineElement.setAttribute("part", "line");
            lineElement.style.display = "inline-block";
            if (this.preserveLetters) {
              lineElement.innerHTML = line.replace(/./g, '<span part="letter">$&</span>').replace(/\s/g, " ");
            } else {
              lineElement.textContent = line;
            }
            this.shadowRoot.appendChild(lineElement);
          });
        } else {
          this.shadowRoot.innerHTML = this.textContent.replace(/./g, '<span part="letter">$&</span>').replace(/\s/g, " ");
          const bounds = /* @__PURE__ */ new Map();
          Array.from(this.shadowRoot.children).forEach((letter) => {
            const key = Math.round(letter.offsetTop);
            if (this.preserveLetters) {
              bounds.set(key, (bounds.get(key) || "").concat(letter.outerHTML));
            } else {
              bounds.set(key, (bounds.get(key) || "").concat(letter.textContent));
            }
          });
          this.shadowRoot.replaceChildren(
            ...Array.from(bounds.values(), (line) => {
              return document.createRange().createContextualFragment(
                `<span part="line" style="display: inline-block;">${line}</span>`
              );
            })
          );
        }
        this.requireSplit = false;
        this.classList.add("is-split");
        this.dispatchEvent(new CustomEvent("split-lines:split", {
          bubbles: true,
          detail: { lines: Array.from(this.shadowRoot.children) }
        }));
      }
      onWindowResized() {
        if (this.lastScreenWidth === window.innerWidth) {
          return;
        }
        if (this.manualBreaks) {
          this.lastScreenWidth = window.innerWidth;
          return;
        }
        this.split(true);
        this.lastScreenWidth = window.innerWidth;
      }
    }
    if (!window.customElements.get("split-lines")) {
      window.customElements.define("split-lines", SplitLines);
    }
    gsapWithCSS.registerPlugin(ScrollTrigger, CustomEase, Flip);
    window.gsap = gsapWithCSS;
    window.ScrollTrigger = ScrollTrigger;
    window.Flip = Flip;
    window.Lenis = Lenis;
    window.barba = Z;
    gsapWithCSS.registerPlugin(CustomEase);
    history.scrollRestoration = "manual";
    let lenis = null;
    let onceFunctionsInitialized = false;
    const hasLenis = typeof window.Lenis !== "undefined";
    const hasScrollTrigger = typeof window.ScrollTrigger !== "undefined";
    const rmMQ = window.matchMedia("(prefers-reduced-motion: reduce)");
    let reducedMotion = rmMQ.matches;
    (_a = rmMQ.addEventListener) == null ? void 0 : _a.call(rmMQ, "change", (e2) => reducedMotion = e2.matches);
    (_b = rmMQ.addListener) == null ? void 0 : _b.call(rmMQ, (e2) => reducedMotion = e2.matches);
    let durationDefault = 0.6;
    CustomEase.create("osmo", "0.625, 0.05, 0, 1");
    gsapWithCSS.defaults({ ease: "osmo", duration: durationDefault });
    function initOnceFunctions(container) {
      initLenis();
      if (onceFunctionsInitialized) return;
      onceFunctionsInitialized = true;
      applyHeaderStyles(container);
    }
    function initBeforeEnterFunctions(next) {
    }
    function initAfterEnterFunctions(next) {
      applyHeaderStyles(next);
      if (hasLenis && lenis) {
        lenis.resize();
      }
      if (hasScrollTrigger) {
        ScrollTrigger.refresh();
      }
    }
    function runPageOnceAnimation(next) {
      const tl = gsapWithCSS.timeline();
      tl.call(() => {
        resetPage(next);
      }, null, 0);
      return tl;
    }
    function runPageLeaveAnimation(current, next) {
      const transitionWrap = document.querySelector("[data-transition-wrap]");
      const transitionPanel = transitionWrap.querySelector("[data-transition-panel]");
      const transitionLabel = transitionWrap.querySelector("[data-transition-label]");
      const tl = gsapWithCSS.timeline({
        onComplete: () => {
          current.remove();
        }
      });
      if (reducedMotion) {
        return tl.set(current, { autoAlpha: 0 });
      }
      tl.set(transitionPanel, { autoAlpha: 1 }, 0);
      tl.set(next, { autoAlpha: 0 }, 0);
      tl.fromTo(transitionPanel, {
        yPercent: 0
      }, {
        yPercent: -100,
        duration: 0.8
      }, 0);
      tl.fromTo(transitionLabel, {
        autoAlpha: 0
      }, {
        autoAlpha: 1
      }, "<+=0.2");
      tl.fromTo(current, {
        y: "0vh"
      }, {
        y: "-15vh",
        duration: 0.8
      }, 0);
    }
    function runPageEnterAnimation(next) {
      const transitionWrap = document.querySelector("[data-transition-wrap]");
      const transitionPanel = transitionWrap.querySelector("[data-transition-panel]");
      const transitionLabel = transitionWrap.querySelector("[data-transition-label]");
      const tl = gsapWithCSS.timeline();
      if (reducedMotion) {
        tl.set(next, { autoAlpha: 1 });
        tl.add("pageReady");
        tl.call(resetPage, [next], "pageReady");
        return new Promise((resolve) => tl.call(resolve, null, "pageReady"));
      }
      tl.add("startEnter", 1.25);
      tl.set(next, { autoAlpha: 1 }, "startEnter");
      tl.call(() => applyHeaderStyles(next), null, "startEnter");
      tl.fromTo(transitionPanel, {
        yPercent: -100
      }, {
        yPercent: -200,
        duration: 1,
        overwrite: "auto",
        immediateRender: false
      }, "startEnter");
      tl.set(transitionPanel, { autoAlpha: 0 }, ">");
      tl.fromTo(transitionLabel, {
        autoAlpha: 1
      }, {
        autoAlpha: 0,
        duration: 0.4,
        overwrite: "auto",
        immediateRender: false
      }, "startEnter+=0.1");
      tl.from(next, {
        y: "15vh",
        duration: 1
      }, "startEnter");
      tl.add("pageReady");
      tl.call(resetPage, [next], "pageReady");
      return new Promise((resolve) => {
        tl.call(resolve, null, "pageReady");
      });
    }
    Z.hooks.before(() => {
      var _a2, _b2;
      (_a2 = document.querySelector("cart-drawer")) == null ? void 0 : _a2.removeAttribute("open");
      (_b2 = document.querySelector("#menu-drawer")) == null ? void 0 : _b2.removeAttribute("open");
    });
    Z.hooks.beforeEnter((data) => {
      gsapWithCSS.set(data.next.container, {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0
      });
      if (lenis && typeof lenis.stop === "function") {
        lenis.stop();
      }
      window.scrollTo(0, 0);
      if (lenis && typeof lenis.scrollTo === "function") {
        lenis.scrollTo(0, { immediate: true, force: true });
      }
      initBeforeEnterFunctions(data.next.container);
    });
    Z.hooks.afterLeave(() => {
      if (hasScrollTrigger) {
        ScrollTrigger.getAll().forEach((trigger) => {
          if (trigger.trigger && !document.documentElement.contains(trigger.trigger)) {
            trigger.kill();
          } else if (!trigger.trigger) {
            trigger.kill();
          }
        });
      }
    });
    Z.hooks.enter((data) => {
      initBarbaNavUpdate(data);
    });
    Z.hooks.afterEnter((data) => {
      reExecuteScripts(data.next.container);
      initAfterEnterFunctions(data.next.container);
      if (hasLenis && lenis) {
        lenis.resize();
        lenis.start();
      }
      if (hasScrollTrigger) {
        ScrollTrigger.refresh();
        setTimeout(() => {
          var _a2;
          ScrollTrigger.refresh();
          (_a2 = window.initFooterAnimations) == null ? void 0 : _a2.call(window);
        }, 200);
      }
    });
    Z.init({
      debug: false,
      timeout: 7e3,
      preventRunning: true,
      prevent: ({ el }) => {
        const href = el.href || "";
        return href.includes("/cart") || href.includes("/checkout") || href.includes("/account") || href.includes("/password") || href.includes("cdn.shopify.com") || el.hasAttribute("data-no-barba") || el.classList.contains("no-barba");
      },
      transitions: [
        {
          name: "page-name-wipe",
          sync: true,
          async once(data) {
            initOnceFunctions(data.next.container);
            if (hasScrollTrigger) {
              ScrollTrigger.refresh();
              setTimeout(() => ScrollTrigger.refresh(), 300);
            }
            return runPageOnceAnimation(data.next.container);
          },
          async leave(data) {
            return runPageLeaveAnimation(data.current.container, data.next.container);
          },
          async enter(data) {
            return runPageEnterAnimation(data.next.container);
          }
        }
      ]
    });
    function initLenis() {
      if (lenis) return;
      if (window.lenis) {
        lenis = window.lenis;
        return;
      }
      const check = setInterval(() => {
        if (window.lenis) {
          lenis = window.lenis;
          clearInterval(check);
        }
      }, 50);
    }
    function resetPage(container) {
      window.scrollTo(0, 0);
      if (hasLenis && lenis) {
        lenis.scrollTo(0, { immediate: true, force: true });
      }
      gsapWithCSS.set(container, { clearProps: "all" });
      if (hasLenis && lenis) {
        lenis.resize();
        lenis.start();
      }
    }
    function reExecuteScripts(container) {
      Array.from(container.querySelectorAll("script")).forEach((oldScript) => {
        var _a2;
        const newScript = document.createElement("script");
        Array.from(oldScript.attributes).forEach((attr) => {
          newScript.setAttribute(attr.name, attr.value);
        });
        newScript.textContent = oldScript.textContent;
        (_a2 = oldScript.parentNode) == null ? void 0 : _a2.replaceChild(newScript, oldScript);
      });
    }
    const darkHeaderTemplates = ["page.faq", "404", "product", "product.cask", "product.chapter-02"];
    function applyHeaderStyles(container) {
      var _a2;
      const header = document.querySelector(".header--transparent");
      if (!header) return;
      const template = ((_a2 = container == null ? void 0 : container.dataset) == null ? void 0 : _a2.template) ?? "";
      const needsDark = darkHeaderTemplates.includes(template);
      const logo = header.querySelector(".header__logo-image--transparent") ?? header.querySelector(".header__logo-image");
      const navLinks = header.querySelectorAll(".header__secondary-nav a, .header__primary-nav a");
      const menuLink = header.querySelector(".header__menu-link");
      if (needsDark) {
        if (logo) logo.style.filter = "brightness(0) saturate(100%) invert(31%) sepia(11%) saturate(1234%) hue-rotate(15deg) brightness(97%) contrast(89%)";
        if (menuLink) menuLink.style.color = "#595538";
        navLinks.forEach((link) => {
          link.style.color = "#595538";
        });
      } else {
        if (logo) logo.style.filter = "";
        if (menuLink) menuLink.style.color = "";
        navLinks.forEach((link) => {
          link.style.color = "";
        });
      }
    }
    function initBarbaNavUpdate(data) {
      const tpl = document.createElement("template");
      tpl.innerHTML = data.next.html.trim();
      const nextNodes = tpl.content.querySelectorAll("[data-barba-update]");
      const currentNodes = document.querySelectorAll("nav [data-barba-update]");
      currentNodes.forEach((curr, index) => {
        const next = nextNodes[index];
        if (!next) return;
        const newStatus = next.getAttribute("aria-current");
        if (newStatus !== null) {
          curr.setAttribute("aria-current", newStatus);
        } else {
          curr.removeAttribute("aria-current");
        }
        const newClassList = next.getAttribute("class") || "";
        curr.setAttribute("class", newClassList);
      });
    }
    class PurchaseLimitManager {
      constructor() {
        this.productLimits = /* @__PURE__ */ new Map();
        this.init();
      }
      init() {
        document.addEventListener("cart:change", this.handleCartChange.bind(this));
        document.addEventListener("submit", this.handleProductFormSubmit.bind(this));
        document.addEventListener("line-item:change", this.handleLineItemChange.bind(this));
        document.addEventListener("variant:change", this.handleVariantChange.bind(this));
      }
      async handleProductFormSubmit(event) {
        var _a2, _b2;
        const form = event.target;
        if (!form.matches('form[action*="/cart/add"]')) return;
        const variantId = (_a2 = form.querySelector('input[name="id"]')) == null ? void 0 : _a2.value;
        if (!variantId) {
          console.log("No variant ID found in form");
          return;
        }
        const productId = await this.getProductIdFromVariantId(variantId);
        if (!productId) {
          console.log("Could not determine product ID from variant:", variantId);
          return;
        }
        console.log("Checking purchase limits for product:", productId);
        const limitPurchase = await this.getProductPurchaseLimit(productId);
        if (!limitPurchase) {
          console.log("No purchase limit set for product:", productId);
          return;
        }
        const currentQuantity = await this.getCurrentCartQuantity(productId);
        const requestedQuantity = parseInt(((_b2 = form.querySelector('input[name="quantity"]')) == null ? void 0 : _b2.value) || 1);
        console.log("Purchase limit check:", {
          productId,
          limitPurchase,
          currentQuantity,
          requestedQuantity,
          total: currentQuantity + requestedQuantity
        });
        if (currentQuantity + requestedQuantity > limitPurchase) {
          event.preventDefault();
          this.showLimitError(limitPurchase, currentQuantity);
          return;
        }
        console.log("Purchase limit check passed");
      }
      async handleCartChange(event) {
        const cart = event.detail.cart;
        if (!cart || !cart.items) return;
        for (const item of cart.items) {
          const limitPurchase = await this.getProductPurchaseLimit(item.product_id);
          if (!limitPurchase) continue;
          if (item.quantity > limitPurchase) {
            await this.updateCartItemQuantity(item.key, limitPurchase);
            this.showLimitError(limitPurchase, limitPurchase);
          }
        }
      }
      async handleLineItemChange(event) {
        const lineItem = event.target;
        const productId = this.getProductIdFromLineItem(lineItem);
        if (!productId) return;
        const limitPurchase = await this.getProductPurchaseLimit(productId);
        if (!limitPurchase) return;
        const newQuantity = event.detail.quantity;
        if (newQuantity > limitPurchase) {
          await this.updateCartItemQuantity(event.detail.key, limitPurchase);
          this.showLimitError(limitPurchase, limitPurchase);
        }
      }
      async handleVariantChange(event) {
        const variant = event.detail.variant;
        if (!variant) return;
        const productId = variant.product_id;
        const limitPurchase = await this.getProductPurchaseLimit(productId);
        if (limitPurchase) {
          const quantitySelector = document.querySelector("quantity-selector");
          if (quantitySelector) {
            const currentQuantity = await this.getCurrentCartQuantity(productId);
            const maxAllowed = Math.max(0, limitPurchase - currentQuantity);
            const input = quantitySelector.querySelector("input");
            if (input) {
              input.setAttribute("max", maxAllowed);
              if (parseInt(input.value) > maxAllowed) {
                input.value = maxAllowed;
              }
            }
          }
        }
      }
      getProductIdFromLineItem(lineItem) {
        const productIdAttr = lineItem.getAttribute("data-product-id");
        if (productIdAttr) return productIdAttr;
        const cartData = window.cartData || {};
        const lineItemKey = lineItem.getAttribute("data-line-item-key");
        if (lineItemKey && cartData.items) {
          const item = cartData.items.find((item2) => item2.key === lineItemKey);
          return item == null ? void 0 : item.product_id;
        }
        return null;
      }
      async getProductIdFromVariantId(variantId) {
        var _a2, _b2, _c;
        try {
          if ((_a2 = window.productData) == null ? void 0 : _a2.id) {
            console.log("Using product ID from injected data:", window.productData.id);
            return window.productData.id.toString();
          }
          if ((_c = (_b2 = window.themeVariables) == null ? void 0 : _b2.product) == null ? void 0 : _c.id) {
            console.log("Using product ID from theme variables:", window.themeVariables.product.id);
            return window.themeVariables.product.id.toString();
          }
          if (!this.productsCache) {
            console.log("Fetching products.json for variant lookup...");
            const response = await fetch(`/products.json`);
            if (!response.ok) {
              console.warn("Failed to fetch products.json:", response.status);
              return null;
            }
            this.productsCache = await response.json();
          }
          for (const product of this.productsCache.products) {
            for (const variant of product.variants) {
              if (variant.id.toString() === variantId.toString()) {
                console.log("Found product ID from products.json:", product.id);
                return product.id.toString();
              }
            }
          }
          console.warn("Could not find product ID for variant:", variantId);
        } catch (error) {
          console.error("Error fetching product data:", error);
        }
        return null;
      }
      async getProductPurchaseLimit(productId) {
        var _a2, _b2, _c, _d, _e, _f, _g, _h, _i2;
        if (this.productLimits.has(productId)) {
          return this.productLimits.get(productId);
        }
        try {
          if (window.productData && window.productData.id.toString() === productId.toString()) {
            const limit = ((_b2 = (_a2 = window.productData.metafields) == null ? void 0 : _a2.custom) == null ? void 0 : _b2.limit_purchase) || null;
            this.productLimits.set(productId, limit);
            console.log(`Purchase limit for product ${productId}:`, limit);
            return limit;
          }
          if (((_d = (_c = window.themeVariables) == null ? void 0 : _c.product) == null ? void 0 : _d.id) === parseInt(productId)) {
            const limit = ((_g = (_f = (_e = window.themeVariables.product) == null ? void 0 : _e.metafields) == null ? void 0 : _f.custom) == null ? void 0 : _g.limit_purchase) || null;
            this.productLimits.set(productId, limit);
            console.log(`Purchase limit for product ${productId} (theme):`, limit);
            return limit;
          }
          if (this.productsCache) {
            const product = this.productsCache.products.find((p2) => p2.id.toString() === productId.toString());
            if (product && ((_i2 = (_h = product.metafields) == null ? void 0 : _h.custom) == null ? void 0 : _i2.limit_purchase)) {
              const limit = product.metafields.custom.limit_purchase;
              this.productLimits.set(productId, limit);
              console.log(`Purchase limit for product ${productId} (cache):`, limit);
              return limit;
            }
          }
          console.warn(`No purchase limit data found for product ${productId}, skipping API call to avoid 404`);
          this.productLimits.set(productId, null);
          return null;
        } catch (error) {
          console.error("Error getting product purchase limit:", error);
          this.productLimits.set(productId, null);
          return null;
        }
      }
      async getCurrentCartQuantity(productId) {
        try {
          const response = await fetch("/cart.js");
          const cart = await response.json();
          const item = cart.items.find((item2) => item2.product_id.toString() === productId.toString());
          return item ? item.quantity : 0;
        } catch (error) {
          console.error("Error fetching cart data:", error);
          return 0;
        }
      }
      async updateCartItemQuantity(lineItemKey, quantity) {
        try {
          const response = await fetch("/cart/change.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              id: lineItemKey,
              quantity
            })
          });
          if (response.ok) {
            document.dispatchEvent(new CustomEvent("cart:refresh"));
          }
        } catch (error) {
          console.error("Error updating cart item quantity:", error);
        }
      }
      showLimitError(limit, currentQuantity) {
        const message = `Purchase limit reached. You can only purchase ${limit} of this item.`;
        document.dispatchEvent(new CustomEvent("toast:show", {
          detail: {
            message,
            tone: "error"
          }
        }));
        console.warn("Purchase limit exceeded:", { limit, currentQuantity });
      }
    }
    document.addEventListener("DOMContentLoaded", () => {
      window.purchaseLimitManager = new PurchaseLimitManager();
    });
    if (typeof window.productData === "undefined") {
      window.productData = null;
    }
    window.setProductData = function(productData) {
      window.productData = productData;
    };
    window.testPurchaseLimits = function() {
      var _a2, _b2, _c;
      console.log("=== Purchase Limit Debug Info ===");
      console.log("Product Data:", window.productData);
      console.log("Theme Variables:", (_a2 = window.themeVariables) == null ? void 0 : _a2.product);
      console.log("Purchase Limit Manager:", window.purchaseLimitManager);
      if (window.productData) {
        console.log("Purchase limit for current product:", (_c = (_b2 = window.productData.metafields) == null ? void 0 : _b2.custom) == null ? void 0 : _c.limit_purchase);
      }
      fetch("/cart.js").then((response) => response.json()).then((cart) => {
        console.log("Current cart:", cart);
        console.log("Cart items:", cart.items);
      }).catch((error) => console.error("Error fetching cart:", error));
    };
  }
});
export default require_main();
